// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://assets.foursightonline.com/app/fonts/webfonts/webfonts.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://assets.foursightonline.com/app/fonts/webfonts/webfonts.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.fn-profile .section-title {
  width: min(620px, 100%);
  margin-inline: auto;
}
.fn-profile .section-title__linkcontainer {
  flex-direction: column;
}
.fn-profile__blocks {
  --dotsGap: 10px;
}
.fn-profile__blocks .f-flex {
  align-items: center;
}
.fn-profile__blocks .f-flex:nth-child(1) .fn-profile__pic figure::before {
  display: none;
}
.fn-profile__blocks .f-flex:nth-child(even) {
  flex-direction: row-reverse;
}
.fn-profile__blocks .f-flex:nth-child(even) .fn-profile__pic figure::after {
  left: auto;
  right: calc(100% + var(--dotsGap));
}
.fn-profile__blocks .f-flex + div {
  margin-top: 100px;
}
@media only screen and (max-width: 767px) {
  .fn-profile__blocks .f-flex + div {
    margin-top: calc(60px / 2);
  }
}
@media only screen and (min-width: 768px) {
  .fn-profile__blocks .f-flex > div:first-child {
    width: 45%;
  }
}
@media only screen and (min-width: 768px) {
  .fn-profile__blocks .f-flex > div:last-child {
    width: 55%;
  }
}
.fn-profile__blocks .fn-col {
  position: relative;
}
.fn-profile__blocks .fn-col:nth-child(1) {
  width: 45%;
}
@media only screen and (max-width: 767px) {
  .fn-profile__blocks .fn-col:nth-child(1) {
    width: 100%;
  }
  .fn-profile__blocks .fn-col:nth-child(1):not(:last-child) {
    margin-bottom: 20px;
  }
}
.fn-profile__blocks .fn-col:nth-child(2) {
  width: 55%;
}
@media only screen and (max-width: 767px) {
  .fn-profile__blocks .fn-col:nth-child(2) {
    width: 100%;
  }
}
.fn-profile__pic {
  max-width: 284px;
  width: 100%;
  margin-inline: auto;
}
@media only screen and (max-width: 767px) {
  .fn-profile__pic {
    width: 200px;
  }
}
.fn-profile__pic figure {
  position: relative;
  padding-bottom: 100%;
}
.fn-profile__pic figure::before {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: calc(100% + var(--dotsGap));
  width: 8px;
  height: 60px;
  background-image: url(https://assets.foursightonline.com/admin-uploads/docs/226/original.png);
}
@media only screen and (max-width: 991px) {
  .fn-profile__pic figure::before {
    display: none;
  }
}
.fn-profile__pic figure::after {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: calc(100% + var(--dotsGap));
  width: 62px;
  height: 8px;
  background-image: url(https://assets.foursightonline.com/admin-uploads/docs/219/original.png);
}
@media only screen and (max-width: 991px) {
  .fn-profile__pic figure::after {
    display: none;
  }
}
.fn-profile__pic figure img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 100%;
}
.fn-profile__pic h5 {
  font-size: calc(16px - 2px);
  margin-top: 20px;
  text-align: center;
  max-width: 170px;
  margin-inline: auto;
}
.fn-profile__content {
  max-width: 88%;
  margin-inline: auto;
}
.fn-profile__content p {
  line-height: 1.8;
}

.fn-framework__top {
  background-color: #6d6e71;
  padding: 30px;
}
@media only screen and (max-width: 991px) {
  .fn-framework__top {
    padding: 30px;
  }
}
.fn-framework__top h2 {
  color: #fff;
}
@media only screen and (max-width: 767px) {
  .fn-framework__top h2 {
    margin-bottom: var(--hGap);
  }
}
.fn-framework__top h3 {
  color: #fff;
  font-weight: normal;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  line-height: 1.4;
}
.fn-framework__top p {
  color: #fff;
}
.fn-framework__bottom {
  max-width: 800px;
  margin-inline: auto;
  margin-top: 30px;
}
@media only screen and (max-width: 767px) {
  .fn-framework__bottom {
    margin-top: 30px;
  }
}
.fn-framework__bottom p {
  color: #6a6a6a;
}
.fn-framework__bottom img {
  width: 334px;
  margin-inline: auto;
  display: block;
}
@media only screen and (max-width: 767px) {
  .fn-framework__bottom .fn-row {
    flex-direction: column-reverse;
  }
}

.fn-preferences__sign {
  margin-bottom: 30px;
}
.fn-preferences__sign img {
  width: 130px;
}
.fn-preferences__icon {
  position: absolute;
  top: calc(60px - 20px);
  right: calc(60px - 20px);
  max-width: 220px;
  max-height: 180px;
  z-index: -1;
}
@media only screen and (max-width: 767px) {
  .fn-preferences__icon {
    max-width: 150px;
    top: 20px;
    right: 20px;
  }
}
.fn-preferences__blocks > .f-flex {
  margin-inline: 0;
}
@media only screen and (max-width: 767px) {
  .fn-preferences__blocks > .f-flex + div {
    margin-top: 30px;
  }
}
.fn-preferences__blocks > .f-flex:nth-child(even) {
  flex-direction: row-reverse;
}
.fn-preferences__blocks > .f-flex > [class*=f-col-] {
  position: relative;
  padding: calc(60px - 20px);
}
@media only screen and (max-width: 767px) {
  .fn-preferences__blocks > .f-flex > [class*=f-col-] {
    padding: 20px;
  }
}
.fn-preferences__blocks > .f-flex > [class*=f-col-]:nth-child(1) {
  background-color: var(--clrProfile);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: column;
  z-index: 0;
}
@media only screen and (max-width: 767px) {
  .fn-preferences__blocks > .f-flex > [class*=f-col-]:nth-child(1) {
    border-top-right-radius: 50px;
  }
}
.fn-preferences__blocks > .f-flex > [class*=f-col-]:nth-child(1) > *:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
@media only screen and (max-width: 767px) {
  .fn-preferences__blocks > .f-flex > [class*=f-col-]:nth-child(1) > *:not(:last-child) {
    margin-bottom: var(--hGap);
  }
}
@media only screen and (max-width: 767px) {
  .fn-preferences__blocks > .f-flex > [class*=f-col-]:nth-child(2) {
    background-color: #f2f2f2;
  }
}
@media only screen and (max-width: 767px) {
  .fn-preferences__blocks > .f-flex > [class*=f-col-] [class*=f-col-] {
    width: 100%;
  }
  .fn-preferences__blocks > .f-flex > [class*=f-col-] [class*=f-col-]:not(:last-child) {
    margin-bottom: 30px;
  }
}
.fn-preferences__blocks h2 {
  color: #fff;
}
.fn-preferences__blocks h3 {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 24px;
  color: #fff;
  line-height: 1.3;
  font-weight: normal;
}
@media only screen and (max-width: 767px) {
  .fn-preferences__blocks h3 {
    font-size: 20px;
  }
}
.fn-preferences__blocks ul + .f-flex {
  margin-block-start: 30px;
}
@media only screen and (max-width: 991px) {
  .fn-preferences__blocks ul + .f-flex > [class*=f-col-] {
    width: 100%;
  }
  .fn-preferences__blocks ul + .f-flex > [class*=f-col-]:not(:last-child) {
    margin-bottom: var(--gap-2);
  }
}
.fn-preferences__blocks ul + .f-flex + * {
  margin-block-start: 30px;
}
.fn-preferences__blocks li::before {
  background-color: #6d6e71;
}
.fn-preferences__blocks h5 {
  color: var(--clrProfile);
  margin-bottom: calc(var(--hGap) / 2);
}
.fn-preferences__blocks h5 + ul li {
  font-size: 16px;
}
.fn-preferences__blocks p {
  font-size: 16px;
}

.fn-communicate__items {
  padding-block: 30px;
}
.fn-communicate__items:first-child {
  padding-top: 0;
}
@media only screen and (max-width: 767px) {
  .fn-communicate__items-heading {
    display: none;
  }
  .fn-communicate__items-heading + div {
    padding-top: 0;
  }
}
.fn-communicate__items:not(:last-child) {
  border-bottom: 1px solid #eee;
}
.fn-communicate__items .fn-communicate__title {
  text-align: center;
  color: #fff;
  background-color: var(--clrProfile);
  padding-block: 30px;
  padding-inline: 20px;
}
@media only screen and (max-width: 767px) {
  .fn-communicate__items .fn-communicate__title {
    padding-block: 12px;
    padding-inline: 15px;
    width: -moz-fit-content;
    width: fit-content;
  }
}
@media only screen and (max-width: 767px) {
  .fn-communicate p::before {
    content: attr(data-title) " : ";
    font-weight: 600;
    margin-right: 3px;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .fn-collaborate .f-col-3 {
    width: 50%;
  }
}
.fn-collaborate__cell {
  background-color: #fff;
  height: 100%;
  padding: 20px;
}
.fn-collaborate__cell h3 {
  color: var(--clrProfile);
  word-break: break-word;
}
.fn-collaborate__cell .custom-list li {
  font-size: 16px;
}

.fn-manage__graph:not(:last-child) {
  margin-bottom: 30px;
}
.fn-manage__graph img {
  max-width: none;
  width: 100%;
}
@media only screen and (max-width: 991px) {
  .fn-manage .fn-col {
    width: 50%;
  }
}
.fn-manage__cell {
  text-align: center;
  max-width: 200px;
  margin-inline: auto;
}
.fn-manage__cell img {
  max-width: 32px;
  max-height: 61px;
  margin-bottom: 20px;
}
.fn-manage__cell h3 {
  width: min-content;
  margin-inline: auto;
}

.fn-tips {
  counter-reset: tips-count;
}
@media only screen and (max-width: 767px) {
  .fn-tips .fn-col {
    width: 100%;
  }
}
.fn-tips__cell {
  height: 100%;
  position: relative;
  padding-left: 60px;
}
.fn-tips__cell::before {
  counter-increment: tips-count;
  content: counter(tips-count) ".";
  color: #6d6e71;
  font-size: 44px;
  font-family: "Museo-700";
  position: absolute;
  top: -5px;
  left: 0;
}
.fn-tips__bottom {
  width: min(1000px, 100%);
  margin-inline: auto;
}
.fn-tips__bottom p a {
  font-size: 20px;
}
.fn-tips__bottom > *:not(:last-child) {
  margin-bottom: 30px;
}
.fn-tips__bottom .btn {
  padding: 10px 25px;
  font-size: 1.2em;
}

.modal-header {
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;
}

.pa_assessment {
  line-height: 2em;
  padding: 0.75rem 0.75rem 0.75rem 0 !important;
}

.clearfix {
  clear: both;
}

.package-form select {
  border: 1px solid #ddd;
  padding: 10px !important;
  height: 40px;
  background: #F8F8F8;
  color: #636363;
  font-family: "Museo-300";
  margin-bottom: 10px;
  width: 55%;
}
.package-form .assessment-select select {
  height: 30px;
  padding: 5px !important;
  width: 45%;
  background-color: #fff;
}
.package-form label {
  width: 55%;
  line-height: 2em;
  padding: 0.75rem 0.75rem 0.75rem 0;
  margin-bottom: 5px;
}
.package-form .btn {
  margin-top: 10px;
}
.package-form .btn-sm {
  padding: 5px 10px;
}
.package-form .guide-rdbtn {
  padding-bottom: 25px;
}
.package-form .guide-rdbtn label {
  padding: 0 !important;
  width: 65%;
}
.package-form .guide-rdbtn--disable {
  pointer-events: none;
  opacity: 0.5;
}
.package-form .modal-body__buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  border-top: 1px solid #ddd;
  width: calc(100% + 32px);
  margin: 0 -16px;
  padding: 5px 10px;
  background-color: #f6f6f6;
}
.package-form .modal-body__buttons .btn {
  margin-top: 0;
}
.package-form .modal-body__buttons .btn-prim {
  margin-inline-start: 10px;
}
.package-form .modal-body__buttons .btn-disable {
  cursor: not-allowed;
  pointer-events: none;
}

.modal-title {
  float: left;
}
.modal-title--fs {
  font-size: 16px;
}

.modal-body {
  padding: 20px 30px 0;
}

.modal-pf .col-sm-5 {
  padding: 0 15px;
}
.modal-pf .right-button p {
  margin-bottom: 10px;
}
.modal-pf .right-button.text-right {
  width: 100%;
  text-align: center;
  margin: 3px 0 8px;
}
.modal-pf .right-button.text-right a {
  padding: 5px 10px;
  width: 100%;
}

.fn__guidbtn {
  position: relative;
  padding-bottom: 20px;
  max-width: 820px;
  width: 100%;
}
.fn__guidbtn a {
  position: absolute;
  right: -10px;
  top: 0;
  width: 100%;
  max-width: 245px;
  cursor: pointer;
  border-radius: 4px;
}
@media only screen and (max-width: 991px) {
  .fn__guidbtn a {
    right: 0;
  }
}

.guide-modal {
  display: none;
}

/****************
    14-December 
****************/
.fn-profile__pic figure {
  margin: 0;
}

/* style-for-Profile-chart */
img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

@font-face {
  font-family: "Conv_museo-500-webfont";
  src: url("https://assets.foursightonline.com/app/fonts/museo-500-webfont.eot");
  src: local("☺"), url("https://assets.foursightonline.com/app/fonts/museo-500-webfont.woff") format("woff"), url("https://assets.foursightonline.com/app/fonts/museo-500-webfont.ttf") format("truetype"), url("https://assets.foursightonline.com/app/fonts/museo-500-webfont.svg") format("svg");
  font-weight: normal;
  font-style: normal;
}
/*========== mixin for animation ====================*/
.chart-section {
  width: 90%;
  margin: 5% auto 0 auto;
  padding-bottom: 20px;
  /*------background colors used in chart---------*/
  /*------chart area wrapper---------*/
  /*------main chart wrapper---------*/
  /*------y dividers css---------*/
  /*------x dividers css---------*/
  /*------chart labels css---------*/
  /*------preferences css---------*/
  /*------neutral bar css---------*/
  /*------chart titles css---------*/
  /*------chart pointers css---------*/
  /*------chart pointers css end---------*/
  /*------connector css start---------*/
  /*------connector css end---------*/
}
.chart-section .chart-main {
  width: 100%;
  height: 250px;
  display: table;
  border-collapse: collapse;
  margin: 0 auto;
  float: none;
  position: relative;
}
.chart-section .y-dividers {
  display: table;
  border-collapse: collapse;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .chart-section .y-dividers {
    position: absolute;
  }
}
.chart-section .dividers-yxis {
  border-right: 1px solid #eee;
  border-collapse: collapse;
  display: table-cell;
  width: 20%;
  table-layout: fixed;
  position: relative;
}
.chart-section .dividers-yxis:first-child {
  border-left: 1px solid #eee;
}
.chart-section .x-dividers {
  display: block;
  border-collapse: collapse;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.owl-carousel .chart-section .x-dividers {
  backface-visibility: hidden;
}
.chart-section .dividers-xxis {
  border-collapse: collapse;
  width: 100%;
  height: 20%;
  border-bottom: 1px solid #eee;
  position: relative;
}
.chart-section .dividers-xxis:first-child {
  border-top: 1px solid #eee;
}
.chart-section .side-label {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.4) !important;
  position: absolute;
  left: -25px;
  top: -8px;
  text-align: right;
  width: 20px;
}
.chart-section .label-0 {
  position: absolute;
  top: inherit;
  bottom: -8px;
}
.chart-section .preference {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  padding: 0 30px;
  font-size: 16px;
  font-weight: 500;
}
.chart-section .high_prefer {
  position: absolute;
  top: 20px;
  color: rgba(0, 0, 0, 0.4) !important;
  left: 30px;
}
.chart-section .low_prefer {
  position: absolute;
  bottom: 20px;
  color: rgba(0, 0, 0, 0.4) !important;
  left: 30px;
}
.chart-section .neutral {
  display: block;
  margin-left: -30px;
  margin-right: -30px;
  background: #e3e3e3 !important;
  position: absolute;
  padding-left: 30px;
  padding-top: 5px;
  padding-bottom: 5px;
  z-index: 1;
  width: 100%;
  height: 30px;
  text-align: left;
}
.chart-section .neutral span {
  position: absolute;
  left: 0;
  font-size: 12px;
}
.chart-section .neutral_high_value {
  top: -15px;
}
.chart-section .neutral_low_value {
  bottom: -15px;
}
.chart-section .chart-title {
  text-transform: uppercase;
  font-size: 16px;
  color: #fff !important;
  display: inline-block;
  padding: 5px 0px;
  width: 110px;
  text-align: center;
  position: absolute;
  bottom: -31px;
  right: -55px;
  cursor: pointer;
  z-index: 99;
}
html.mac.safari .chart-section .chart-title {
  bottom: -45px;
}
.chart-section .chart-title.blue-bg:before,
.chart-section .chart-title.orange-bg:before,
.chart-section .chart-title.green-bg:before,
.chart-section .chart-title.purple-bg:before {
  content: "";
  position: absolute;
  top: -10px;
  left: 0;
  width: 0;
  height: 0;
  border-style: solid;
  line-height: 0px;
  border-width: 0 55px 10px 55px;
  _filter: progid:DXImageTransform.Microsoft.Chroma(color="#000000");
}
.chart-section .chart_pointers {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
}
.chart-section .pointer {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  position: absolute;
  left: 0;
  bottom: 0;
  color: #fff !important;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  line-height: 35px;
  transform: translateY(-50%);
  margin-bottom: -35px;
  font-weight: 600;
  font-family: "Helvetica LT W05 Bold" !important;
}
.chart-section .pointer.clarify_pointer {
  left: -ms-calc(20% - 17px);
  left: calc(20% - 17px);
}
.chart-section .pointer.ideate_pointer {
  left: -ms-calc(40% - 17px);
  left: -o-calc(40% - 17px);
  left: calc(40% - 17px);
}
.chart-section .pointer.develop_pointer {
  left: -ms-calc(60% - 17px);
  left: -o-calc(60% - 17px);
  left: calc(60% - 17px);
}
.chart-section .pointer.implement_pointer {
  left: -ms-calc(80% - 17px);
  left: -o-calc(80% - 17px);
  left: calc(80% - 17px);
}
.chart-section .connectors {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.chart-section .connector_block {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 20%;
  z-index: 4;
}
.chart-section .block1 {
  margin-left: 20%;
}
.chart-section .block2 {
  margin-left: 60%;
}
.chart-section .block3 {
  margin-left: 40%;
}
.chart-section .connector_line {
  position: absolute;
  width: 8px;
  margin-top: -15px;
  background-color: #656668 !important;
}
.chart-section .connector_point {
  position: absolute;
  transform: translateY(-50%);
  width: 35px;
  height: 35px;
  margin-bottom: -35px;
}
.chart-section #connector_clarify_pointer,
.chart-section #connector_develop_pointer,
.chart-section #mid_connector_1 {
  left: -17px;
}
.chart-section #connector_ideate_pointer,
.chart-section #connector_implement_pointer,
.chart-section #mid_connector_2 {
  right: -17px;
}
.chart-section .hidden-xs {
  display: block;
}
.chart-section .visible-xs {
  display: none;
}
.chart-section .chart-title.sm .visible-xs {
  display: block !important;
}
.chart-section .chart-title.sm .hidden-xs {
  display: none !important;
}
.chart-section .chart-title.sm {
  width: 52px;
  padding-left: 10px;
  padding-right: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  right: -25px;
  text-transform: capitalize;
  font-size: 14px;
}
.chart-section .chart-title.blue-bg.sm:before,
.chart-section .chart-title.orange-bg.sm:before,
.chart-section .chart-title.green-bg.sm:before,
.chart-section .chart-title.purple-bg.sm:before {
  border-width: 0 26px 10px 26px;
}
@media only screen and (max-width: 689px) {
  .chart-section #chartarea {
    min-width: 320px;
    padding-left: 15px;
  }
  .chart-section .chart-title {
    width: 52px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    right: -25px;
  }
  .chart-section .chart-title.blue-bg:before,
  .chart-section .chart-title.orange-bg:before,
  .chart-section .chart-title.green-bg:before,
  .chart-section .chart-title.purple-bg:before {
    border-width: 0 26px 10px 26px;
  }
  .chart-section .chart-main {
    height: 300px;
    font-size: 14px;
  }
  .chart-section .chart-title,
  .chart-section .side-label,
  .chart-section .pointer {
    font-size: 14px;
  }
  .chart-section .connector_line {
    width: 5px;
  }
  .chart-section .hidden-xs {
    display: none;
  }
  .chart-section .visible-xs {
    display: block;
  }
}
@media only screen and (max-width: 767px) {
  .chart-section .chart-main {
    height: 280px;
  }
  ::ng-deep .result .chart-section .chart-main {
    height: 130px;
    margin-bottom: 30px;
  }
  .chart-section .chart-main .preference {
    font-size: 12px;
  }
  .chart-section .chart-main .high_prefer {
    top: 5px;
  }
  .chart-section .chart-main .low_prefer {
    bottom: 5px;
  }
  .chart-section .chart-title {
    width: 52px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    right: -25px;
  }
  body.mini-navbar .chart-section .chart-title {
    width: 40px !important;
    right: -21px !important;
  }
  .chart-section .chart-title.blue-bg:before,
  .chart-section .chart-title.orange-bg:before,
  .chart-section .chart-title.green-bg:before,
  .chart-section .chart-title.purple-bg:before {
    border-width: 0 26px 10px 26px;
  }
  body.mini-navbar .chart-section .chart-title.blue-bg:before,
  body.mini-navbar .chart-section .chart-title.orange-bg:before,
  body.mini-navbar .chart-section .chart-title.green-bg:before,
  body.mini-navbar .chart-section .chart-title.purple-bg:before {
    border-width: 0 20px 10px 20px !important;
  }
  .chart-section .preference {
    font-size: 14px;
  }
  .chart-section .pointer {
    transform: translateY(-50%) scale(0.8);
  }
}
@media only screen and (max-width: 390px) {
  .chart-section #chartarea {
    min-width: 250px;
  }
  .chart-section .chart-title {
    width: 40px;
  }
  .chart-section .chart-title.blue-bg:before,
  .chart-section .chart-title.orange-bg:before,
  .chart-section .chart-title.green-bg:before,
  .chart-section .chart-title.purple-bg:before {
    border-width: 0 20px 10px 20px;
  }
}
@media only screen and (max-height: 600px) {
  .chart-section .chart-main {
    height: 250px;
    font-size: 14px;
  }
  .chart-section .chart-title,
  .chart-section .side-label,
  .chart-section .pointer {
    font-size: 14px;
  }
  .chart-section .chart-title.blue-bg:before,
  .chart-section .chart-title.orange-bg:before,
  .chart-section .chart-title.green-bg:before,
  .chart-section .chart-title.purple-bg:before {
    top: -10px;
  }
  .chart-section .connector_line {
    width: 5px;
  }
}

.print-info {
  display: block;
  font-size: 10px;
  margin-top: 5px;
  color: #676a6c;
  margin-bottom: 5px;
}
.print-info a {
  font-size: inherit !important;
}

#print-button {
  margin-bottom: -8px;
}
@media only screen and (max-width: 767px) {
  #print-button {
    margin: 0;
    width: 100%;
  }
  #print-button select,
  #print-button .btn {
    width: 100%;
  }
}

@media only screen and (max-height: 414px) and (orientation: landscape) {
  .chart-title.sm {
    width: 42px !important;
    right: -21px !important;
    font-size: 12px !important;
  }
  .chart-title.blue-bg.sm:before,
  .chart-title.orange-bg.sm:before,
  .chart-title.green-bg.sm:before,
  .chart-title.purple-bg.sm:before {
    border-width: 0 21px 10px 21px !important;
  }
}
.chart-container,
.below-chart {
  padding: 25px;
  max-width: 820px;
  width: 100%;
}

#print-button a {
  display: block;
  font-size: 12px;
  line-height: 1;
  margin-bottom: 7px;
  text-align: right;
}

.interpretive-wrapper {
  max-width: 820px;
  width: 100%;
  font-family: "Museo-regular";
  margin-block-start: -60px;
}

.interpretive-wrapper .toolsguide {
  background: #fff;
}

section#four-profile {
  padding: 0;
}

.toolsguide {
  padding: 40px 40px 30px;
}

#four-profile .toolsguide-heading,
#four-profile .toolsguide-content {
  padding: 15px 30px;
}

.toolsguide .toolsguide-heading .toolsguide-heading-text {
  font-size: 40px;
  font-weight: 600;
}

#four-profile .toolsguide-heading,
#four-profile .toolsguide-content {
  padding: 15px 30px;
}

#four-think .box {
  margin: 15px 1%;
  min-height: 265px;
}

.toolsguide .box.clarify {
  border: 1px solid rgb(0, 173, 208) !important;
  box-shadow: 0 0 1px 0 rgb(0, 173, 208) !important;
}

#four-think .box h2 {
  border-bottom: 1px solid;
  box-shadow: 0 1px 1px -1px;
  padding-bottom: 5px;
}

.toolsguide .box.clarify h2,
.toolsguide .box.clarify h4 {
  color: rgb(0, 173, 208) !important;
}

.toolsguide .box h2 {
  font-size: 30px;
}

.toolsguide .toolsguide-content ul {
  padding: 0;
  list-style-position: inherit;
  list-style-type: none;
  font-family: "Museo-300";
}

.toolsguide .box ul {
  margin: 0;
  padding: 0;
  list-style-position: inside;
}

.toolsguide .box ul li {
  font-family: "Museo-300";
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 5px;
}

.toolsguide .toolsguide-content ul li {
  font-family: "Museo-300";
}

.toolsguide .toolsguide-content ul li:before {
  content: "•";
  margin-right: 5px;
}

.toolsguide .box.ideate {
  border: 1px solid rgb(255, 121, 0) !important;
  box-shadow: 0 0 1px 0 rgb(255, 121, 0) !important;
}

.toolsguide .box.ideate h2,
.toolsguide .box.ideate h4 {
  color: rgb(255, 121, 0) !important;
}

.toolsguide .box.develop {
  border: 1px solid rgb(105, 190, 40) !important;
  box-shadow: 0 0 1px 0 rgb(105, 190, 40) !important;
}

.toolsguide .box.develop h2,
.toolsguide .box.develop h4 {
  color: rgb(105, 190, 40) !important;
}

.toolsguide .box.implement {
  border: 1px solid rgb(245, 67, 89) !important;
  box-shadow: 0 0 1px 0 rgb(245, 67, 89) !important;
}

.toolsguide .box.implement h2,
.toolsguide .box.implement h4 {
  color: rgb(245, 67, 89) !important;
}

.toolsguide .toolsguide-heading .toolsguide-heading-text {
  font-size: 40px;
  font-weight: 600;
}

#four-box .box {
  margin: 15px 1%;
  min-height: 600px;
}

.toolsguide .box.clarify {
  border: 1px solid rgb(0, 173, 208) !important;
  box-shadow: 0 0 1px 0 rgb(0, 173, 208) !important;
}

.toolsguide .box .box-top {
  padding: 15px;
  margin: 0 -15px;
}

.toolsguide .box.clarify .box-top {
  background: rgb(0, 173, 208) !important;
}

.toolsguide .toolsguide-content h4 {
  font-size: 16px;
}

.toolsguide .box.ideate .box-top {
  background: rgb(255, 121, 0) !important;
}

.toolsguide .box.develop .box-top {
  background: rgb(105, 190, 40) !important;
}

.toolsguide .box h2 img {
  margin-left: 20px;
}

.toolsguide .box.implement .box-top {
  background: rgb(245, 67, 89) !important;
}

.toolsguide .toolsguide-content span.num {
  font-size: 28px;
  line-height: 20px;
  margin-top: 6px;
  display: block;
  width: 20px;
  float: left;
}

.toolsguide .toolsguide-content .num-p p {
  float: right;
  width: calc(100% - 30px);
  font-size: 14px;
}

.toolsguide .toolsguide-content h3 {
  font-size: 20px;
}

.pref {
  margin-top: 15px;
}

.toolsguide .toolsguide-content h4 {
  font-size: 16px;
}

.pref span {
  padding: 2px 4px;
  color: #fff !important;
  font-size: 14px;
}

.pref.clarify span {
  background: rgb(0, 173, 208) !important;
}

.pref.clarify ul li {
  color: rgb(0, 173, 208) !important;
}

.pref.ideate span {
  background: rgb(255, 121, 0) !important;
}

.pref.ideate ul li {
  color: rgb(255, 121, 0) !important;
}

.pref.developer span {
  background: rgb(105, 190, 40) !important;
}

.pref.developer ul li {
  color: rgb(105, 190, 40) !important;
}

.pref.implement span {
  background: rgb(245, 67, 89) !important;
}

.pref.implement ul li {
  color: rgb(245, 67, 89) !important;
}

.toolsguide .footer-xs {
  background-color: #e6e7e8;
  font-size: 12px !important;
  padding: 10px 40px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
}

.fs-graph-logo {
  max-width: 300px;
  width: 100%;
}

.below-chart .left-label {
  background-color: #6d6e71 !important;
  float: left;
  font-size: 25px !important;
  line-height: 30px;
  letter-spacing: 0.8px;
  padding: 5px 11px 5px 11px !important;
  text-transform: none;
  font-family: "Helvetica LT W05 Bold";
  margin-bottom: 0 !important;
}

.below-chart .right-label {
  float: right;
  margin-bottom: 0 !important;
}
.below-chart .right-label .eq-developer {
  margin-bottom: 0 !important;
}

.right-label-text span.eq-clarifier {
  background-color: rgb(0, 173, 208) !important;
  display: none;
}

.right-label-text span .icon-plus {
  width: 32px;
  font-size: 14px;
  display: inline-block;
  text-align: center;
  color: #929394;
  display: inline-block;
  font: 14px/1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
@media (max-width: 992px) {
  .right-label-text span .icon-plus {
    width: 25px;
  }
}

.right-label-text .icon-plus:before {
  content: "\\f067";
}

.right-label-text .eq-developer {
  background-color: rgb(105, 190, 40) !important;
}

.below-chart span {
  color: #fff !important;
  padding: 10px;
}

.right-label-text .eq-ideator {
  background-color: rgb(255, 121, 0) !important;
}

.right-label-text .eq-implementer {
  background-color: rgb(245, 67, 89) !important;
}

@media (min-width: 768px) {
  #four-think .box {
    width: 48%;
  }
  #four-box .box {
    width: 48%;
  }
}
/*================= css copied from charts.scss ================*/
.comparison-chart-1 {
  border-left: 1px solid #c0c0c0;
  border-bottom: 1px solid #c0c0c0;
  height: 200px;
  position: relative;
  margin-top: 50px;
}
.comparison-chart-1 ul {
  padding: 0;
  margin: 0;
  display: flex;
}
.comparison-chart-1 ul li {
  list-style: none;
  width: 20%;
  margin: 0 2.5%;
  flex: 1;
  position: absolute;
  bottom: 0px;
}
.comparison-chart-1 ul li span {
  width: 50%;
  display: block;
  border: 0.5px solid #fff;
  float: left;
  position: absolute;
  bottom: 0;
}
.comparison-chart-1 ul li span .competitor-name {
  color: #fff;
  font-size: 11px;
  position: absolute;
  bottom: 0px;
  margin: 0px;
  left: 2px;
}
.comparison-chart-1 ul li span .competitor-score {
  text-align: center;
  margin-top: -20px;
}
.comparison-chart-1 ul li span:last-child {
  margin-left: 50%;
  opacity: 0.7;
}
.comparison-chart-1 ul .clarify-comparison span {
  background-color: rgb(0, 173, 208) !important;
}
.comparison-chart-1 ul.remove-color .clarify-comparison span {
  background-color: rgb(0, 173, 208) !important;
}
.comparison-chart-1 ul.remove-color .clarify-comparison span:last-child {
  background-color: #ccc !important;
}
.comparison-chart-1 ul .ideate-comparison {
  margin-left: 25%;
}
.comparison-chart-1 ul .ideate-comparison span {
  background-color: rgb(255, 121, 0) !important;
}
.comparison-chart-1 ul.remove-color .ideate-comparison span {
  background-color: rgb(0, 173, 208) !important;
}
.comparison-chart-1 ul.remove-color .ideate-comparison span:last-child {
  background-color: #ccc !important;
}
.comparison-chart-1 ul .develop-comparison {
  margin-left: 50%;
}
.comparison-chart-1 ul .develop-comparison span {
  background-color: rgb(105, 190, 40) !important;
}
.comparison-chart-1 ul.remove-color .develop-comparison span {
  background-color: rgb(0, 173, 208) !important;
}
.comparison-chart-1 ul.remove-color .develop-comparison span:last-child {
  background-color: #ccc !important;
}
.comparison-chart-1 ul .implement-comparison {
  margin-left: 75%;
}
.comparison-chart-1 ul .implement-comparison span {
  background-color: rgb(245, 67, 89) !important;
}
.comparison-chart-1 ul.remove-color .implement-comparison span {
  background-color: rgb(0, 173, 208) !important;
}
.comparison-chart-1 ul.remove-color .implement-comparison span:last-child {
  background-color: #ccc !important;
}

.client-detail .list-unstyled {
  width: 100%;
  float: left;
  margin-bottom: 35px;
}
@media screen and (max-width: 599px) {
  .client-detail .list-unstyled li {
    width: 100%;
  }
}
.client-detail .list-unstyled li h2 {
  font-size: 20px;
  font-weight: bold;
}
.client-detail .list-unstyled li span {
  font-size: 18px;
}
.client-detail .profile-headers {
  clear: both;
  float: left;
  width: 100%;
  margin: 30px 0;
  font-size: 18px;
  font-family: "Conv_museo-500-webfont";
}
@media (max-width: 767px) {
  .client-detail .profile-headers {
    font-size: 13px;
  }
}
.client-detail .profile-headers .profile-equation-wrapper {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
@media (max-width: 950px) {
  .client-detail .profile-headers .profile-equation-wrapper {
    float: left !important;
    clear: both;
    margin-top: 10px;
  }
}
@media (max-width: 767px) {
  .client-detail .profile-headers .profile-equation-wrapper {
    float: right !important;
    clear: none;
  }
}
@media (max-width: 599px) {
  .client-detail .profile-headers .profile-equation-wrapper {
    float: left !important;
    clear: both;
  }
}
.client-detail .profile-headers .profile-equation-wrapper span {
  color: #fff;
  padding: 7px;
}
@media (max-width: 950px) {
  .client-detail .profile-headers .profile-equation-wrapper span {
    float: left;
    margin-bottom: 10px;
  }
}
@media (max-width: 375px) {
  .client-detail .profile-headers .profile-equation-wrapper span {
    display: block;
  }
}
.client-detail .profile-headers .profile-equation-wrapper .eq-plus {
  color: #6d6e71;
}
.client-detail .profile-headers .profile-equation-result {
  background: #6d6e71;
  padding: 7px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.client-detail .profile-headers .profile-equation-result a {
  color: #fff;
  text-decoration: none;
}
.client-detail .client_description {
  clear: both;
  text-align: justify;
  font-size: 16px;
  margin-bottom: 30px;
  -ms-column-count: 2;
  column-count: 2;
  -ms-column-gap: 20;
  column-gap: 20;
}
@media screen and (max-width: 599px) {
  .client-detail .client_description {
    -ms-column-count: 1;
    column-count: 1;
    -ms-column-gap: 0;
    column-gap: 0;
  }
}
.client-detail .client_description span.pull-left {
  padding-right: 10px;
  padding-bottom: 10px;
}
.client-detail .client_description span.profile-desc {
  font-weight: bold;
}

.group-profile.teammates-group {
  height: 230px;
  border: none;
  max-width: 90%;
  margin: 0 auto;
}
.group-profile.teammates-group .main-group-profile {
  height: 230px;
}
.group-profile.teammates-group .main-group-profile .common-profile {
  max-height: 50px;
}
.group-profile.teammates-group .main-group-profile .integrators-region {
  height: 30px;
  margin-top: -15px;
}
.group-profile.teammates-group .main-group-profile .integrators-region h4 {
  line-height: 30px;
}
.group-profile.teammates-group .main-group-profile .profile-flex-bottom {
  margin-top: 15px;
}
.group-profile.teammates-group .main-group-profile .profile-flex-bottom .common-low h5 {
  margin: 0px;
  margin-top: 5px;
}
.group-profile.teammates-group .main-group-profile .profile-flex-top .common-high .top-label-scores {
  margin: 0;
  margin-bottom: 5px;
}

.comparison-chart-2 {
  border-left: 1px solid #c0c0c0;
  border-bottom: 1px solid #c0c0c0;
  height: 200px;
  position: relative;
}
.comparison-chart-2 .diff-score {
  position: absolute;
  color: #333;
  top: -20px;
}
.comparison-chart-2 .other-User .diff-score {
  right: -3px;
}
.comparison-chart-2 .current-User .diff-score {
  left: -3px;
}
.comparison-chart-2 .score_calculator {
  position: absolute;
  top: 0;
  left: -20px;
  bottom: 0;
  width: 20px;
}
.comparison-chart-2 .score_calculator .start,
.comparison-chart-2 .score_calculator .end {
  position: absolute;
}
.comparison-chart-2 .score_calculator .start {
  bottom: -5px;
  left: 7px;
}
.comparison-chart-2 .score_calculator .end {
  top: -5px;
}
.comparison-chart-2 ul {
  padding: 0;
  margin: 0 0 0 4.5%;
  display: flex;
  opacity: 0;
  animation-fill-mode: forwards;
  animation-name: chartOpacity;
  animation-duration: 3s;
  animation-timing-function: ease;
  animation-delay: 2000ms;
}
.comparison-chart-2 ul li {
  list-style: none;
  width: 20%;
  margin: 0;
  flex: 1;
  position: absolute;
  bottom: 0px;
}
.comparison-chart-2 ul li span {
  width: 50%;
  display: block;
  border: 0.5px solid #000;
  float: left;
  position: absolute;
  bottom: 0;
  z-index: 1;
  -ms-box-shadow: 2px 1px 5px rgba(0, 0, 0, 0.35);
  -o-box-shadow: 2px 1px 5px rgba(0, 0, 0, 0.35);
  box-shadow: 2px 1px 5px rgba(0, 0, 0, 0.35);
}
.comparison-chart-2 ul li span .competitor-name {
  color: #fff;
  font-size: 11px;
  position: absolute;
  bottom: 0px;
  margin: 0px;
  left: 2px;
}
.comparison-chart-2 ul li span .competitor-score {
  text-align: left;
  margin-top: 2px;
  color: #fff;
  margin-left: 3px;
  margin-right: 3px;
}
.comparison-chart-2 ul li span:last-child {
  opacity: 0.7;
  z-index: 0;
  left: 30%;
  -ms-box-shadow: none;
  -o-box-shadow: none;
  box-shadow: none;
}
.comparison-chart-2 ul li span:last-child .competitor-name {
  right: 5px;
  left: inherit;
  text-align: right;
}
.comparison-chart-2 ul li span:last-child .competitor-score {
  text-align: right;
}
.comparison-chart-2 ul .clarify-comparison span {
  background-color: rgb(0, 173, 208) !important;
}
.comparison-chart-2 ul .ideate-comparison {
  margin-left: 25%;
}
.comparison-chart-2 ul .ideate-comparison span {
  background-color: rgb(255, 121, 0) !important;
}
.comparison-chart-2 ul .develop-comparison {
  margin-left: 50%;
}
.comparison-chart-2 ul .develop-comparison span {
  background-color: rgb(105, 190, 40) !important;
}
.comparison-chart-2 ul .implement-comparison {
  margin-left: 75%;
}
.comparison-chart-2 ul .implement-comparison span {
  background-color: rgb(245, 67, 89) !important;
}

.grid {
  border-left: 1px solid #000;
  box-shadow: 0px 1px 0 rgb(0, 0, 0);
  border-top: 0;
  border-bottom: 0;
  width: 100%;
  max-width: 700px;
  height: 200px;
  margin: 50px auto;
  position: relative;
}
.grid .score_calculator {
  position: absolute;
  top: 0;
  left: -20px;
  bottom: 0;
  width: 20px;
}
.grid .score_calculator .start,
.grid .score_calculator .end {
  position: absolute;
}
.grid .score_calculator .start {
  bottom: -5px;
  left: 7px;
}
.grid .score_calculator .end {
  top: -5px;
}
.grid ul {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  position: relative;
}
.grid ul li {
  width: 25%;
  position: absolute;
  left: 0px;
  bottom: 0;
  top: 0px;
}
.grid ul li .commonGraph {
  opacity: 0.65;
  width: 100%;
  height: 100%;
  position: relative;
  transition: all 400ms ease-in-out;
}
.grid ul li .commonGraph:hover {
  opacity: 0.8;
}
.grid ul li .graph {
  z-index: 1;
}
.grid ul li .graph2 {
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 1;
}
.grid ul li.clarify-comparison .graph,
.grid ul li.clarify-comparison .graph2 {
  background: rgb(0, 173, 208);
}
.grid ul li.ideate-comparison {
  left: 25%;
}
.grid ul li.ideate-comparison .graph,
.grid ul li.ideate-comparison .graph2 {
  background: rgb(255, 121, 0);
}
.grid ul li.develop-comparison {
  left: 50%;
}
.grid ul li.develop-comparison .graph,
.grid ul li.develop-comparison .graph2 {
  background: rgb(105, 190, 40);
}
.grid ul li.implement-comparison {
  left: 75%;
}
.grid ul li.implement-comparison .graph,
.grid ul li.implement-comparison .graph2 {
  background: rgb(245, 67, 89);
}

::ng-deep .profile-section.chart-container__pd {
  padding: 0 !important;
  box-shadow: none !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .profile-section.chart-container__pd > h2 .form-inline {
    margin-top: 20px;
  }
}
::ng-deep .profile-section.chart-container__pd > h2 .form-inline input + input {
  margin-top: 10px;
}
::ng-deep .profile-section.chart-container__pd > h2 {
  display: flex;
  flex-direction: column-reverse;
}
@media only screen and (min-width: 768px) {
  ::ng-deep .profile-section.chart-container__pd > h2 span {
    text-align: right;
  }
}
::ng-deep .profile-section.chart-container__pd .chart-section {
  margin: 0 0 0 29px;
  width: 96.5%;
}
::ng-deep .profile-section .chart-section {
  margin-top: 0;
}
::ng-deep .profile-section .chart-section .side-label {
  font-size: 12px;
  line-height: 14px;
  color: #999999 !important;
  position: absolute;
  left: -35px !important;
  text-align: right;
  width: 20px;
  letter-spacing: 0.01px;
  font-family: "Helvetica LT W05 Light";
}
::ng-deep .profile-section .chart-section .high_prefer {
  position: absolute;
  top: 2px !important;
  left: 9px !important;
  width: 110px;
  font-weight: normal;
  font-size: 14px !important;
  line-height: 17px !important;
  font-family: "Helvetica LT W05 Roman";
  text-align: left;
  color: #5C5D60 !important;
}
::ng-deep .profile-section .chart-section .low_prefer {
  position: absolute;
  bottom: 20px;
  left: 9px;
  font-size: 14px;
  line-height: 17px;
  width: 110px;
  text-align: left;
  font-family: "Helvetica LT W05 Roman";
  color: #5C5D60 !important;
}
::ng-deep .profile-section .chart-section .neutral .neutralBartext {
  left: 9px !important;
  position: absolute;
  font-weight: normal;
  font-size: 14px !important;
  line-height: 17px !important;
  font-family: "Helvetica LT W05 Roman";
  color: #5C5D60 !important;
}
::ng-deep .profile-section .chart-section .neutral_high_value {
  font-size: 14px !important;
  font-weight: normal;
  line-height: 17px !important;
  font-family: "Helvetica LT W05 Roman";
  color: #999 !important;
  left: 9px !important;
}
::ng-deep .profile-section .chart-section .neutral_low_value {
  font-size: 14px !important;
  font-weight: normal;
  line-height: 17px !important;
  font-family: "Helvetica LT W05 Roman";
  color: #999 !important;
  left: 9px !important;
}
::ng-deep .profile-section .chart-section .chart-main .chart-title span {
  font-size: 11px !important;
  line-height: 14px;
  font-family: "Helvetica LT W05 Bold";
}
@media only screen and (max-width: 1023px) {
  ::ng-deep .profile-section .chart-section .chart-main .visible-xs {
    display: block !important;
  }
  ::ng-deep .profile-section .chart-section .chart-main .hidden-xs {
    display: none !important;
  }
  ::ng-deep .profile-section .chart-section .chart-main .chart-title.blue-bg:before,
  ::ng-deep .profile-section .chart-section .chart-main .chart-title.orange-bg:before,
  ::ng-deep .profile-section .chart-section .chart-main .chart-title.green-bg:before,
  ::ng-deep .profile-section .chart-section .chart-main .chart-title.purple-bg:before {
    border-width: 0 26px 10px 26px;
  }
  ::ng-deep .profile-section .chart-section .chart-main .chart-title {
    width: 52px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    right: -25px;
    text-transform: capitalize;
    font-size: 14px;
  }
}
@media (min-width: 768px) {
  ::ng-deep .profile-section .chart-section .chart-main {
    height: 350px;
  }
}

@media (max-width: 1023px) {
  ::ng-deep #f-profile .chart-section .chart-main .visible-xs {
    display: block !important;
  }
  ::ng-deep #f-profile .chart-section .chart-main .hidden-xs {
    display: none !important;
  }
  ::ng-deep #f-profile .chart-section .chart-main .chart-title.blue-bg:before,
  ::ng-deep #f-profile .chart-section .chart-main .chart-title.orange-bg:before,
  ::ng-deep #f-profile .chart-section .chart-main .chart-title.green-bg:before,
  ::ng-deep #f-profile .chart-section .chart-main .chart-title.purple-bg:before {
    border-width: 0 26px 10px 26px;
  }
  ::ng-deep #f-profile .chart-section .chart-main .chart-title {
    width: 52px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    right: -25px;
    text-transform: capitalize;
    font-size: 14px;
  }
}
@media (max-width: 767px) {
  ::ng-deep #f-profile .chart-section .chart-main {
    height: 235px;
  }
}

::ng-deep .below-chart-description {
  background-color: #6d6e71 !important;
  color: #fff;
  padding: 25px 25px 0;
  max-width: 820px;
  width: 100%;
}
::ng-deep .below-chart-description .height30 {
  height: 30px;
}
::ng-deep .below-chart-description .custom-footer {
  margin-left: -25px;
  margin-right: -25px;
  background: #fff;
  color: #676a6c;
  display: flex;
  vertical-align: middle;
  align-items: center;
  padding: 15px 0px;
}
@media (max-width: 767px) {
  ::ng-deep .below-chart-description .custom-footer {
    display: block;
    float: left;
  }
  ::ng-deep .below-chart-description .custom-footer .col-xs-12 {
    text-align: center !important;
    margin-bottom: 10px;
  }
}
::ng-deep .below-chart-description .custom-footer p {
  margin: 0;
  font-size: 12px !important;
  color: #5C5D60 !important;
}
::ng-deep .below-chart-description .custom-footer a {
  font-size: 12px !important;
}

.quick-gd {
  width: 100%;
  max-width: 820px;
  position: relative;
  margin-block-start: -15px;
}
.quick-gd .quick-gd__arrow {
  border-left: 70px solid transparent;
  border-right: 70px solid transparent;
  border-top: 60px solid #7bbc43;
  max-width: 100px;
  position: relative;
  width: 100%;
  min-height: 100px;
  margin: 21px auto;
  cursor: pointer;
}
.quick-gd .quick-gd__arrow span {
  position: absolute;
  top: -60px;
  left: -20px;
  z-index: 9;
  max-width: 50px;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
}

#build-term .toolsguide-heading {
  min-height: 90px;
}
#build-term .lg-text {
  font-size: 18px;
  margin-bottom: 15px;
}
#build-term .side-bar {
  background: #e6e7e9 !important;
  padding: 20px;
}

#four-box .box {
  margin: 15px 1%;
  min-height: 600px;
}
@media (min-width: 768px) {
  #four-box .box {
    width: 48%;
  }
}
#four-box .box .col-xs-6:first-child {
  padding-right: 7.5px;
}
#four-box .box .col-xs-6:last-child {
  padding-left: 7.5px;
}

.right-button.text-right {
  width: 100%;
  text-align: center;
  margin: 3px 0 8px 0;
}
.right-button.text-right a.btn {
  /*width: 230px;*/
  display: block;
}
.right-button.disable-btn a {
  cursor: not-allowed;
}

.d-block {
  display: block;
}

.no-bottom-pad h5 {
  font-size: 17px;
}
.no-bottom-pad .close {
  margin-top: -24px;
}

.modal-dialog {
  width: 470px;
}

@media print {
  /*#chartarea {
      width: 580px;
    }*/
  .chart-title {
    color: #fff #fff !important;
  }
  .chart-title .visible-xs,
  .chart-title .hidden-xs {
    color: #fff #fff !important;
  }
  /* Guide Report print style*/
  body {
    color: #676a6c !important;
  }
  .below-chart,
  .below-chart-description {
    margin-left: 20px;
  }
  .below-chart-description p,
  .below-chart-description big,
  .below-chart-description a,
  .below-chart-description span,
  .below-chart-description sup {
    color: #fff !important;
  }
  .chart-container {
    padding-top: 0px;
    margin-bottom: 20px;
  }
  .short-guide .innovation-section,
  .long-guide .innovation-section {
    margin: 0px auto;
    padding: 15px 15px 50px;
    min-height: 960px;
  }
  .short-guide #four-profile,
  .long-guide #four-profile {
    padding-top: 0;
  }
  .short-guide #four-profile .toolsguide-heading,
  .long-guide #four-profile .toolsguide-heading {
    padding: 0px;
  }
  .short-guide #four-profile .toolsguide-content,
  .long-guide #four-profile .toolsguide-content {
    padding: 0;
  }
  .short-guide #four-box .box,
  .long-guide #four-box .box {
    min-height: 430px;
    margin: 0px 1% 15px;
  }
  .short-guide #four-box .box .box-top img,
  .long-guide #four-box .box .box-top img {
    width: 55px;
  }
  .short-guide #four-box .box h2,
  .long-guide #four-box .box h2 {
    margin: 5px 0;
  }
  .short-guide #four-box .box .col-xs-6:first-child,
  .long-guide #four-box .box .col-xs-6:first-child {
    padding: 0px 7.5px;
  }
  .short-guide #four-box .box ul li,
  .long-guide #four-box .box ul li {
    line-height: 16px;
  }
  .short-guide #four-think .box,
  .long-guide #four-think .box {
    min-height: 225px;
    margin: 2px;
  }
  .short-guide #dots-img,
  .long-guide #dots-img {
    background: url("https://assets.foursightonline.com/app/images/dotk.jpg") !important;
    background-size: cover !important;
    min-height: 900px;
  }
  .short-guide .toolsguide .box .box-top,
  .long-guide .toolsguide .box .box-top {
    padding: 0px 15px;
  }
  .short-guide #four-think .box h2,
  .long-guide #four-think .box h2 {
    margin: 5px 0;
  }
  .short-guide .toolsguide,
  .long-guide .toolsguide {
    page-break-after: always;
  }
  .short-guide .toolsguide:last-child,
  .long-guide .toolsguide:last-child {
    page-break-after: auto;
  }
  .short-guide .toolsguide .toolsguide-content aside,
  .long-guide .toolsguide .toolsguide-content aside {
    padding: 0px;
  }
  .short-guide .toolsguide .footer-lg,
  .long-guide .toolsguide .footer-lg {
    background-color: #6d6e71 !important;
  }
  .short-guide .toolsguide .footer-lg .text,
  .short-guide .toolsguide .footer-lg a,
  .long-guide .toolsguide .footer-lg .text,
  .long-guide .toolsguide .footer-lg a {
    color: #fff !important;
  }
  .short-guide .toolsguide .footer-lg a[href]:after,
  .long-guide .toolsguide .footer-lg a[href]:after {
    color: #fff !important;
  }
  .short-guide .toolsguide .pref.clarify span,
  .long-guide .toolsguide .pref.clarify span {
    background: #00aed9 !important;
  }
  .short-guide .toolsguide .pref.ideate span,
  .long-guide .toolsguide .pref.ideate span {
    background: #f68c1f !important;
  }
  .short-guide .toolsguide .pref.developer span,
  .long-guide .toolsguide .pref.developer span {
    background: #66bd4a !important;
  }
  .short-guide .toolsguide .pref.implement span,
  .long-guide .toolsguide .pref.implement span {
    background: #ef465b !important;
  }
  .short-guide .toolsguide .pref.clarify ul li,
  .long-guide .toolsguide .pref.clarify ul li {
    color: #00aed9 !important;
  }
  .short-guide .toolsguide .pref.developer ul li,
  .long-guide .toolsguide .pref.developer ul li {
    color: #66bd4a !important;
  }
  .short-guide .toolsguide .pref.ideate ul li,
  .long-guide .toolsguide .pref.ideate ul li {
    color: #f68c1f !important;
  }
  .short-guide .toolsguide .pref.implement ul li,
  .long-guide .toolsguide .pref.implement ul li {
    color: #ef465b !important;
  }
  .short-guide .toolsguide .toolsguide-heading-text,
  .long-guide .toolsguide .toolsguide-heading-text {
    margin: 0px;
  }
  .short-guide .toolsguide .footer-xs,
  .long-guide .toolsguide .footer-xs {
    background-color: #e6e7e8 !important;
  }
  .short-guide .toolsguide .box.clarify h2,
  .short-guide .toolsguide .box.clarify h4,
  .long-guide .toolsguide .box.clarify h2,
  .long-guide .toolsguide .box.clarify h4 {
    color: #00aed9 !important;
  }
  .short-guide .toolsguide .box.clarify .box-top,
  .long-guide .toolsguide .box.clarify .box-top {
    background-color: #00aed9 !important;
  }
  .short-guide .toolsguide .box.ideate h2,
  .short-guide .toolsguide .box.ideate h4,
  .long-guide .toolsguide .box.ideate h2,
  .long-guide .toolsguide .box.ideate h4 {
    color: #f68c1f !important;
  }
  .short-guide .toolsguide .box.ideate .box-top,
  .long-guide .toolsguide .box.ideate .box-top {
    background-color: #f68c1f !important;
  }
  .short-guide .toolsguide .box.develop h2,
  .short-guide .toolsguide .box.develop h4,
  .long-guide .toolsguide .box.develop h2,
  .long-guide .toolsguide .box.develop h4 {
    color: #66bd4a !important;
  }
  .short-guide .toolsguide .box.develop .box-top,
  .long-guide .toolsguide .box.develop .box-top {
    background-color: #66bd4a !important;
  }
  .short-guide .toolsguide .box.implement h2,
  .short-guide .toolsguide .box.implement h4,
  .long-guide .toolsguide .box.implement h2,
  .long-guide .toolsguide .box.implement h4 {
    color: #ef465b !important;
  }
  .short-guide .toolsguide .box.implement .box-top,
  .long-guide .toolsguide .box.implement .box-top {
    background-color: #ef465b !important;
  }
  .short-guide .toolsguide .box ul li,
  .long-guide .toolsguide .box ul li {
    margin-bottom: 0px;
  }
}
.profile-section h2 {
  color: #5C5D60;
  font-size: 32px;
  margin: 0 0 0;
  letter-spacing: -0.1px;
  font-family: "Helvetica LT W05 Bold";
}

.profile-section p {
  font-size: 12px !important;
  color: #5C5D60 !important;
  margin-bottom: 0;
}

.form-inline .fa,
.pencil .fa {
  font-size: 18px;
}

.grey {
  background: rgba(236, 236, 236, 0.9);
}

.download_language {
  margin-top: 20px;
  font-size: 13px;
}

.long_guides {
  margin-top: 20px;
}

.package-form {
  display: inline-block;
  width: 100%;
}
.package-form--pd .modal-body select {
  padding: 5px !important;
}
.package-form label,
.package-form select {
  width: 55%;
}
.package-form label {
  line-height: 2em;
  padding: 0.75rem 0.75rem 0.75rem 0 !important;
}
.package-form select {
  border: 1px solid #ddd;
  padding: 10px !important;
  height: 40px;
  background: #F8F8F8;
  color: #636363;
  font-family: "Museo-300";
  margin-bottom: 10px;
}
.package-form select:focus {
  outline: none;
}
.package-form .modal-body .warning {
  padding-top: 10px;
}

.package-form .btn {
  margin-top: 10px;
}

.profile-description {
  color: #5C5D60 !important;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.4px;
  font-family: "Helvetica LT W05 Roman";
  margin-top: 13px;
}

.below-chart {
  background: #f1f1f1;
  margin-bottom: 0;
}
.below-chart h3 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  grid-gap: 10px 13px;
}
.below-chart h3 .left-label {
  float: none;
}
.below-chart h3 .prefers_to {
  font-family: "Helvetica LT W05 Roman";
  color: #5C5D60 !important;
  font-size: 14px !important;
  line-height: 17px !important;
  text-transform: none;
  letter-spacing: -0.04px;
  font-weight: normal;
  display: inline;
  margin-bottom: 0 !important;
}
.below-chart h3 #equation {
  display: inline-block;
}
.below-chart h3 #equation span {
  margin-bottom: 0 !important;
}
.below-chart h3 #equation > span {
  padding: 0;
  display: inline-block !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  line-height: 14px !important;
  text-transform: uppercase !important;
  font-family: "Helvetica LT W05 Bold" !important;
  letter-spacing: 0.07px !important;
}

.footer-logo {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  width: 100%;
  margin-bottom: 10px;
}
.footer-logo .copyright {
  width: 50%;
}
.footer-logo .copyright p {
  font-size: 11px !important;
  letter-spacing: 0.39px !important;
}
.footer-logo .fs-logo {
  width: 50%;
  text-align: right;
}

.below-chart-description {
  margin-bottom: 0;
}
.below-chart-description p {
  margin: 0;
  font-family: "Helvetica LT W05 Light";
  font-size: 12px;
  line-height: 17px;
  display: block;
  color: #f1f1f1;
}
.below-chart-description p span {
  font-size: 14px;
  font-family: "Helvetica LT W05 Bold";
}
.below-chart-description .fs-graph-logo {
  max-width: 181px;
}

.fixed-loader {
  width: 100%;
  height: 100%;
  text-align: center;
}
.fixed-loader.profile-loader {
  max-width: 820px;
  width: 100%;
}
.fixed-loader i {
  font-size: 8em !important;
}

.pf-rdbtn {
  padding-bottom: 25px;
}
.pf-rdbtn--pfpdf {
  padding-bottom: 10px;
}
.pf-rdbtn label {
  padding: 0;
  width: 65%;
  padding-left: 10px;
  font-weight: 500;
  cursor: pointer;
}

.modal-body {
  padding-block-end: 0px;
}
.modal-body .disable-btn {
  pointer-events: none;
}
.modal-body .text-left.text {
  padding-left: 0;
}
.modal-body .text--fw {
  width: 100%;
  font-weight: bold;
  padding: 0;
}
.modal-body .assessment-select select {
  height: 30px;
  padding: 3px;
  width: 45%;
  background-color: #fff;
  margin: 0 10px 7px;
}

.modal-body__buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  border-top: 1px solid #ddd;
  width: calc(100% + 32px);
  margin: 0 -16px;
  padding: 5px 10px;
  background-color: #f6f6f6;
}
.modal-body__buttons .btn {
  margin-top: 0;
}
.modal-body__buttons .btn-prim {
  margin-inline-start: 10px;
}
.modal-body__buttons .btn-disable {
  cursor: not-allowed;
  pointer-events: none;
}

.clr {
  color: #5C5D60;
  font-size: 16px;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 400;
}
@media only screen and (max-width: 767px) {
  .clr {
    padding-bottom: 0;
  }
}
.clr select {
  padding: 2px 5px 2px 3px;
  outline-color: #5c5d60;
  width: 171px;
  height: 29px;
  color: #5c5d60;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
@media only screen and (max-width: 767px) {
  .clr select {
    width: 100%;
  }
}

.chart-container .chart-pfd {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  line-height: 20px;
  align-items: center;
}
@media only screen and (max-width: 767px) {
  .chart-container .chart-pfd {
    flex-wrap: wrap;
  }
}
.chart-container .chart-pfd .chart-left {
  position: relative;
}
.chart-container .chart-pfd .chart-left__title {
  position: absolute;
  top: -55px;
}
@media only screen and (max-width: 767px) {
  .chart-container .chart-pfd .chart-left__title {
    position: static;
  }
}
.chart-container .chart-pfd .chart-left__title strong {
  padding-bottom: 8px;
  color: #5C5D60;
  font-size: 32px;
  line-height: 38px;
  margin: 0 0 0;
  letter-spacing: -0.1px;
  font-family: "Helvetica LT W05 Bold";
}
.chart-container .chart-pfd .chart-left__title .pencil {
  margin-left: 8px;
}
.chart-container .chart-pfd .chart-right {
  width: 100%;
  text-align: right;
  padding-bottom: 6px;
}
@media only screen and (max-width: 767px) {
  .chart-container .chart-pfd .chart-right {
    text-align: left;
  }
}
.chart-container .chart-pfd .chart-right .foursight-content {
  font-size: 16px;
  line-height: 19px;
  text-align: right;
  margin-bottom: 0px;
  margin-top: 11px;
  letter-spacing: 0;
  padding-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .chart-container .chart-pfd .chart-right .foursight-content {
    text-align: left;
  }
}

.chartist-wrap__pd {
  margin: 0;
}

.section-wrapper {
  padding: 20px 10px 40px;
}

.guide-modal {
  display: none;
}

/*--- 05-07-23 ---*/
@media only screen and (max-width: 1199px) {
  .fs-profile .page-content .chart-container .chart-left__title h2 {
    font-size: 30px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .fs-profile .page-content .chart-container .chart-left__title h2 {
    font-size: 28px;
  }
}
@media (max-width: 640px) {
  .fs-profile .page-content .chart-container .chart-left__title h2 {
    font-size: 26px;
  }
}
@media (min-width: 641px) and (max-width: 991px) {
  ::ng-deep .fs-profile .page-content .chart-container__pd .chart-section {
    margin: 0 0 0 19px;
  }
}
@media (max-width: 640px) {
  ::ng-deep .fs-profile .page-content .chart-container__pd .chart-section {
    margin: 0 0 0 19px;
    width: 95%;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .fs-profile .page-content .below-chart h3 .left-label {
    font-size: 22px;
  }
}
@media (max-width: 640px) {
  .fs-profile .page-content .below-chart h3 .left-label {
    font-size: 18px !important;
    padding: 4px 8px !important;
    width: 100%;
    margin-right: 0 !important;
  }
}
@media (max-width: 640px) {
  .fs-profile .page-content .below-chart {
    padding: 18px;
  }
}
@media only screen and (max-width: 1199px) {
  .fs-profile .page-content .quick-gd .quick-gd__arrow {
    min-height: 75px;
  }
}

.f-btn--nobdr {
  border: 0;
}

img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

::ng-deep .owner-details .ibox-content .source-wrapper .image {
  display: inline-block;
}

::ng-deep .dark-left-section small.fs-in {
  display: block;
}

::ng-deep .pace-running:not(.pace-done) .widget-head-color-box h2 {
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-avatar 1.6s infinite linear;
  height: 26px;
  font-size: 0;
}
::ng-deep .pace-running:not(.pace-done) .owner-details .ibox-content .source-wrapper .image {
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-avatar2 1.6s infinite linear;
  height: 100px;
}
::ng-deep .pace-running:not(.pace-done) .owner-details .ibox-content .source-wrapper .image img {
  opacity: 0;
}
::ng-deep .pace-running:not(.pace-done) .owner-details .ibox-content ul.list-unstyled li {
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-avatar1 1.6s infinite linear;
  margin: 0 0 1px 0;
  height: 19px;
  font-size: 0;
}

@keyframes shine-avatar {
  0% {
    background-position: -32px;
  }
  40%, 100% {
    background-position: 300px;
  }
  100% {
    background-position: 500px;
  }
}
@keyframes shine-avatar1 {
  0% {
    background-position: -32px;
  }
  40%, 100% {
    background-position: 300px;
  }
  100% {
    background-position: 500px;
  }
}
@keyframes shine-avatar2 {
  0% {
    background-position: -32px;
  }
  40%, 100% {
    background-position: 300px;
  }
  100% {
    background-position: 500px;
  }
}
@keyframes shine-avatar3 {
  0% {
    background-position: -32px;
  }
  40%, 100% {
    background-position: 300px;
  }
  100% {
    background-position: 500px;
  }
}
::ng-deep .introjs-tooltip {
  box-sizing: content-box;
  visibility: visible;
  min-width: 200px;
  max-width: 300px;
  transition: opacity 0.1s ease-out;
  width: 243px;
  height: auto;
  background: #fff;
  border-radius: 100px;
  -webkit-border-radius: 100px;
  -moz-border-radius: 100px;
  position: relative;
  margin: 90px auto 20px;
  padding: 20px !important;
  box-shadow: 0 0px !important;
}
::ng-deep .introjs-tooltip .introjs-arrow.top {
  background: url("https://assets.foursightonline.com/app/images/cloud-arrow-icon.png");
  width: 10px !important;
  height: 10px !important;
  display: block !important;
  padding: 32px;
  display: block !important;
  background-size: 100% !important;
  top: -80px;
  background-color: transparent;
  border: none;
}
::ng-deep .introjs-tooltip .introjs-arrow.left {
  background: url("https://assets.foursightonline.com/app/images/cloud-arrow-icon.png");
  width: 10px !important;
  height: 10px !important;
  display: block !important;
  padding: 32px;
  display: block !important;
  background-size: 100% !important;
  top: 90px;
  background-color: transparent;
  border: none;
  transform: rotate(-70deg);
  left: -50px;
}
::ng-deep .introjs-tooltip:after, ::ng-deep .introjs-tooltip:before {
  content: "";
  position: absolute;
  background: #fff;
  z-index: -1;
}
::ng-deep .introjs-tooltip:before {
  width: 135px;
  height: 135px;
  top: -67px;
  right: 37px;
  border-radius: 200px;
  -webkit-border-radius: 200px;
  -moz-border-radius: 200px;
}
::ng-deep .introjs-tooltip:after {
  width: 75px;
  height: 75px;
  top: -37px;
  left: 37px;
  border-radius: 100px;
  -webkit-border-radius: 100px;
  -moz-border-radius: 100px;
}
::ng-deep .introjs-tooltip .introjs-tooltiptext {
  text-align: center;
  padding: 0 15px;
}
::ng-deep .introjs-tooltip .introjs-tooltipbuttons {
  text-align: center;
  white-space: nowrap;
  margin-top: 10px;
}
::ng-deep .introjs-tooltip .introjs-tooltipbuttons a.introjs-button {
  padding: 9px 14px;
  border: none;
  border-radius: 4px;
  background: rgb(105, 190, 40);
  color: #fff;
  text-shadow: 0 0;
  margin: 0 0 0 5px;
}
::ng-deep .introjs-tooltip .introjs-tooltipbuttons a.introjs-button.introjs-disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

.dashboard-column .source-owner .btn-primary {
  max-width: 170px;
  width: 100%;
  word-wrap: break-word;
  white-space: normal;
}

.m-b-md.dash-user-image {
  width: 70px;
  height: 70px;
  border-width: 0px;
  object-fit: cover;
}

@media only screen and (max-width: 991px) {
  .ibox-title h5 {
    float: none;
  }
}
@media screen and (max-width: 575px) {
  .ibox-title {
    text-align: center;
  }
}
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}

.video-container iframe,
.video-container object,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.top-modal {
  display: inline-block;
}

.min-box {
  height: auto !important;
}
.min-box .places {
  padding: 5px 20px 5px 20px !important;
}

.d-flex-cst {
  display: flex;
  display: -ms-flexbox;
  flex-wrap: wrap;
}

.d-flex-cst .ibox {
  height: 100%;
}

.h-100 {
  height: 100%;
}

@media screen and (max-width: 1199px) {
  .d-flex-cst .col-lg-6 {
    width: 100%;
  }
}
::ng-deep.grey {
  background: rgba(236, 236, 236, 0.9);
}

.branding-details {
  text-align: left;
  max-width: 100;
}

li.branding-profile {
  padding-bottom: 5px;
  padding-top: 3px;
}

.email-verification {
  text-align: center;
}

.grid-2-cols {
  display: grid;
  grid-template-columns: auto auto;
}

.image-youtube {
  height: 500px;
  object-fit: contain;
}

.asssessment_img {
  width: 263px;
  height: 341px;
  margin: 0 auto;
  padding: 10px;
}

.dashboard-header {
  padding: 32px 20px 30px;
}
.dashboard-header h2 {
  margin-top: 0;
  font-size: 24px;
}

.api-err h1 {
  font-family: "Museo-700";
}

.profile-error h5,
.profile-error p {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
}

.maintain-msg {
  background-color: #f5b5b5;
  padding: 20px;
  border-radius: 4px;
  color: #c80909;
}

img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

::ng-deep .owner-details .ibox-content .source-wrapper .image {
  display: inline-block;
}

::ng-deep .dark-left-section small.fs-in {
  display: block;
}

::ng-deep .pace-running:not(.pace-done) .widget-head-color-box h2 {
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-avatar 1.6s infinite linear;
  height: 26px;
  font-size: 0;
}
::ng-deep .pace-running:not(.pace-done) .owner-details .ibox-content .source-wrapper .image {
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-avatar2 1.6s infinite linear;
  height: 100px;
}
::ng-deep .pace-running:not(.pace-done) .owner-details .ibox-content .source-wrapper .image img {
  opacity: 0;
}
::ng-deep .pace-running:not(.pace-done) .owner-details .ibox-content ul.list-unstyled li {
  background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
  background-size: 600px;
  animation: shine-avatar1 1.6s infinite linear;
  margin: 0 0 1px 0;
  height: 19px;
  font-size: 0;
}

@keyframes shine-avatar {
  0% {
    background-position: -32px;
  }
  40%, 100% {
    background-position: 300px;
  }
  100% {
    background-position: 500px;
  }
}
@keyframes shine-avatar1 {
  0% {
    background-position: -32px;
  }
  40%, 100% {
    background-position: 300px;
  }
  100% {
    background-position: 500px;
  }
}
@keyframes shine-avatar2 {
  0% {
    background-position: -32px;
  }
  40%, 100% {
    background-position: 300px;
  }
  100% {
    background-position: 500px;
  }
}
@keyframes shine-avatar3 {
  0% {
    background-position: -32px;
  }
  40%, 100% {
    background-position: 300px;
  }
  100% {
    background-position: 500px;
  }
}
::ng-deep .introjs-tooltip {
  box-sizing: content-box;
  visibility: visible;
  min-width: 200px;
  max-width: 300px;
  transition: opacity 0.1s ease-out;
  width: 243px;
  height: auto;
  background: #fff;
  border-radius: 100px;
  -webkit-border-radius: 100px;
  -moz-border-radius: 100px;
  position: relative;
  margin: 90px auto 20px;
  padding: 20px !important;
  box-shadow: 0 0px !important;
}
::ng-deep .introjs-tooltip .introjs-arrow.top {
  background: url("https://assets.foursightonline.com/app/images/cloud-arrow-icon.png");
  width: 10px !important;
  height: 10px !important;
  display: block !important;
  padding: 32px;
  display: block !important;
  background-size: 100% !important;
  top: -80px;
  background-color: transparent;
  border: none;
}
::ng-deep .introjs-tooltip .introjs-arrow.left {
  background: url("https://assets.foursightonline.com/app/images/cloud-arrow-icon.png");
  width: 10px !important;
  height: 10px !important;
  display: block !important;
  padding: 32px;
  display: block !important;
  background-size: 100% !important;
  top: 90px;
  background-color: transparent;
  border: none;
  transform: rotate(-70deg);
  left: -50px;
}
::ng-deep .introjs-tooltip:after, ::ng-deep .introjs-tooltip:before {
  content: "";
  position: absolute;
  background: #fff;
  z-index: -1;
}
::ng-deep .introjs-tooltip:before {
  width: 135px;
  height: 135px;
  top: -67px;
  right: 37px;
  border-radius: 200px;
  -webkit-border-radius: 200px;
  -moz-border-radius: 200px;
}
::ng-deep .introjs-tooltip:after {
  width: 75px;
  height: 75px;
  top: -37px;
  left: 37px;
  border-radius: 100px;
  -webkit-border-radius: 100px;
  -moz-border-radius: 100px;
}
::ng-deep .introjs-tooltip .introjs-tooltiptext {
  text-align: center;
  padding: 0 15px;
}
::ng-deep .introjs-tooltip .introjs-tooltipbuttons {
  text-align: center;
  white-space: nowrap;
  margin-top: 10px;
}
::ng-deep .introjs-tooltip .introjs-tooltipbuttons a.introjs-button {
  padding: 9px 14px;
  border: none;
  border-radius: 4px;
  background: rgb(105, 190, 40);
  color: #fff;
  text-shadow: 0 0;
  margin: 0 0 0 5px;
}
::ng-deep .introjs-tooltip .introjs-tooltipbuttons a.introjs-button.introjs-disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

.dashboard-column .source-owner .btn-primary {
  max-width: 170px;
  width: 100%;
  word-wrap: break-word;
  white-space: normal;
}

.m-b-md.dash-user-image {
  width: 70px;
  height: 70px;
  border-width: 0px;
  object-fit: cover;
}

@media only screen and (max-width: 991px) {
  .ibox-title h5 {
    float: none;
  }
}
@media screen and (max-width: 575px) {
  .ibox-title {
    text-align: center;
  }
}
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}

.video-container iframe,
.video-container object,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.top-modal {
  display: inline-block;
}

.min-box {
  height: auto !important;
}
.min-box .places {
  padding: 5px 20px 5px 20px !important;
}

.d-flex-cst {
  display: flex;
  display: -ms-flexbox;
  flex-wrap: wrap;
}

.d-flex-cst .ibox {
  height: 100%;
}

.h-100 {
  height: 100%;
}

@media screen and (max-width: 1199px) {
  .d-flex-cst .col-lg-6 {
    width: 100%;
  }
}
::ng-deep.grey {
  background: rgba(236, 236, 236, 0.9);
}

.branding-details {
  text-align: left;
  max-width: 100;
}

li.branding-profile {
  padding-bottom: 5px;
  padding-top: 3px;
}

.email-verification {
  text-align: center;
}

.grid-2-cols {
  display: grid;
  grid-template-columns: auto auto;
}

.image-youtube {
  height: 500px;
  object-fit: contain;
}

.asssessment_img {
  width: 263px;
  height: 341px;
  margin: 0 auto;
  padding: 10px;
}

.dashboard-header {
  padding: 32px 20px 30px;
}
.dashboard-header h2 {
  margin-top: 0;
  font-size: 24px;
}

.api-err h1 {
  font-family: "Museo-700";
}

.profile-error h5,
.profile-error p {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
}

.maintain-msg {
  background-color: #f5b5b5;
  padding: 20px;
  border-radius: 4px;
  color: #c80909;
}

#mc_embed_signup_scroll .row {
  margin-left: -10px;
  margin-right: -10px;
}

div#mc_embed_signup_scroll {
  background: #6d6e71;
  padding: 20px;
  color: #fff;
  max-width: 400px;
}

div#mc_embed_signup_scroll h2 {
  margin-top: 0;
}

div#mc_embed_signup_scroll div[class*=col-] {
  padding-left: 10px;
  padding-right: 10px;
}

#mc_embed_signup {
  font-family: "Museo-300";
}

input#mce-EMAIL {
  color: #000;
}

.branding-details .ibox {
  box-shadow: none !important;
}
.branding-details .ibox-content {
  border: 1px solid #e7eaec;
}

.presenter-title {
  font-size: 20px;
  margin-bottom: 5px;
}

::ng-deep .hs-form {
  color: #fff;
  font-family: "Museo-300";
  padding: 5px 6px;
}
::ng-deep .hs-form .legal-consent-container {
  display: none !important;
}
::ng-deep .hs-form div.hs-email {
  float: left;
  width: 60%;
  position: relative;
}
::ng-deep .hs-form .hs_error_rollup {
  display: none;
}
::ng-deep .hs-form ul.hs-error-msgs {
  margin-left: 0px;
  padding-left: 0px;
  position: absolute;
  color: rgb(193, 226, 21);
  margin-top: 3px;
}
::ng-deep .hs-form ul.hs-error-msgs li {
  list-style: none;
}
::ng-deep .hs-form div.hs_submit {
  float: right;
  width: 35%;
}
::ng-deep .hs-form .hs-input {
  background-color: #fff;
  background-image: none;
  border: 1px solid #e5e6e7;
  border-radius: 1px;
  color: inherit;
  display: block;
  padding: 6px 12px;
  transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
  width: 100%;
  color: #000;
}
::ng-deep .hs-form input.hs-button.primary.large {
  border: 0 !important;
  padding: 8px 15px !important;
  line-height: 1.4em;
  background: #5EB85C;
  color: #fff;
  width: 100%;
  margin-top: 23px;
}

div#f-end {
  position: relative;
}

::ng-deep.prefers_to {
  font-family: "Helvetica LT W05 Roman";
  color: #5C5D60 !important;
  font-size: 14px !important;
  line-height: 17px !important;
  text-transform: none;
  letter-spacing: -0.04px;
  font-weight: normal;
  display: inline;
  margin-bottom: 10px !important;
  padding-right: 13px;
}

::ng-deep.chart-container {
  box-shadow: none !important;
}
::ng-deep.chart-container__head {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  line-height: 1.5;
}
::ng-deep.chart-container__head .foursight-content {
  font-size: 16px !important;
  line-height: 19px !important;
  letter-spacing: 0 !important;
}
::ng-deep.chart-container .head {
  padding-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
::ng-deep.chart-container .head .head__right {
  text-align: right;
}
::ng-deep.chart-container .head .head__right p {
  line-height: 10px;
}
::ng-deep.chart-container .head p {
  font-family: "Helvetica LT W05 Light";
}
::ng-deep.chart-container.white-bg.profile-section {
  padding: 0;
}
::ng-deep.chart-container .chart-section {
  width: 97%;
  margin: 1% 0 0 3%;
}
::ng-deep.chart-container .y-dividers {
  border: 3px solid rgb(209, 210, 212);
  height: 420px;
}

.lmslider {
  margin-top: 30px;
  position: relative;
}

::ng-deep.lmslider__ftrplayer {
  color: #000;
}
::ng-deep.lmslider__ftrplayer audio {
  color: #000;
}
::ng-deep.lmslider__ftrplayer audio::-webkit-media-controls-mute-button {
  display: none;
  pointer-events: none;
  visibility: hidden;
}
::ng-deep.lmslider__ftrplayer audio::-webkit-media-controls-volume-slider-container {
  display: none;
  pointer-events: none;
}
::ng-deep.lmslider__ftrplayer ::-webkit-slider-thumb {
  display: none;
  pointer-events: none;
}
::ng-deep.lmslider__ftrplayer audio::-webkit-media-controls-volume-slider {
  display: none;
  pointer-events: none;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.branding-details {
  width: 40%;
}
.branding-details .list-unstyled {
  padding-left: 20px;
}
.branding-details .list-unstyled--wd {
  width: 100%;
  max-width: 100%;
  text-align: left;
  list-style: disc;
}

.dash-steps {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
}
.dash-steps img {
  max-width: 100%;
  width: 100%;
  height: auto;
  max-height: 302px;
  object-fit: contain;
}
.dash-steps .step-checlist {
  padding-top: 10px;
  display: flex;
  align-items: center;
}
.dash-steps .step-checlist i {
  font-size: 2em;
  color: rgb(105, 190, 40);
  margin-right: 5px;
}

.dash-steps-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.dash-steps-wrapper:after, .dash-steps-wrapper:before {
  display: none;
}

.dash-common {
  display: flex;
}
.dash-common .float-e-margins {
  height: 100%;
}
.dash-common .ibox-content {
  border: none;
}

.no-border {
  border: none !important;
}

.imp-top h1 a {
  color: inherit;
}

::ng-deep .challenges-heading .fn-col:nth-child(1) {
  width: 60%;
}
::ng-deep .challenges-heading .fn-col:nth-child(2) {
  width: 40%;
}
::ng-deep .challenges-heading h2 {
  margin-bottom: 2px;
}
::ng-deep .challenges-heading p {
  font-size: 14px;
}
::ng-deep .challenges-heading__icon {
  text-align: right;
  display: flex;
  justify-content: flex-end;
}
::ng-deep .challenges-heading__icon img {
  width: 100px;
}
::ng-deep .challenges-heading__icon ::ng-deep .unliked-profile {
  transform: scale(3);
  display: inline-block;
  transform-origin: right;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .challenges-heading__icon ::ng-deep .unliked-profile {
    transform: scale(2);
  }
}

@keyframes assessPulseClarify {
  0% {
    background-color: rgb(0, 173, 208);
  }
  70% {
    background-color: #0087a2;
  }
  100% {
    background-color: rgb(0, 173, 208);
  }
}
@keyframes assessPulseIdeate {
  0% {
    background-color: rgb(255, 121, 0);
  }
  70% {
    background-color: #d16300;
  }
  100% {
    background-color: rgb(255, 121, 0);
  }
}
@keyframes assessPulseDevelop {
  0% {
    background-color: rgb(105, 190, 40);
  }
  60% {
    background-color: #549820;
  }
  100% {
    background-color: rgb(105, 190, 40);
  }
}
@keyframes assessPulseImplement {
  0% {
    background-color: rgb(245, 67, 89);
  }
  60% {
    background-color: #f76f7f;
  }
  100% {
    background-color: rgb(245, 67, 89);
  }
}
.assess {
  --imageGap: 7.5%;
  --animDuration: 2s;
}
@media only screen and (max-width: 767px) {
  .assess .fn-col {
    width: 100%;
  }
  .assess .fn-col:not(:last-child) {
    margin-bottom: 30px;
  }
}
.assess__tab {
  position: relative;
}
.assess__border {
  opacity: var(--opacity);
}
.assess__image {
  position: absolute;
  width: 40.762%;
  height: 40.762%;
  opacity: var(--opacity);
}
.assess__imagebox {
  animation-direction: alternate;
}
.assess__imagebox img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  max-width: 75%;
  pointer-events: none;
}
.assess__image--active {
  --opacity: 1;
}
.assess__image--active .assess__imagebox {
  box-shadow: 0 0 0 2px #fff, 0 0 10px rgba(0, 0, 0, 0.2);
}
.assess__image--active.assess__image--clarify .assess__imagebox {
  animation: assessPulseClarify var(--animDuration) infinite;
}
.assess__image--active.assess__image--ideate .assess__imagebox {
  animation: assessPulseIdeate var(--animDuration) infinite;
}
.assess__image--active.assess__image--develop .assess__imagebox {
  animation: assessPulseDevelop var(--animDuration) infinite;
}
.assess__image--active.assess__image--implement .assess__imagebox {
  animation: assessPulseImplement var(--animDuration) infinite;
}
.assess__imagebox {
  width: 70%;
  padding-bottom: 70%;
  background-color: var(--clrProfile);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
}
.assess__imageboxcontent {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.assess__imageboxcontent h3 {
  color: #fff;
  font-size: 1.7vw;
}
@media only screen and (max-width: 767px) {
  .assess__imageboxcontent h3 {
    font-size: 4.5vw;
  }
}
.assess__image--clarify {
  top: var(--imageGap);
  left: 50%;
  transform: translateX(-50%);
}
.assess__image--ideate {
  top: 50%;
  right: var(--imageGap);
  transform: translateY(-50%);
}
.assess__image--develop {
  bottom: var(--imageGap);
  left: 50%;
  transform: translateX(-50%);
}
.assess__image--implement {
  top: 50%;
  left: var(--imageGap);
  transform: translateY(-50%);
}
.assess__content > *:not(:last-child) {
  margin-bottom: 20px;
}

::ng-deep.share-result {
  padding-bottom: 60px;
}
::ng-deep.share-result__wrapper {
  background-image: url(https://assets.foursightonline.com/admin-uploads/docs/242/original.png);
  background-size: cover;
  background-position: center;
  padding-block: 100px;
  padding-end: 60px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.share-result__wrapper {
    padding-block: 60px;
    padding-inline: 20px;
  }
}
::ng-deep.share-result__social ul {
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  line-height: 0;
}
::ng-deep.share-result__social li {
  margin-inline: 12px;
  list-style: none;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.share-result__social li {
    margin-inline: 10px;
  }
}
::ng-deep.share-result__social a {
  display: inline-block;
  transition: 0.3s;
}
::ng-deep.share-result__social a:hover {
  opacity: 0.8;
}
::ng-deep.share-result__social img {
  width: 36px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.share-result__social img {
    width: 30px;
  }
}

::ng-deep.dashcheck {
  padding-block-end: 0;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.dashcheck__colrow .fn-col {
    width: 50%;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.dashcheck__colrow .fn-col {
    width: 100%;
  }
}
::ng-deep.dashcheck__cell {
  height: 100%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
::ng-deep.dashcheck__cell:hover .dashcheck__box {
  border-color: rgb(105, 190, 40);
}
::ng-deep.dashcheck__cell:hover .dashcheck__content {
  display: none;
}
::ng-deep.dashcheck__cell--active .dashcheck__box {
  border-color: rgb(105, 190, 40);
}
::ng-deep.dashcheck__cell--active .dashcheck__content {
  display: none;
}
::ng-deep.dashcheck__cell--active .dashcheck__activecontent {
  display: block;
}
::ng-deep.dashcheck__box {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 2px solid #f1f1f2;
  border-radius: 5px;
  overflow: hidden;
}
::ng-deep.dashcheck__image {
  padding: 15px;
}
::ng-deep.dashcheck__imageinner {
  position: relative;
  padding-bottom: 70%;
}
::ng-deep.dashcheck__image img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
::ng-deep.dashcheck__content, ::ng-deep.dashcheck__activecontent {
  text-align: center;
  background-color: #f1f1f2;
  padding: 20px 30px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::ng-deep.dashcheck__content h3,
::ng-deep.dashcheck__content h6, ::ng-deep.dashcheck__activecontent h3,
::ng-deep.dashcheck__activecontent h6 {
  font-weight: bold;
}
::ng-deep.dashcheck__content *:not(i), ::ng-deep.dashcheck__activecontent *:not(i) {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
::ng-deep.dashcheck__activecontent {
  background-color: #fff;
}
::ng-deep.dashcheck__time {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}
::ng-deep.dashcheck__time i:not(:last-child) {
  margin-right: 3px;
}
::ng-deep.dashcheck__time h6 {
  font-size: inherit;
}
::ng-deep.dashcheck__button {
  display: none;
  margin-top: 20px;
}
::ng-deep.dashcheck__button .fbtn {
  width: 100%;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 700;
  border-radius: 5px;
  text-transform: uppercase;
}
::ng-deep.dashcheck__button .fbtn i {
  margin-right: 7px;
}
::ng-deep.dashcheck__dots {
  --size: 38px;
  --sizeHalf: (var(--size) / 2);
  --shadowSize: 14px;
  margin-block-start: 30px;
  margin-block-end: 60px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.dashcheck__dots {
    --size: 26px;
    --shadowSize: 8px;
  }
}
::ng-deep.dashcheck__dots .dashcheck__col {
  position: relative;
}
::ng-deep.dashcheck__dots .dashcheck__col:not(:last-child)::before {
  content: "";
  position: absolute;
  top: 50%;
  left: calc(50% + var(--sizeHalf));
  transform: translateY(-50%);
  width: calc(100% - var(--size));
  height: 1px;
  background-color: #f1f1f2;
}
::ng-deep.dashcheck__dots .dashcheck__col--active:not(:last-child)::before {
  background-color: rgb(105, 190, 40);
}
::ng-deep.dashcheck__dots .dashcheck__col--active .dashcheck__dot {
  background-color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
  box-shadow: 0 0 0 var(--shadowSize) #fff, 0 0 0 calc(var(--shadowSize) + 1px) rgb(105, 190, 40);
}
::ng-deep.dashcheck__dot {
  width: var(--size);
  height: var(--size);
  border: 1px solid #f1f1f2;
  border-radius: 50%;
  margin-inline: auto;
  position: relative;
  z-index: 1;
}
::ng-deep.dashcheck__dot svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 17px;
}

@media only screen and (max-width: 767px) {
  ::ng-deep.presenter .fn-col {
    width: 100%;
  }
}
::ng-deep.presenter__item {
  border: 1px solid #f1f1f2;
  padding: 20px;
  border-radius: 5px;
  height: 100%;
}
::ng-deep.presenter__item + div {
  margin-top: 30px;
}
::ng-deep.presenter__item h2 {
  border-bottom: 1px solid #f1f1f2;
  padding-bottom: 10px;
}
::ng-deep.presenter__content:not(:last-child) {
  margin-bottom: 15px;
}
::ng-deep.presenter__content ul:not(:last-child) {
  margin-bottom: 10px;
}
::ng-deep.presenter__content ul:not(.presenter__address) {
  padding-left: 0;
}
::ng-deep.presenter__content ul.custom-list li::before {
  background-color: #6d6e71;
}
::ng-deep.presenter__content li {
  list-style: none;
}
::ng-deep.presenter__content li:not(:last-child) {
  margin-bottom: 4px;
}
::ng-deep.presenter__content p,
::ng-deep.presenter__content li {
  font-size: 15px;
}
::ng-deep.presenter__address--spc {
  margin: 0 auto !important;
  width: 100%;
  max-width: 130px;
}
::ng-deep.presenter__address li {
  list-style: none;
  color: #6d6e71;
}
::ng-deep.presenter__address li a {
  color: inherit;
}
::ng-deep.presenter__address li i {
  margin-right: 7px;
  color: #f1f1f2;
  font-size: 18px;
}
::ng-deep.presenter__broughtby {
  display: inline-block;
  width: 100%;
  margin: 20px 0 0;
  text-align: center;
}
::ng-deep.presenter__broughtby img {
  min-width: 250px;
  max-width: 250px !important;
}
::ng-deep.presenter .fn-btn {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border-radius: 3px;
}

::ng-deep .footer {
  position: fixed;
  margin-left: auto;
}
@media screen and (min-width: 769px) {
  ::ng-deep .footer {
    width: calc(100% - 220px);
  }
}

::ng-deep .all-learner-maps.lm-an-cards {
  display: none;
  justify-content: center;
  flex-wrap: wrap;
}
::ng-deep .all-learner-maps .car-small-heading {
  color: #fff;
}
::ng-deep .all-learner-maps .practioner-dash-wrap--ss {
  background: #F1F1F2;
  border-radius: 6px;
  color: #fff;
  padding: 30px 38px;
}
::ng-deep .all-learner-maps .product-imitation {
  background-color: #fff;
  color: #676a6c;
}

::ng-deep .unliked-profile .profile_types {
  width: 35px !important;
  height: 16px !important;
}

::ng-deep .lmslider__notes {
  padding-top: 0px;
}
::ng-deep .lmslider__notes > h3 {
  text-transform: capitalize;
}

.ig-right {
  width: 25%;
  justify-content: flex-start;
  align-items: flex-end;
}

.breadcrumb li strong span {
  cursor: pointer;
}

::ng-deep .modal-body .expire-form p {
  padding-bottom: 60px;
}

::ng-deep .modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1050;
  display: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  outline: 0;
}
::ng-deep .modal-title {
  float: none !important;
}
::ng-deep .modal.show {
  display: block !important;
}
::ng-deep .modal.grey {
  background: rgba(236, 236, 236, 0.9);
}
::ng-deep .modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
::ng-deep .modal.fade.in {
  opacity: 1;
}
::ng-deep .modal.in .modal-dialog {
  transform: translate(0, 0);
}
::ng-deep .modal.modal-open {
  overflow-x: hidden;
  overflow-y: auto;
}
::ng-deep .modal .modal-dialog {
  position: relative;
  width: auto;
  margin: 10px;
}
@media (min-width: 768px) {
  ::ng-deep .modal .modal-dialog {
    width: 600px;
    margin: 30px auto;
  }
}
::ng-deep .modal .modal-dialog .modal-content {
  background-clip: padding-box;
  background-color: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  outline: 0 none;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .all_guides {
  border: 1px solid #e5e5e5;
}
::ng-deep .modal .modal-dialog .modal-content .close {
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
  opacity: 0.2;
}
::ng-deep .modal .modal-dialog .modal-content .close:focus-visible {
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  appearance: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body {
  padding: 20px 30px 0px 30px;
  position: relative;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text] {
  width: 100%;
  color: inherit;
  display: block;
  font-size: 14px;
  line-height: 1.4;
  padding: 6px 12px;
  border-radius: 1px;
  background-image: none;
  background-color: #fff;
  border: 1px solid #e5e6e7;
  transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text]::-webkit-input-placeholder {
  color: #999;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text]:focus, ::ng-deep .modal .modal-dialog .modal-content .modal-body form input[type=text]:focus-visible {
  border-color: #1ab394;
  outline: none;
}
::ng-deep .modal .modal-dialog .modal-content .modal-body.no-pad {
  padding: 0;
}
::ng-deep .modal .f-btn {
  color: #fff;
  font-size: 14px;
  border-color: #73BF38;
  background-color: #73BF38;
}
::ng-deep .modal .f-btn:hover {
  border-color: #4cae4c;
  background-color: #4cae4c;
}
::ng-deep .modal .f-btn--dngr {
  color: #fff;
  border-color: #ED5565;
  background-color: #ED5565;
}
::ng-deep .modal .f-btn--dngr:hover {
  border-color: #ec4758;
  background-color: #ec4758;
}
::ng-deep .modal .f-btn--info {
  color: #fff;
  font-size: 12px;
  line-height: 1.5;
  padding: 5px 10px;
  border-color: #23c6c8;
  background-color: #23c6c8;
}
::ng-deep .modal .f-btn--info:hover {
  border-color: #21b9bb;
  background-color: #21b9bb;
}
::ng-deep .modal .f-btn--wrng {
  color: #fff;
  border-color: #f8ac59;
  background-color: #f8ac59;
}
::ng-deep .modal .f-btn--wrng:hover {
  border-color: #f7a54a;
  background-color: #f7a54a;
}
::ng-deep .modal .hidden {
  display: none;
}

::ng-deep.modal-open {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-profile/custom-profile.component.scss","webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/custom-profile/interpretive-guide/interpretive-guide.component.scss","webpack://./src/app/components/fs-profile/fs-profile.component.scss","webpack://./src/app/components/dashboard/dashboard.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACgIhB;EACE,eAAA;AD5HF;;AC+HA;EACE,aAAA;EACA,eAAA;AD5HF;;AC+HA;EACE,sBAAA;AD5HF;;AC+HA;EACE,8BAAA;AD5HF;;AC+HA;EACE,gBAAA;AD5HF;;AC+HA;EACE,gBAAA;AD5HF;;AC+HA;EACE,aAAA;AD5HF;;AC+HA;EACE,gBAAA;AD5HF;;AC0IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ADvIJ;ACyII;;;;;;EACE,gBAAA;ADlIN;ACsIE;;EAEE,eA5GO;EA6GP,gBA3GO;ADzBX;ACsII;EALF;;IAMI,eA/GY;EDnBhB;AACF;ACqIE;;EAEE,eAlHO;EAmHP,gBAjHO;ADlBX;ACqII;EALF;;IAMI,eArHY;EDZhB;AACF;ACoIE;;EAEE,eAxHO;EAyHP,gBAvHO;ADXX;ACoII;EALF;;IAMI,eA3HY;EDLhB;AACF;ACmIE;;EAEE,eA9HO;EA+HP,gBA7HO;ADJX;ACoIE;;EAEE,eAhIO;EAiIP,gBAhIO;ADFX;ACqIE;;EAEE,eAnIO;EAoIP,gBAnIO;ADAX;ACyIE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ADvIJ;ACyII;EACE,gBAAA;ADvIN;AC0II;EAXF;IAYI,eAAA;EDvIJ;AACF;AC0IE;;EAEE,UAAA;EACA,SAAA;ADxIJ;AC2IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;ADzIJ;;AC6IA;EACE,sBAxNQ;AD8EV;;AC6IA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AD1IF;AC4IE;EALF;IAMI,cAAA;EDzIF;AACF;AC2IE;EACE,iBA1Ka;ADiCjB;AC4IE;EACE,gBApLa;EAqLb,WAAA;AD1IJ;;AC+IE;EACE,kBAAA;AD5IJ;AC+IE;EACE,iBAAA;AD7IJ;;ACkJE;EACE,aAAA;AD/IJ;;ACmJA;EACE,kBAAA;ADhJF;ACkJE;EACE,mBAAA;ADhJJ;ACoJI;EACE,sBAAA;ADlJN;ACsJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;AD0EnB;ACsJI;EACE,sBAAA;ADpJN;ACuJI;EAVF;IAWI,eApOoB;EDgFxB;AACF;ACuJE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ADrJJ;ACuJI;EACE,sBAAA;ADrJN;ACwJI;EACE,WAAA;ADtJN;ACyJI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ADqMZ;;AC4JA;EACE,mBA1PO;ADiGT;AC2JE;EAHF;IAII,mBAAA;EDxJF;AACF;AC0JE;EACE,mBAAA;ADxJJ;AC2JE;EACE,aArQK;AD4GT;AC2JI;EAHF;IAII,aAAA;EDxJJ;AACF;AC0JI;EACE,aAAA;ADxJN;;AC6JA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AD1JF;AC4JE;EACE,eAAA;AD1JJ;AC6JE;EACE,sCAAA;AD3JJ;AC8JE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AD5JJ;;AC2KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ADxKJ;AC0KI;EACE,kBAAA;ADxKN;AC2KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;ADzKN;;AC8KA;EACE,8BAAA;AD3KF;;AC8KA;EACE,8BAAA;AD3KF;;AC8KA;EACE,+BAAA;AD3KF;;AC8KA;EACE,8BAAA;AD3KF;;AC8KA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AD3KF;AC6KE;EACE,2BAAA;EACA,mBAAA;AD3KJ;AC8KE;EACE,yBAzbiB;EA0bjB,WA1aO;AD8PX;AC+KE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AD7KJ;ACgLE;EACE,yBAjckB;EAkclB,cArciB;ADuRrB;ACiLE;EACE,yBAvbS;EAwbT,WA1bO;AD2QX;ACiLI;EACE,6BAAA;AD/KN;;ACoLA;EACE;IACE,uBAAA;EDjLF;ECoLA;IACE,yBAAA;EDlLF;AACF;ACqLA;EACE,8BAAA;ADnLF;;ACsLA;EACE,8BAAA;ADnLF;;ACsLA;EACE,+BAAA;ADnLF;;ACsLA;EACE,8BAAA;ADnLF;;ACsLA;EACE,qBAAA;ADnLF;;ACsLA;EACE,UAAA;ADnLF;ACqLE;EACE,qBAAA;ADnLJ;;ACuLA;EACE,UAAA;ADpLF;;ACwLE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ADtLJ;ACyLM;EACE,mBAAA;ADvLR;AC4LE;EACE,2BAAA;AD1LJ;AC6LE;EACE,uBAAA;AD3LJ;AC8LE;EACE,mBAAA;AD5LJ;;ACiME;EACE,mBAAA;AD9LJ;ACiME;EACE,yBAAA;AD/LJ;ACkME;EACE,sBAAA;ADhMJ;ACmME;EACE,uBAAA;ADjMJ;ACoME;EACE,oBAAA;ADlMJ;;AClRA;EACE,eAAA;ADqRF;;AClRA;EACE,aAAA;EACA,eAAA;ADqRF;;AClRA;EACE,sBAAA;ADqRF;;AClRA;EACE,8BAAA;ADqRF;;AClRA;EACE,gBAAA;ADqRF;;AClRA;EACE,gBAAA;ADqRF;;AClRA;EACE,aAAA;ADqRF;;AClRA;EACE,gBAAA;ADqRF;;ACvQE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AD0QJ;ACxQI;;;;;;EACE,gBAAA;AD+QN;AC3QE;;EAEE,eA5GO;EA6GP,gBA3GO;ADwXX;AC3QI;EALF;;IAMI,eA/GY;ED8XhB;AACF;AC5QE;;EAEE,eAlHO;EAmHP,gBAjHO;AD+XX;AC5QI;EALF;;IAMI,eArHY;EDqYhB;AACF;AC7QE;;EAEE,eAxHO;EAyHP,gBAvHO;ADsYX;AC7QI;EALF;;IAMI,eA3HY;ED4YhB;AACF;AC9QE;;EAEE,eA9HO;EA+HP,gBA7HO;AD6YX;AC7QE;;EAEE,eAhIO;EAiIP,gBAhIO;AD+YX;AC5QE;;EAEE,eAnIO;EAoIP,gBAnIO;ADiZX;ACxQE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AD0QJ;ACxQI;EACE,gBAAA;AD0QN;ACvQI;EAXF;IAYI,eAAA;ED0QJ;AACF;ACvQE;;EAEE,UAAA;EACA,SAAA;ADyQJ;ACtQE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;ADwQJ;;ACpQA;EACE,sBAxNQ;AD+dV;;ACpQA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;ADuQF;ACrQE;EALF;IAMI,cAAA;EDwQF;AACF;ACtQE;EACE,iBA1Ka;ADkbjB;ACrQE;EACE,gBApLa;EAqLb,WAAA;ADuQJ;;AClQE;EACE,kBAAA;ADqQJ;AClQE;EACE,iBAAA;ADoQJ;;AC/PE;EACE,aAAA;ADkQJ;;AC9PA;EACE,kBAAA;ADiQF;AC/PE;EACE,mBAAA;ADiQJ;AC7PI;EACE,sBAAA;AD+PN;AC3PE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;AD2dnB;AC3PI;EACE,sBAAA;AD6PN;AC1PI;EAVF;IAWI,eApOoB;EDiexB;AACF;AC1PE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;AD4PJ;AC1PI;EACE,sBAAA;AD4PN;ACzPI;EACE,WAAA;AD2PN;ACxPI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ADslBZ;;ACrPA;EACE,mBA1PO;ADkfT;ACtPE;EAHF;IAII,mBAAA;EDyPF;AACF;ACvPE;EACE,mBAAA;ADyPJ;ACtPE;EACE,aArQK;AD6fT;ACtPI;EAHF;IAII,aAAA;EDyPJ;AACF;ACvPI;EACE,aAAA;ADyPN;;ACpPA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;ADuPF;ACrPE;EACE,eAAA;ADuPJ;ACpPE;EACE,sCAAA;ADsPJ;ACnPE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;ADqPJ;;ACtOE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ADyOJ;ACvOI;EACE,kBAAA;ADyON;ACtOI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;ADwON;;ACnOA;EACE,8BAAA;ADsOF;;ACnOA;EACE,8BAAA;ADsOF;;ACnOA;EACE,+BAAA;ADsOF;;ACnOA;EACE,8BAAA;ADsOF;;ACnOA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;ADsOF;ACpOE;EACE,2BAAA;EACA,mBAAA;ADsOJ;ACnOE;EACE,yBAzbiB;EA0bjB,WA1aO;AD+oBX;AClOE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;ADoOJ;ACjOE;EACE,yBAjckB;EAkclB,cArciB;ADwqBrB;AChOE;EACE,yBAvbS;EAwbT,WA1bO;AD4pBX;AChOI;EACE,6BAAA;ADkON;;AC7NA;EACE;IACE,uBAAA;EDgOF;EC7NA;IACE,yBAAA;ED+NF;AACF;AC5NA;EACE,8BAAA;AD8NF;;AC3NA;EACE,8BAAA;AD8NF;;AC3NA;EACE,+BAAA;AD8NF;;AC3NA;EACE,8BAAA;AD8NF;;AC3NA;EACE,qBAAA;AD8NF;;AC3NA;EACE,UAAA;AD8NF;AC5NE;EACE,qBAAA;AD8NJ;;AC1NA;EACE,UAAA;AD6NF;;ACzNE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;AD2NJ;ACxNM;EACE,mBAAA;AD0NR;ACrNE;EACE,2BAAA;ADuNJ;ACpNE;EACE,uBAAA;ADsNJ;ACnNE;EACE,mBAAA;ADqNJ;;AChNE;EACE,mBAAA;ADmNJ;AChNE;EACE,yBAAA;ADkNJ;AC/ME;EACE,sBAAA;ADiNJ;AC9ME;EACE,uBAAA;ADgNJ;AC7ME;EACE,oBAAA;AD+MJ;;AE1xBE;EAEE,uBAAA;EACA,mBAAA;AF4xBJ;AE1xBI;EACE,sBAAA;AF4xBN;AExxBE;EAEE,eAAA;AFyxBJ;AEvxBI;EACE,mBAAA;AFyxBN;AElxBY;EACE,aAAA;AFoxBd;AE9wBM;EACE,2BAAA;AFgxBR;AEzwBY;EACE,UAAA;EACA,kCAAA;AF2wBd;AErwBM;EACE,iBAAA;AFuwBR;AErwBQ;EAHF;IAII,0BAAA;EFwwBR;AACF;AEpwBQ;EADF;IAEI,UAAA;EFuwBR;AACF;AElwBQ;EADF;IAEI,UAAA;EFqwBR;AACF;AEhwBI;EACE,kBAAA;AFkwBN;AEhwBM;EACE,UAAA;AFkwBR;AEhwBQ;EAHF;IAII,WAAA;EFmwBR;EEjwBQ;IACE,mBAAA;EFmwBV;AACF;AE/vBM;EACE,UAAA;AFiwBR;AE/vBQ;EAHF;IAII,WAAA;EFkwBR;AACF;AE7vBE;EAEE,gBAAA;EACA,WAAA;EACA,mBAAA;AF8vBJ;AE3vBI;EAPF;IAQI,YAAA;EF8vBJ;AACF;AE5vBI;EACE,kBAAA;EACA,oBAAA;AF8vBN;AE5vBM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,mCAAA;EACA,UAAA;EACA,YAAA;EACA,6FAAA;AF8vBR;AE5vBQ;EAVF;IAWI,aAAA;EF+vBR;AACF;AE5vBM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,iCAAA;EACA,WAAA;EACA,WAAA;EACA,6FAAA;AF8vBR;AE5vBQ;EAVF;IAWI,aAAA;EF+vBR;AACF;AE5vBM;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AF8vBR;AE1vBI;EACE,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AF4vBN;AEvvBE;EACE,cAAA;EACA,mBAAA;AFyvBJ;AEvvBI;EACE,gBAAA;AFyvBN;;AElvBE;EACE,yBD5IiB;EC6IjB,aAAA;AFqvBJ;AEnvBI;EAJF;IAKI,aAAA;EFsvBJ;AACF;AEpvBI;EACE,WDpIK;AD03BX;AEpvBM;EAHF;IAII,0BAAA;EFuvBN;AACF;AEpvBI;EACE,WD5IK;EC6IL,mBAAA;EACA,wEDtMO;ECuMP,gBAAA;AFsvBN;AEnvBI;EACE,WDnJK;ADw4BX;AEjvBE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;AFmvBJ;AEjvBI;EALF;IAMI,gBAAA;EFovBJ;AACF;AElvBI;EACE,cDhLmB;ADo6BzB;AEjvBI;EACE,YAAA;EACA,mBAAA;EACA,cAAA;AFmvBN;AE/uBM;EADF;IAEI,8BAAA;EFkvBN;AACF;;AE1uBE;EACE,mBAAA;AF6uBJ;AE3uBI;EACE,YAAA;AF6uBN;AEzuBE;EACE,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AF2uBJ;AExuBI;EATF;IAUI,gBAAA;IACA,SAAA;IACA,WAAA;EF2uBJ;AACF;AEtuBI;EAEE,gBAAA;AFuuBN;AEruBM;EAEE;IACE,gBAAA;EFsuBR;AACF;AEnuBM;EACE,2BAAA;AFquBR;AEluBM;EAEE,kBAAA;EACA,0BAAA;AFmuBR;AEjuBQ;EALF;IAMI,aAAA;EFouBR;AACF;AEluBQ;EACE,mCAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,UAAA;AFouBV;AEluBU;EARF;IASI,6BAAA;EFquBV;AACF;AEnuBU;EACE,sCAAA;AFquBZ;AEnuBY;EAHF;IAII,0BAAA;EFsuBZ;AACF;AEhuBU;EAFF;IAGI,yBAAA;EFmuBV;AACF;AE/tBU;EADF;IAEI,WAAA;EFkuBV;EEhuBU;IACE,mBAAA;EFkuBZ;AACF;AE5tBI;EACE,WDhRK;AD8+BX;AE3tBI;EACE,wED5UO;EC6UP,eD/OK;ECgPL,WDtRK;ECuRL,gBAAA;EACA,mBAAA;AF6tBN;AE3tBM;EAPF;IAQI,eDpPU;EDk9BhB;AACF;AEztBM;EACE,wBAAA;AF2tBR;AEvtBU;EAFF;IAGI,WAAA;EF0tBV;EExtBU;IACE,2BAAA;EF0tBZ;AACF;AEttBQ;EACE,wBAAA;AFwtBV;AEjtBM;EACE,yBDxUa;AD2hCrB;AE/sBI;EACE,wBAAA;EACA,oCAAA;AFitBN;AE7sBQ;EACE,eAAA;AF+sBV;AE1sBI;EACE,eAAA;AF4sBN;;AEpsBE;EACE,mBAAA;AFusBJ;AErsBI;EACE,cAAA;AFusBN;AElsBM;EAFF;IAGI,aAAA;EFqsBN;EEnsBM;IACE,cAAA;EFqsBR;AACF;AEjsBI;EACE,6BAAA;AFmsBN;AEhsBI;EACE,kBAAA;EACA,WDzWK;EC0WL,mCAAA;EACA,mBAAA;EACA,oBAAA;AFksBN;AEhsBM;EAPF;IAQI,mBAAA;IACA,oBAAA;IACA,uBAAA;IAAA,kBAAA;EFmsBN;AACF;AE7rBI;EAEE;IACE,+BAAA;IACA,gBAAA;IACA,iBAAA;EF8rBN;AACF;;AEprBI;EAFF;IAGI,UAAA;EFwrBJ;AACF;AErrBE;EAEE,sBD/YO;ECgZP,YAAA;EACA,aAAA;AFsrBJ;AEprBI;EACE,wBAAA;EACA,sBAAA;AFsrBN;AEjrBM;EACE,eAAA;AFmrBR;;AEzqBI;EACE,mBAAA;AF4qBN;AEzqBI;EACE,eAAA;EACA,WAAA;AF2qBN;AErqBI;EAFF;IAGI,UAAA;EFwqBJ;AACF;AErqBE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AFuqBJ;AErqBI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AFuqBN;AEpqBI;EACE,kBAAA;EACA,mBAAA;AFsqBN;;AEjqBA;EACE,yBAAA;AFoqBF;AEjqBI;EADF;IAEI,WAAA;EFoqBJ;AACF;AEjqBE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;AFmqBJ;AEjqBI;EACE,6BAAA;EACA,gCAAA;EACA,cDzee;EC0ef,eDhcK;ECicL,wBD9gBK;EC+gBL,kBAAA;EACA,SAAA;EACA,OAAA;AFmqBN;AE/pBE;EACE,wBAAA;EACA,mBAAA;AFiqBJ;AE9pBM;EACE,eAAA;AFgqBR;AE5pBI;EACE,mBAAA;AF8pBN;AE3pBI;EACE,kBAAA;EACA,gBAAA;AF6pBN;;AExpBA;EACE,aAAA;EACA,gCAAA;AF2pBF;;AExpBA;EACE,gBAAA;EACA,6CAAA;AF2pBF;;AExpBA;EACE,WAAA;AF2pBF;;AEtpBE;EACE,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,mBAAA;EACA,UAAA;AFypBJ;AEppBI;EACE,YAAA;EACA,uBAAA;EACA,UAAA;EACA,sBAAA;AFspBN;AElpBE;EACE,UAAA;EACA,gBAAA;EACA,kCAAA;EACA,kBAAA;AFopBJ;AEjpBE;EACE,gBAAA;AFmpBJ;AEjpBI;EACE,iBAAA;AFmpBN;AE/oBE;EACE,oBAAA;AFipBJ;AE/oBI;EACE,qBAAA;EACA,UAAA;AFipBN;AE9oBI;EACE,oBAAA;EACA,YAAA;AFgpBN;AE5oBE;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AF8oBJ;AE5oBI;EACE,aAAA;AF8oBN;AE5oBM;EACE,yBAAA;AF8oBR;AE1oBM;EACE,mBAAA;EACA,oBAAA;AF4oBR;;AEtoBA;EACE,WAAA;AFyoBF;AEvoBE;EACE,eAAA;AFyoBJ;;AEroBA;EACE,oBAAA;AFwoBF;;AEpoBE;EACE,eAAA;AFuoBJ;AEloBI;EACE,mBAAA;AFooBN;AEjoBI;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;AFmoBN;AEjoBM;EACE,iBAAA;EACA,WAAA;AFmoBR;;AE7nBA;EACE,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;AFgoBF;AE9nBE;EACE,kBAAA;EACA,YAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AFgoBJ;AE9nBI;EATF;IAUI,QAAA;EFioBJ;AACF;;AE7nBA;EACC,aAAA;AFgoBD;;AE7nBA;;gBAAA;AAYI;EACE,SAAA;AFunBN;;AG70CA,4BAAA;AFgIA;EACE,eAAA;ADitCF;;AC9sCA;EACE,aAAA;EACA,eAAA;ADitCF;;AC9sCA;EACE,sBAAA;ADitCF;;AC9sCA;EACE,8BAAA;ADitCF;;AC9sCA;EACE,gBAAA;ADitCF;;AC9sCA;EACE,gBAAA;ADitCF;;AC9sCA;EACE,aAAA;ADitCF;;AC9sCA;EACE,gBAAA;ADitCF;;ACnsCE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ADssCJ;ACpsCI;;;;;;EACE,gBAAA;AD2sCN;ACvsCE;;EAEE,eA5GO;EA6GP,gBA3GO;ADozCX;ACvsCI;EALF;;IAMI,eA/GY;ED0zChB;AACF;ACxsCE;;EAEE,eAlHO;EAmHP,gBAjHO;AD2zCX;ACxsCI;EALF;;IAMI,eArHY;EDi0ChB;AACF;ACzsCE;;EAEE,eAxHO;EAyHP,gBAvHO;ADk0CX;ACzsCI;EALF;;IAMI,eA3HY;EDw0ChB;AACF;AC1sCE;;EAEE,eA9HO;EA+HP,gBA7HO;ADy0CX;ACzsCE;;EAEE,eAhIO;EAiIP,gBAhIO;AD20CX;ACxsCE;;EAEE,eAnIO;EAoIP,gBAnIO;AD60CX;ACpsCE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ADssCJ;ACpsCI;EACE,gBAAA;ADssCN;ACnsCI;EAXF;IAYI,eAAA;EDssCJ;AACF;ACnsCE;;EAEE,UAAA;EACA,SAAA;ADqsCJ;AClsCE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;ADosCJ;;AChsCA;EACE,sBAxNQ;AD25CV;;AChsCA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;ADmsCF;ACjsCE;EALF;IAMI,cAAA;EDosCF;AACF;AClsCE;EACE,iBA1Ka;AD82CjB;ACjsCE;EACE,gBApLa;EAqLb,WAAA;ADmsCJ;;AC9rCE;EACE,kBAAA;ADisCJ;AC9rCE;EACE,iBAAA;ADgsCJ;;AC3rCE;EACE,aAAA;AD8rCJ;;AC1rCA;EACE,kBAAA;AD6rCF;AC3rCE;EACE,mBAAA;AD6rCJ;ACzrCI;EACE,sBAAA;AD2rCN;ACvrCE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ADu5CnB;ACvrCI;EACE,sBAAA;ADyrCN;ACtrCI;EAVF;IAWI,eApOoB;ED65CxB;AACF;ACtrCE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ADwrCJ;ACtrCI;EACE,sBAAA;ADwrCN;ACrrCI;EACE,WAAA;ADurCN;ACprCI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ADkhDZ;;ACjrCA;EACE,mBA1PO;AD86CT;AClrCE;EAHF;IAII,mBAAA;EDqrCF;AACF;ACnrCE;EACE,mBAAA;ADqrCJ;AClrCE;EACE,aArQK;ADy7CT;AClrCI;EAHF;IAII,aAAA;EDqrCJ;AACF;ACnrCI;EACE,aAAA;ADqrCN;;AChrCA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;ADmrCF;ACjrCE;EACE,eAAA;ADmrCJ;AChrCE;EACE,sCAAA;ADkrCJ;AC/qCE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;ADirCJ;;AClqCE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ADqqCJ;ACnqCI;EACE,kBAAA;ADqqCN;AClqCI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;ADoqCN;;AC/pCA;EACE,8BAAA;ADkqCF;;AC/pCA;EACE,8BAAA;ADkqCF;;AC/pCA;EACE,+BAAA;ADkqCF;;AC/pCA;EACE,8BAAA;ADkqCF;;AC/pCA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;ADkqCF;AChqCE;EACE,2BAAA;EACA,mBAAA;ADkqCJ;AC/pCE;EACE,yBAzbiB;EA0bjB,WA1aO;AD2kDX;AC9pCE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;ADgqCJ;AC7pCE;EACE,yBAjckB;EAkclB,cArciB;ADomDrB;AC5pCE;EACE,yBAvbS;EAwbT,WA1bO;ADwlDX;AC5pCI;EACE,6BAAA;AD8pCN;;ACzpCA;EACE;IACE,uBAAA;ED4pCF;ECzpCA;IACE,yBAAA;ED2pCF;AACF;ACxpCA;EACE,8BAAA;AD0pCF;;ACvpCA;EACE,8BAAA;AD0pCF;;ACvpCA;EACE,+BAAA;AD0pCF;;ACvpCA;EACE,8BAAA;AD0pCF;;ACvpCA;EACE,qBAAA;AD0pCF;;ACvpCA;EACE,UAAA;AD0pCF;ACxpCE;EACE,qBAAA;AD0pCJ;;ACtpCA;EACE,UAAA;ADypCF;;ACrpCE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ADupCJ;ACppCM;EACE,mBAAA;ADspCR;ACjpCE;EACE,2BAAA;ADmpCJ;AChpCE;EACE,uBAAA;ADkpCJ;AC/oCE;EACE,mBAAA;ADipCJ;;AC5oCE;EACE,mBAAA;AD+oCJ;AC5oCE;EACE,yBAAA;AD8oCJ;AC3oCE;EACE,sBAAA;AD6oCJ;AC1oCE;EACE,uBAAA;AD4oCJ;ACzoCE;EACE,oBAAA;AD2oCJ;;AGxtDA;EACE,qCAAA;EACA,8EAAA;EACA,iSAAA;EACA,mBAAA;EACA,kBAAA;AH2tDF;AG9sDA,sDAAA;AA2CA;EAIE,UAAA;EACA,sBAAA;EACA,oBAAA;EAEA,iDAAA;EAcA,oCAAA;EAEA,oCAAA;EAWA,gCAAA;EA+BA,gCAAA;EA4BA,kCAAA;EAiBA,iCAAA;EA0BA,iCAAA;EAiCA,kCAAA;EAqDA,oCAAA;EAsDA,wCAAA;EAEA,qCAAA;EA0DA,mCAAA;AHq2CF;AG7pDE;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AH+pDJ;AG3pDE;EACE,cAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EAEA,SAAA;EACA,QAAA;AH4pDJ;AGzpDE;EAEE;IACE,kBAAA;EH0pDJ;AACF;AGvpDE;EACE,4BAAA;EACA,yBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;AHypDJ;AGtpDE;EACE,2BAAA;AHwpDJ;AGppDE;EACE,cAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AHspDJ;AGppDI;EAEE,2BAAA;AHspDN;AGlpDE;EACE,yBAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;AHopDJ;AGjpDE;EACE,0BAAA;AHmpDJ;AG/oDE;EACE,eAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;AHipDJ;AG9oDE;EACE,kBAAA;EACA,YAAA;EACA,YAAA;AHgpDJ;AG5oDE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AH8oDJ;AG3oDE;EACE,kBAAA;EACA,SAAA;EACA,oCAAA;EACA,UAAA;AH6oDJ;AG1oDE;EACE,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,UAAA;AH4oDJ;AGxoDE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EAIA,gBAAA;AHuoDJ;AGpoDE;EACE,kBAAA;EACA,OAAA;EACA,eAAA;AHsoDJ;AGnoDE;EACE,UAAA;AHqoDJ;AGloDE;EACE,aAAA;AHooDJ;AGhoDE;EACE,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AHkoDJ;AGhoDI;EACE,aAAA;AHkoDN;AG9nDE;;;;EAIE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,8BAAA;GHgoDF,iEG/nDE;AHgoDJ;AG3mDE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AH6mDJ;AG1mDE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EAGA,2BAAA;EACA,oBAAA;EACA,gBAAA;EACA,+CAAA;AH4mDJ;AGzmDE;EACE,0BAAA;EACA,sBAAA;AH2mDJ;AGxmDE;EACE,0BAAA;EACA,yBAAA;EACA,sBAAA;AH0mDJ;AGvmDE;EACE,0BAAA;EACA,yBAAA;EACA,sBAAA;AHymDJ;AGtmDE;EACE,0BAAA;EACA,yBAAA;EACA,sBAAA;AHwmDJ;AGlmDE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AHomDJ;AGjmDE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AHmmDJ;AGhmDE;EACE,gBAAA;AHkmDJ;AG/lDE;EACE,gBAAA;AHimDJ;AG9lDE;EACE,gBAAA;AHgmDJ;AG7lDE;EACE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,oCAAA;AH+lDJ;AG5lDE;EACE,kBAAA;EAGA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;AH8lDJ;AG3lDE;;;EAGE,WAAA;AH6lDJ;AG1lDE;;;EAGE,YAAA;AH4lDJ;AGvlDE;EACE,cAAA;AHylDJ;AGtlDE;EACE,aAAA;AHwlDJ;AGrlDE;EACE,yBAAA;AHulDJ;AGplDE;EACE,wBAAA;AHslDJ;AGnlDE;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;AHqlDJ;AGllDE;;;;EAIE,8BAAA;AHolDJ;AGjlDE;EACE;IACE,gBAAA;IACA,kBAAA;EHmlDJ;EGhlDE;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;EHklDJ;EG/kDE;;;;IAIE,8BAAA;EHilDJ;EG9kDE;IACE,aAAA;IACA,eAAA;EHglDJ;EG7kDE;;;IAGE,eAAA;EH+kDJ;EG5kDE;IACE,UAAA;EH8kDJ;EG3kDE;IACE,aAAA;EH6kDJ;EG1kDE;IACE,cAAA;EH4kDJ;AACF;AGzkDE;EACE;IACE,aAAA;EH2kDJ;EGzkDI;IACE,aAAA;IACA,mBAAA;EH2kDN;EGxkDI;IACE,eAAA;EH0kDN;EGvkDI;IACE,QAAA;EHykDN;EGtkDI;IACE,WAAA;EHwkDN;EGnjDE;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;EHqjDJ;EGnjDI;IACE,sBAAA;IACA,uBAAA;EHqjDN;EGjjDE;;;;IAIE,8BAAA;EHmjDJ;EGjjDI;;;;IACE,yCAAA;EHsjDN;EGljDE;IACE,eAAA;EHojDJ;EGjjDE;IAKE,sCAAA;EHmjDJ;AACF;AGhjDE;EACE;IACE,gBAAA;EHkjDJ;EG/iDE;IACE,WAAA;EHijDJ;EG9iDE;;;;IAIE,8BAAA;EHgjDJ;AACF;AG7iDE;EACE;IACE,aAAA;IACA,eAAA;EH+iDJ;EG5iDE;;;IAGE,eAAA;EH8iDJ;EG3iDE;;;;IAIE,UAAA;EH6iDJ;EG1iDE;IACE,UAAA;EH4iDJ;AACF;;AGxiDA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,cF9jBmB;EE+jBnB,kBAAA;AH2iDF;AGziDE;EACE,6BAAA;AH2iDJ;;AGviDA;EAEE,mBAAA;AHyiDF;AGviDE;EAJF;IAKI,SAAA;IACA,WAAA;EH0iDF;EGxiDE;;IAEE,WAAA;EH0iDJ;AACF;;AGriDA;EAEE;IACE,sBAAA;IACA,uBAAA;IACA,0BAAA;EHuiDF;EGpiDA;;;;IAIE,yCAAA;EHsiDF;AACF;AGniDA;;EAEE,aAAA;EACA,gBAAA;EACA,WAAA;AHqiDF;;AGliDA;EACE,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AHqiDF;;AGliDA;EACE,gBAAA;EACA,WAAA;EACA,4BAAA;EACA,yBAAA;AHqiDF;;AGliDA;EACE,gBFzlBiB;AD8nEnB;;AGliDA;EACE,UAAA;AHqiDF;;AGliDA;EACE,uBAAA;AHqiDF;;AGliDA;;EAEE,kBAAA;AHqiDF;;AGliDA;EACE,eAAA;EACA,gBAAA;AHqiDF;;AGliDA;;EAEE,kBAAA;AHqiDF;;AGliDA;EACE,eAAA;EACA,iBAAA;AHqiDF;;AGliDA;EACE,6CAAA;EACA,iDAAA;AHqiDF;;AGliDA;EACE,wBAAA;EACA,0BAAA;EACA,mBAAA;AHqiDF;;AGliDA;;EAEE,kCAAA;AHqiDF;;AGliDA;EACE,eAAA;AHqiDF;;AGliDA;EACE,UAAA;EACA,4BAAA;EACA,qBAAA;EACA,wBAAA;AHqiDF;;AGliDA;EACE,SAAA;EACA,UAAA;EACA,2BAAA;AHqiDF;;AGliDA;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AHqiDF;;AGliDA;EACE,wBAAA;AHqiDF;;AGliDA;EACE,YAAA;EACA,iBAAA;AHqiDF;;AGliDA;EACE,6CAAA;EACA,iDAAA;AHqiDF;;AGliDA;;EAEE,kCAAA;AHqiDF;;AGliDA;EACE,8CAAA;EACA,kDAAA;AHqiDF;;AGliDA;;EAEE,mCAAA;AHqiDF;;AGliDA;EACE,6CAAA;EACA,iDAAA;AHqiDF;;AGliDA;;EAEE,kCAAA;AHqiDF;;AGliDA;EACE,eAAA;EACA,gBAAA;AHqiDF;;AGliDA;EACE,eAAA;EACA,iBAAA;AHqiDF;;AGliDA;EACE,6CAAA;EACA,iDAAA;AHqiDF;;AGliDA;EACE,aAAA;EACA,eAAA;AHqiDF;;AGliDA;EACE,uCAAA;AHqiDF;;AGliDA;EACE,eAAA;AHqiDF;;AGliDA;EACE,uCAAA;AHqiDF;;AGliDA;EACE,wCAAA;AHqiDF;;AGliDA;EACE,iBAAA;AHqiDF;;AGliDA;EACE,uCAAA;AHqiDF;;AGliDA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;AHqiDF;;AGliDA;EACE,YAAA;EACA,wBAAA;EACA,eAAA;AHqiDF;;AGliDA;EACE,eAAA;AHqiDF;;AGliDA;EACE,gBAAA;AHqiDF;;AGliDA;EACE,eAAA;AHqiDF;;AGliDA;EACE,gBAAA;EACA,sBAAA;EACA,eAAA;AHqiDF;;AGliDA;EACE,uCAAA;AHqiDF;;AGliDA;EACE,kCAAA;AHqiDF;;AGliDA;EACE,uCAAA;AHqiDF;;AGliDA;EACE,kCAAA;AHqiDF;;AGliDA;EACE,wCAAA;AHqiDF;;AGliDA;EACE,mCAAA;AHqiDF;;AGliDA;EACE,uCAAA;AHqiDF;;AGliDA;EACE,kCAAA;AHqiDF;;AGliDA;EACE,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;AHqiDF;;AGliDA;EACE,gBAAA;EACA,WAAA;AHqiDF;;AGliDA;EACE,oCAAA;EACA,WAAA;EACA,0BAAA;EACA,iBAAA;EACA,qBAAA;EACA,qCAAA;EACA,oBAAA;EACA,oCAAA;EACA,2BAAA;AHqiDF;;AGliDA;EACE,YAAA;EACA,2BAAA;AHqiDF;AGniDE;EACE,2BAAA;AHqiDJ;;AGjiDA;EACE,6CAAA;EACA,aAAA;AHoiDF;;AGjiDA;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;EACA,wBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;AHoiDF;AGliDE;EAbF;IAcI,WAAA;EHqiDF;AACF;;AGliDA;EACE,gBAAA;AHqiDF;;AGliDA;EACE,8CAAA;AHqiDF;;AGliDA;EACE,sBAAA;EACA,aAAA;AHqiDF;;AGliDA;EACE,6CAAA;AHqiDF;;AGliDA;EACE,6CAAA;AHqiDF;;AGjiDA;EACE;IACE,UAAA;EHoiDF;EGjiDA;IACE,UAAA;EHmiDF;AACF;AGhiDA,iEAAA;AAEA;EACE,8BAAA;EACA,gCAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AHiiDF;AG/hDE;EACE,UAAA;EACA,SAAA;EACA,aAAA;AHiiDJ;AG/hDI;EACE,gBAAA;EACA,UAAA;EACA,cAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;AHiiDN;AG/hDM;EACE,UAAA;EACA,cAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;AHiiDR;AG/hDQ;EACE,WF/6BS;EEg7BT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AHiiDV;AG9hDQ;EACE,kBAAA;EACA,iBAAA;AHgiDV;AG5hDM;EACE,gBAAA;EACA,YAAA;AH8hDR;AGzhDM;EACE,6CAAA;AH2hDR;AGthDM;EACE,6CAAA;AHwhDR;AGrhDM;EACE,iCAAA;AHuhDR;AGnhDI;EACE,gBAAA;AHqhDN;AGnhDM;EACE,6CAAA;AHqhDR;AGhhDM;EACE,6CAAA;AHkhDR;AG/gDM;EACE,iCAAA;AHihDR;AG7gDI;EACE,gBAAA;AH+gDN;AG7gDM;EACE,8CAAA;AH+gDR;AG1gDM;EACE,6CAAA;AH4gDR;AGzgDM;EACE,iCAAA;AH2gDR;AGvgDI;EACE,gBAAA;AHygDN;AGvgDM;EACE,6CAAA;AHygDR;AGpgDM;EACE,6CAAA;AHsgDR;AGngDM;EACE,iCAAA;AHqgDR;;AG9/CE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;AHigDJ;AG3/CM;EAJF;IAKI,WAAA;EH8/CN;AACF;AG5/CM;EACE,eAAA;EACA,iBAAA;AH8/CR;AG3/CM;EACE,eAAA;AH6/CR;AGx/CE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,qCFvmCS;ADimFb;AGx/CI;EARF;IASI,eAAA;EH2/CJ;AACF;AGz/CI;EACE,wEFxnCO;ADmnFb;AGz/CM;EAHF;IAII,sBAAA;IACA,WAAA;IACA,gBAAA;EH4/CN;AACF;AG1/CM;EATF;IAUI,uBAAA;IACA,WAAA;EH6/CN;AACF;AG3/CM;EAdF;IAeI,sBAAA;IACA,WAAA;EH8/CN;AACF;AG5/CM;EACE,WFpkCW;EEqkCX,YAAA;AH8/CR;AG5/CQ;EAJF;IAKI,WAAA;IACA,mBAAA;EH+/CR;AACF;AG7/CQ;EATF;IAUI,cAAA;EHggDR;AACF;AG7/CM;EACE,cFjnCa;ADgnFrB;AG3/CI;EACE,mBFtnCe;EEunCf,YAAA;EACA,wEFhqCO;AD6pFb;AG3/CM;EACE,WF5lCW;EE6lCX,qBAAA;AH6/CR;AG19CE;EACE,WAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EAEA,mBAAA;EAEA,eAAA;EAEA,kBAAA;EAEA,cAAA;AH49CJ;AG19CI;EAdF;IAgBI,mBAAA;IAEA,eAAA;IAEA,iBAAA;IAEA,aAAA;EH69CJ;AACF;AG39CI;EACE,mBAAA;EACA,oBAAA;AH69CN;AG19CI;EACE,iBAAA;AH49CN;;AGv9CA;EACE,aAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;AH09CF;AGx9CE;EACE,aAAA;AH09CJ;AGx9CI;EACE,gBAAA;AH09CN;AGv9CI;EACE,YAAA;EACA,iBAAA;AHy9CN;AGv9CM;EACE,iBAAA;AHy9CR;AGr9CI;EACE,gBAAA;AHu9CN;AGp9CQ;EACE,WAAA;EACA,eAAA;AHs9CV;AG/8CQ;EACE,SAAA;EACA,kBAAA;AHi9CV;;AGz8CA;EACE,8BAAA;EACA,gCAAA;EACA,aAAA;EACA,kBAAA;AH48CF;AG18CE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AH48CJ;AGx8CI;EACE,WAAA;AH08CN;AGr8CI;EACE,UAAA;AHu8CN;AGn8CE;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AHq8CJ;AGn8CI;;EAEE,kBAAA;AHq8CN;AGl8CI;EACE,YAAA;EACA,SAAA;AHo8CN;AGj8CI;EACE,SAAA;AHm8CN;AG97CE;EACE,UAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EA3wCF,6BA4wC+B;EA1yC/B,4BA2yC0B;EAtyC1B,sBAuyC8B;EAlyC9B,+BAmyCqC;EA9xCrC,uBA+xC2B;AHq8C7B;AGn8CI;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;AHq8CN;AGn8CM;EACE,UAAA;EACA,cAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EAh1CJ,+CAi1CgC;EAj1ChC,8CAi1CgC;EA70ClC,2CA60CkC;AHy8CpC;AGv8CQ;EACE,WF9xCS;EE+xCT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AHy8CV;AGt8CQ;EACE,gBAAA;EACA,eAAA;EACA,WFzyCS;EE0yCT,gBAAA;EACA,iBAAA;AHw8CV;AGp8CM;EACE,YAAA;EACA,UAAA;EACA,SAAA;EAx2CJ,oBAy2CgC;EAz2ChC,mBAy2CgC;EAr2ClC,gBAq2CkC;AH08CpC;AGx8CQ;EACE,UAAA;EACA,aAAA;EACA,iBAAA;AH08CV;AGv8CQ;EACE,iBAAA;AHy8CV;AGn8CM;EACE,6CAAA;AHq8CR;AGj8CI;EACE,gBAAA;AHm8CN;AGj8CM;EACE,6CAAA;AHm8CR;AG/7CI;EACE,gBAAA;AHi8CN;AG/7CM;EACE,8CAAA;AHi8CR;AG77CI;EACE,gBAAA;AH+7CN;AG77CM;EACE,6CAAA;AH+7CR;;AG96CA;EACE,2BAAA;EACA,kCAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AHi7CF;AG/6CE;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AHi7CJ;AG/6CI;;EAEE,kBAAA;AHi7CN;AG96CI;EACE,YAAA;EACA,SAAA;AHg7CN;AG76CI;EACE,SAAA;AH+6CN;AG16CE;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AH46CJ;AG16CI;EACE,UAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,QAAA;AH46CN;AG16CM;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAn9CN,iCAo9CkC;AH+6CpC;AG76CQ;EACE,YAAA;AH+6CV;AG36CM;EACE,UAAA;AH66CR;AG16CM;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;AH46CR;AGv6CQ;;EAEE,4BF1+CM;ADm5FhB;AGl4CM;EACE,SAAA;AHo4CR;AGl4CQ;;EAEE,4BFrhDK;ADy5Ff;AG91CM;EACE,SAAA;AHg2CR;AG91CQ;;EAEE,6BF/jDM;AD+5FhB;AG3zCM;EACE,SAAA;AH6zCR;AG3zCQ;;EAEE,4BFxmDQ;ADq6FlB;;AGjxCI;EACE,qBAAA;EACA,2BAAA;AHoxCN;AGhxCQ;EAFF;IAGI,gBAAA;EHmxCR;AACF;AGjxCQ;EACE,gBAAA;AHmxCV;AG/wCM;EAEE,aAAA;EACA,8BAAA;AHgxCR;AG5wCU;EAFF;IAGI,iBAAA;EH+wCV;AACF;AG1wCM;EACE,kBAAA;EACA,YAAA;AH4wCR;AGtwCE;EACE,aAAA;AHwwCJ;AGtwCI;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,qCAAA;AHwwCN;AGrwCI;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,0BAAA;EACA,4BAAA;EACA,qCAAA;EACA,gBAAA;EACA,yBAAA;AHuwCN;AGpwCI;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,qCAAA;EACA,yBAAA;AHswCN;AGnwCI;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,4BAAA;EACA,qCAAA;EACA,yBAAA;AHqwCN;AGlwCI;EACE,0BAAA;EACA,mBAAA;EACA,4BAAA;EACA,qCAAA;EACA,sBAAA;EACA,oBAAA;AHowCN;AGjwCI;EACE,0BAAA;EACA,mBAAA;EACA,4BAAA;EACA,qCAAA;EACA,sBAAA;EACA,oBAAA;AHmwCN;AG/vCM;EACE,0BAAA;EACA,iBAAA;EACA,oCAAA;AHiwCR;AG9vCM;EACE;IACE,yBAAA;EHgwCR;EG7vCM;IACE,wBAAA;EH+vCR;EG5vCM;;;;IAIE,8BAAA;EH8vCR;EG3vCM;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;IACA,0BAAA;IACA,eAAA;EH6vCR;AACF;AG1vCM;EAnCF;IAoCI,aAAA;EH6vCN;AACF;;AGrvCM;EACE;IACE,yBAAA;EHwvCR;EGrvCM;IACE,wBAAA;EHuvCR;EGpvCM;;;;IAIE,8BAAA;EHsvCR;EGnvCM;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;IACA,0BAAA;IACA,eAAA;EHqvCR;AACF;AGlvCM;EA7BF;IA8BI,aAAA;EHqvCN;AACF;;AGhvCA;EACE,oCAAA;EACA,WFhyDiB;EEiyDjB,oBAAA;EACA,gBAAA;EACA,WAAA;AHmvCF;AGjvCE;EACE,YAAA;AHmvCJ;AGhvCE;EACE,kBAAA;EACA,mBAAA;EACA,gBF5yDe;EE6yDf,cFj1DiB;EEo1DjB,aAAA;EACA,sBAAA;EAGA,mBAAA;EACA,iBAAA;AHkvCJ;AGhvCI;EAdF;IAeI,cAAA;IACA,WAAA;EHmvCJ;EGjvCI;IACE,6BAAA;IACA,mBAAA;EHmvCN;AACF;AGhvCI;EACE,SAAA;EACA,0BAAA;EACA,yBAAA;AHkvCN;AG/uCI;EACE,0BAAA;AHivCN;;AG3uCA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AH8uCF;AG5uCE;EACE,mCAAA;EACA,oCAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;AH8uCJ;AG5uCI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AH8uCN;;AGxuCE;EACE,gBAAA;AH2uCJ;AGxuCE;EACE,eAAA;EACA,mBAAA;AH0uCJ;AGvuCE;EACE,8BAAA;EACA,aAAA;AHyuCJ;;AGruCA;EAKE,eAAA;EACA,iBAAA;AHouCF;AGzuCE;EADF;IAEI,UAAA;EH4uCF;AACF;AGtuCI;EACE,oBAAA;AHwuCN;AGruCI;EACE,mBAAA;AHuuCN;;AGhuCE;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;AHmuCJ;AGjuCI;EACE,gBAAA;EACA,cAAA;AHmuCN;AG9tCI;EACE,mBAAA;AHguCN;;AG1tCA;EACE,cAAA;AH6tCF;;AGvtCE;EACE,eAAA;AH0tCJ;AGvtCE;EACE,iBAAA;AHytCJ;;AGrtCA;EACE,YAAA;AHwtCF;;AGrtCA;EAEE;;MAAA;EAGA;IACE,2BAAA;EHutCF;EGrtCE;;IAEE,2BAAA;EHutCJ;EGntCA,4BAAA;EAEA;IACE,yBAAA;EHotCF;EGjtCA;;IAEE,iBAAA;EHmtCF;EG7sCE;;;;;IAKE,sBAAA;EH+sCJ;EG3sCA;IACE,gBAAA;IACA,mBAAA;EH6sCF;EGxsCE;;IACE,gBAAA;IACA,uBAAA;IACA,iBAAA;EH2sCJ;EGxsCE;;IACE,cAAA;EH2sCJ;EGzsCI;;IACE,YAAA;EH4sCN;EGzsCI;;IACE,UAAA;EH4sCN;EGxsCE;;IACE,iBAAA;IACA,mBAAA;EH2sCJ;EGxsCM;;IACE,WAAA;EH2sCR;EGvsCI;;IACE,aAAA;EH0sCN;EGvsCI;;IACE,kBAAA;EH0sCN;EGvsCI;;IACE,iBAAA;EH0sCN;EGtsCE;;IACE,iBAAA;IACA,WAAA;EHysCJ;EGtsCE;;IACE,oFAAA;IACA,iCAAA;IACA,iBAAA;EHysCJ;EGtsCE;;IACE,iBAAA;EHysCJ;EGtsCE;;IACE,aAAA;EHysCJ;EGtsCE;;IACE,wBAAA;EHysCJ;EGvsCI;;IACE,sBAAA;EH0sCN;EGvsCI;;IACE,YAAA;EH0sCN;EGvsCI;;IACE,oCAAA;EH0sCN;EGxsCM;;;;IAEE,sBAAA;EH4sCR;EGzsCM;;IACE,sBAAA;EH4sCR;EGxsCI;;IACE,8BAAA;EH2sCN;EGvsCI;;IACE,8BAAA;EH0sCN;EGvsCI;;IACE,8BAAA;EH0sCN;EGvsCI;;IACE,8BAAA;EH0sCN;EGvsCI;;IACE,yBAAA;EH0sCN;EGvsCI;;IACE,yBAAA;EH0sCN;EGvsCI;;IACE,yBAAA;EH0sCN;EGvsCI;;IACE,yBAAA;EH0sCN;EGvsCI;;IACE,WAAA;EH0sCN;EGvsCI;;IACE,oCAAA;EH0sCN;EGrsCM;;;;IAEE,yBAAA;EHysCR;EGtsCM;;IACE,oCAAA;EHysCR;EGnsCM;;;;IAEE,yBAAA;EHusCR;EGpsCM;;IACE,oCAAA;EHusCR;EGjsCM;;;;IAEE,yBAAA;EHqsCR;EGlsCM;;IACE,oCAAA;EHqsCR;EG/rCM;;;;IAEE,yBAAA;EHmsCR;EGhsCM;;IACE,oCAAA;EHmsCR;EG/rCI;;IACE,kBAAA;EHksCN;AACF;AG7rCA;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,oCAAA;AH+rCF;;AG5rCA;EACE,0BAAA;EACA,yBAAA;EACA,gBAAA;AH+rCF;;AG5rCA;;EAEE,eAAA;AH+rCF;;AG5rCA;EACE,oCAAA;AH+rCF;;AG5rCA;EACE,gBAAA;EACA,eAAA;AH+rCF;;AG5rCA;EACE,gBAAA;AH+rCF;;AG5rCA;EACE,qBAAA;EACA,WAAA;AH+rCF;AGzrCM;EACE,uBAAA;AH2rCR;AGtrCE;;EAEE,UAAA;AHwrCJ;AGrrCE;EACE,gBAAA;EACA,6CAAA;AHurCJ;AGprCE;EACE,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,mBAAA;AHsrCJ;AGnrCE;EACE,aAAA;AHqrCJ;AGlrCE;EACE,iBAAA;AHorCJ;;AGhrCA;EACE,gBAAA;AHmrCF;;AGhrCA;EACE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,qCAAA;EACA,gBAAA;AHmrCF;;AGhrCA;EACE,mBAAA;EACA,gBAAA;AHmrCF;AGjrCE;EAGE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;AHmrCJ;AGjrCI;EACE,WAAA;AHmrCN;AG9qCI;EACE,qCAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;AHgrCN;AG7qCI;EACE,qBAAA;AH+qCN;AG5qCM;EACE,2BAAA;AH8qCR;AG3qCM;EACE,UAAA;EACA,gCAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,oCAAA;EACA,+CAAA;EACA,iCAAA;AH6qCR;;AGvqCA;EAGE,aAAA;EAEA,eAAA;EAGA,qBAAA;EACA,WAAA;EACA,mBAAA;AH0qCF;AGxqCE;EACE,UAAA;AH0qCJ;AGxqCI;EACE,0BAAA;EACA,iCAAA;AH0qCN;AGtqCE;EACE,UAAA;EACA,iBAAA;AHwqCJ;;AGpqCA;EACE,gBAAA;AHuqCF;AGrqCE;EACE,SAAA;EACA,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AHuqCJ;AGrqCI;EACE,eAAA;EACA,oCAAA;AHuqCN;AGnqCE;EACE,gBAAA;AHqqCJ;;AGjqCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AHoqCF;AGlqCE;EACE,gBAAA;EACA,WAAA;AHoqCJ;AGjqCE;EACE,yBAAA;AHmqCJ;;AG9pCA;EACE,oBAAA;AHiqCF;AG/pCE;EACE,oBAAA;AHiqCJ;AG9pCE;EACE,UAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AHgqCJ;;AG5pCA;EACE,sBAAA;AH+pCF;AG7pCE;EACE,oBAAA;AH+pCJ;AG1pCI;EACE,eAAA;AH4pCN;AGxpCE;EACE,WAAA;EACA,iBAAA;EACA,UAAA;AH0pCJ;AGrpCI;EACE,YAAA;EACA,YAAA;EACA,UAAA;EACA,sBAAA;EACA,kBAAA;AHupCN;;AGlpCA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AHqpCF;AGnpCE;EACE,aAAA;AHqpCJ;AGnpCI;EACE,yBAAA;AHqpCN;AGjpCI;EACE,mBAAA;EACA,oBAAA;AHmpCN;;AG9oCA;EACE,cAAA;EACA,eAAA;EACA,wEAAA;EACA,gBAAA;AHipCF;AG/oCE;EANF;IAOI,iBAAA;EHkpCF;AACF;AGhpCE;EACE,wBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,wEFrgFS;ADupHb;AGhpCI;EARF;IASI,WAAA;EHmpCJ;AACF;;AG7oCE;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,iBAAA;EACA,mBAAA;AHgpCJ;AG9oCI;EAPF;IAQI,eAAA;EHipCJ;AACF;AG/oCI;EACE,kBAAA;AHipCN;AG/oCM;EACE,kBAAA;EACA,UAAA;AHipCR;AG/oCQ;EAJF;IAKI,gBAAA;EHkpCR;AACF;AGhpCQ;EACE,mBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,oCAAA;AHkpCV;AG/oCQ;EACE,gBAAA;AHipCV;AG3oCI;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;AH6oCN;AG3oCM;EALF;IAMI,gBAAA;EH8oCN;AACF;AG5oCM;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AH8oCR;AG5oCQ;EATF;IAUI,gBAAA;EH+oCR;AACF;;AGvoCE;EACE,SAAA;AH0oCJ;;AGtoCA;EACE,uBAAA;AHyoCF;;AGtoCA;EACE,aAAA;AHyoCF;;AGtoCA,mBAAA;AAcY;EAFF;IAGI,eAAA;EH6nCZ;AACF;AG3nCY;EANF;IAOI,eAAA;EH8nCZ;AACF;AG5nCY;EAVF;IAWI,eAAA;EH+nCZ;AACF;AGtnCU;EAFF;IAGI,kBAAA;EHynCV;AACF;AGvnCU;EANF;IAOI,kBAAA;IACA,UAAA;EH0nCV;AACF;AG/mCU;EAFF;IAGI,eAAA;EHknCV;AACF;AGhnCU;EANF;IAOI,0BAAA;IACA,2BAAA;IACA,WAAA;IACA,0BAAA;EHmnCV;AACF;AG9mCM;EApBF;IAqBI,aAAA;EHinCN;AACF;AGxmCU;EAFF;IAGI,gBAAA;EH2mCV;AACF;;AGlmCE;EACE,SAAA;AHqmCJ;;AC7pHA;EACE,eAAA;ADgqHF;;AC7pHA;EACE,aAAA;EACA,eAAA;ADgqHF;;AC7pHA;EACE,sBAAA;ADgqHF;;AC7pHA;EACE,8BAAA;ADgqHF;;AC7pHA;EACE,gBAAA;ADgqHF;;AC7pHA;EACE,gBAAA;ADgqHF;;AC7pHA;EACE,aAAA;ADgqHF;;AC7pHA;EACE,gBAAA;ADgqHF;;AClpHE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ADqpHJ;ACnpHI;;;;;;EACE,gBAAA;AD0pHN;ACtpHE;;EAEE,eA5GO;EA6GP,gBA3GO;ADmwHX;ACtpHI;EALF;;IAMI,eA/GY;EDywHhB;AACF;ACvpHE;;EAEE,eAlHO;EAmHP,gBAjHO;AD0wHX;ACvpHI;EALF;;IAMI,eArHY;EDgxHhB;AACF;ACxpHE;;EAEE,eAxHO;EAyHP,gBAvHO;ADixHX;ACxpHI;EALF;;IAMI,eA3HY;EDuxHhB;AACF;ACzpHE;;EAEE,eA9HO;EA+HP,gBA7HO;ADwxHX;ACxpHE;;EAEE,eAhIO;EAiIP,gBAhIO;AD0xHX;ACvpHE;;EAEE,eAnIO;EAoIP,gBAnIO;AD4xHX;ACnpHE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ADqpHJ;ACnpHI;EACE,gBAAA;ADqpHN;AClpHI;EAXF;IAYI,eAAA;EDqpHJ;AACF;AClpHE;;EAEE,UAAA;EACA,SAAA;ADopHJ;ACjpHE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;ADmpHJ;;AC/oHA;EACE,sBAxNQ;AD02HV;;AC/oHA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;ADkpHF;AChpHE;EALF;IAMI,cAAA;EDmpHF;AACF;ACjpHE;EACE,iBA1Ka;AD6zHjB;AChpHE;EACE,gBApLa;EAqLb,WAAA;ADkpHJ;;AC7oHE;EACE,kBAAA;ADgpHJ;AC7oHE;EACE,iBAAA;AD+oHJ;;AC1oHE;EACE,aAAA;AD6oHJ;;ACzoHA;EACE,kBAAA;AD4oHF;AC1oHE;EACE,mBAAA;AD4oHJ;ACxoHI;EACE,sBAAA;AD0oHN;ACtoHE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ADs2HnB;ACtoHI;EACE,sBAAA;ADwoHN;ACroHI;EAVF;IAWI,eApOoB;ED42HxB;AACF;ACroHE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ADuoHJ;ACroHI;EACE,sBAAA;ADuoHN;ACpoHI;EACE,WAAA;ADsoHN;ACnoHI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ADi+HZ;;AChoHA;EACE,mBA1PO;AD63HT;ACjoHE;EAHF;IAII,mBAAA;EDooHF;AACF;ACloHE;EACE,mBAAA;ADooHJ;ACjoHE;EACE,aArQK;ADw4HT;ACjoHI;EAHF;IAII,aAAA;EDooHJ;AACF;ACloHI;EACE,aAAA;ADooHN;;AC/nHA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;ADkoHF;AChoHE;EACE,eAAA;ADkoHJ;AC/nHE;EACE,sCAAA;ADioHJ;AC9nHE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;ADgoHJ;;ACjnHE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ADonHJ;AClnHI;EACE,kBAAA;ADonHN;ACjnHI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;ADmnHN;;AC9mHA;EACE,8BAAA;ADinHF;;AC9mHA;EACE,8BAAA;ADinHF;;AC9mHA;EACE,+BAAA;ADinHF;;AC9mHA;EACE,8BAAA;ADinHF;;AC9mHA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;ADinHF;AC/mHE;EACE,2BAAA;EACA,mBAAA;ADinHJ;AC9mHE;EACE,yBAzbiB;EA0bjB,WA1aO;AD0hIX;AC7mHE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AD+mHJ;AC5mHE;EACE,yBAjckB;EAkclB,cArciB;ADmjIrB;AC3mHE;EACE,yBAvbS;EAwbT,WA1bO;ADuiIX;AC3mHI;EACE,6BAAA;AD6mHN;;ACxmHA;EACE;IACE,uBAAA;ED2mHF;ECxmHA;IACE,yBAAA;ED0mHF;AACF;ACvmHA;EACE,8BAAA;ADymHF;;ACtmHA;EACE,8BAAA;ADymHF;;ACtmHA;EACE,+BAAA;ADymHF;;ACtmHA;EACE,8BAAA;ADymHF;;ACtmHA;EACE,qBAAA;ADymHF;;ACtmHA;EACE,UAAA;ADymHF;ACvmHE;EACE,qBAAA;ADymHJ;;ACrmHA;EACE,UAAA;ADwmHF;;ACpmHE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ADsmHJ;ACnmHM;EACE,mBAAA;ADqmHR;AChmHE;EACE,2BAAA;ADkmHJ;AC/lHE;EACE,uBAAA;ADimHJ;AC9lHE;EACE,mBAAA;ADgmHJ;;AC3lHE;EACE,mBAAA;AD8lHJ;AC3lHE;EACE,yBAAA;AD6lHJ;AC1lHE;EACE,sBAAA;AD4lHJ;ACzlHE;EACE,uBAAA;AD2lHJ;ACxlHE;EACE,oBAAA;AD0lHJ;;AIzqIM;EACE,qBAAA;AJ4qIR;;AIrqIE;EACE,cAAA;AJwqIJ;;AInqIE;EACE,2EAAA;EACA,sBAAA;EACA,4CAAA;EACA,YAAA;EACA,YAAA;AJsqIJ;AIhqIQ;EACE,2EAAA;EACA,sBAAA;EACA,6CAAA;EACA,aAAA;AJkqIV;AIhqIU;EACE,UAAA;AJkqIZ;AI5pIQ;EACE,2EAAA;EACA,sBAAA;EACA,6CAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;AJ8pIV;;AIvpIA;EACE;IACE,0BAAA;EJ0pIF;EIvpIA;IAEE,0BAAA;EJwpIF;EIrpIA;IACE,0BAAA;EJupIF;AACF;AIppIA;EACE;IACE,0BAAA;EJspIF;EInpIA;IAEE,0BAAA;EJopIF;EIjpIA;IACE,0BAAA;EJmpIF;AACF;AIhpIA;EACE;IACE,0BAAA;EJkpIF;EI/oIA;IAEE,0BAAA;EJgpIF;EI7oIA;IACE,0BAAA;EJ+oIF;AACF;AI5oIA;EACE;IACE,0BAAA;EJ8oIF;EI3oIA;IAEE,0BAAA;EJ4oIF;EIzoIA;IACE,0BAAA;EJ2oIF;AACF;AIxoIA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;EAEA,YAAA;EACA,YAAA;EACA,gBHrDiB;EGsDjB,oBAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,4BAAA;AJyoIF;AIvoIE;EACE,qFAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,gCAAA;EACA,UAAA;EACA,6BAAA;EACA,YAAA;AJyoIJ;AItoIE;EACE,qFAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,gCAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;AJwoIJ;AIroIE;EAEE,WAAA;EACA,kBAAA;EACA,gBH9Fe;EG+Ff,WAAA;AJsoIJ;AInoIE;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;AJqoIJ;AIloIE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;AJooIJ;AIjoIE;EACE,kBAAA;EACA,eAAA;AJmoIJ;AIhoIE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;AJkoIJ;AIhoII;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,6BHpLU;EGqLV,WHrIa;EGsIb,gBAAA;EACA,iBAAA;AJkoIN;AIhoIM;EACE,YAAA;EACA,mBAAA;AJkoIR;;AI5nIA;EACE,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;AJ+nIF;;AI5nIA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AJ+nIF;;AI5nIA;EACE;IACE,WAAA;EJ+nIF;AACF;AI5nIA;EACE;IACE,kBAAA;EJ8nIF;AACF;AI3nIA;EACE,kBAAA;EACA,sBAAA;EAEA,SAAA;EACA,gBAAA;AJ4nIF;;AIznIA;;;EAGE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AJ4nIF;;AIznIA;EACE,qBAAA;AJ4nIF;;AIznIA;EAEE,uBAAA;AJ2nIF;AIznIE;EACE,qCAAA;AJ2nIJ;;AIvnIA;EACE,aAAA;EACA,oBAAA;EAEA,eAAA;AJ0nIF;;AIvnIA;EACE,YAAA;AJ0nIF;;AIvnIA;EACE,YAAA;AJ0nIF;;AIvnIA;EACE;IACE,WAAA;EJ0nIF;AACF;AIvnIA;EACE,oCAAA;AJynIF;;AItnIA;EACE,gBAAA;EACA,cAAA;AJynIF;;AItnIA;EACE,mBAAA;EACA,gBAAA;AJynIF;;AItnIA;EACE,kBAAA;AJynIF;;AItnIA;EACE,aAAA;EACA,gCAAA;AJynIF;;AItnIA;EACE,aAAA;EACA,mBAAA;AJynIF;;AItnIA;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;AJynIF;;AItnIA;EACE,uBAAA;AJynIF;AIvnIE;EACE,aAAA;EACA,eAAA;AJynIJ;;AIpnIE;EACE,wBHhVO;ADu8IX;;AIjnIE;;EAEE,wEH7VS;EG8VT,eAAA;AJonIJ;;AIhnIA;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AJmnIF;;AC11IA;EACE,eAAA;AD61IF;;AC11IA;EACE,aAAA;EACA,eAAA;AD61IF;;AC11IA;EACE,sBAAA;AD61IF;;AC11IA;EACE,8BAAA;AD61IF;;AC11IA;EACE,gBAAA;AD61IF;;AC11IA;EACE,gBAAA;AD61IF;;AC11IA;EACE,aAAA;AD61IF;;AC11IA;EACE,gBAAA;AD61IF;;AC/0IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ADk1IJ;ACh1II;;;;;;EACE,gBAAA;ADu1IN;ACn1IE;;EAEE,eA5GO;EA6GP,gBA3GO;ADg8IX;ACn1II;EALF;;IAMI,eA/GY;EDs8IhB;AACF;ACp1IE;;EAEE,eAlHO;EAmHP,gBAjHO;ADu8IX;ACp1II;EALF;;IAMI,eArHY;ED68IhB;AACF;ACr1IE;;EAEE,eAxHO;EAyHP,gBAvHO;AD88IX;ACr1II;EALF;;IAMI,eA3HY;EDo9IhB;AACF;ACt1IE;;EAEE,eA9HO;EA+HP,gBA7HO;ADq9IX;ACr1IE;;EAEE,eAhIO;EAiIP,gBAhIO;ADu9IX;ACp1IE;;EAEE,eAnIO;EAoIP,gBAnIO;ADy9IX;ACh1IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ADk1IJ;ACh1II;EACE,gBAAA;ADk1IN;AC/0II;EAXF;IAYI,eAAA;EDk1IJ;AACF;AC/0IE;;EAEE,UAAA;EACA,SAAA;ADi1IJ;AC90IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;ADg1IJ;;AC50IA;EACE,sBAxNQ;ADuiJV;;AC50IA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AD+0IF;AC70IE;EALF;IAMI,cAAA;EDg1IF;AACF;AC90IE;EACE,iBA1Ka;AD0/IjB;AC70IE;EACE,gBApLa;EAqLb,WAAA;AD+0IJ;;AC10IE;EACE,kBAAA;AD60IJ;AC10IE;EACE,iBAAA;AD40IJ;;ACv0IE;EACE,aAAA;AD00IJ;;ACt0IA;EACE,kBAAA;ADy0IF;ACv0IE;EACE,mBAAA;ADy0IJ;ACr0II;EACE,sBAAA;ADu0IN;ACn0IE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ADmiJnB;ACn0II;EACE,sBAAA;ADq0IN;ACl0II;EAVF;IAWI,eApOoB;EDyiJxB;AACF;ACl0IE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ADo0IJ;ACl0II;EACE,sBAAA;ADo0IN;ACj0II;EACE,WAAA;ADm0IN;ACh0II;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;AD8pJZ;;AC7zIA;EACE,mBA1PO;AD0jJT;AC9zIE;EAHF;IAII,mBAAA;EDi0IF;AACF;AC/zIE;EACE,mBAAA;ADi0IJ;AC9zIE;EACE,aArQK;ADqkJT;AC9zII;EAHF;IAII,aAAA;EDi0IJ;AACF;AC/zII;EACE,aAAA;ADi0IN;;AC5zIA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AD+zIF;AC7zIE;EACE,eAAA;AD+zIJ;AC5zIE;EACE,sCAAA;AD8zIJ;AC3zIE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AD6zIJ;;AC9yIE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ADizIJ;AC/yII;EACE,kBAAA;ADizIN;AC9yII;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;ADgzIN;;AC3yIA;EACE,8BAAA;AD8yIF;;AC3yIA;EACE,8BAAA;AD8yIF;;AC3yIA;EACE,+BAAA;AD8yIF;;AC3yIA;EACE,8BAAA;AD8yIF;;AC3yIA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AD8yIF;AC5yIE;EACE,2BAAA;EACA,mBAAA;AD8yIJ;AC3yIE;EACE,yBAzbiB;EA0bjB,WA1aO;ADutJX;AC1yIE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AD4yIJ;ACzyIE;EACE,yBAjckB;EAkclB,cArciB;ADgvJrB;ACxyIE;EACE,yBAvbS;EAwbT,WA1bO;ADouJX;ACxyII;EACE,6BAAA;AD0yIN;;ACryIA;EACE;IACE,uBAAA;EDwyIF;ECryIA;IACE,yBAAA;EDuyIF;AACF;ACpyIA;EACE,8BAAA;ADsyIF;;ACnyIA;EACE,8BAAA;ADsyIF;;ACnyIA;EACE,+BAAA;ADsyIF;;ACnyIA;EACE,8BAAA;ADsyIF;;ACnyIA;EACE,qBAAA;ADsyIF;;ACnyIA;EACE,UAAA;ADsyIF;ACpyIE;EACE,qBAAA;ADsyIJ;;AClyIA;EACE,UAAA;ADqyIF;;ACjyIE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ADmyIJ;AChyIM;EACE,mBAAA;ADkyIR;AC7xIE;EACE,2BAAA;AD+xIJ;AC5xIE;EACE,uBAAA;AD8xIJ;AC3xIE;EACE,mBAAA;AD6xIJ;;ACxxIE;EACE,mBAAA;AD2xIJ;ACxxIE;EACE,yBAAA;AD0xIJ;ACvxIE;EACE,sBAAA;ADyxIJ;ACtxIE;EACE,uBAAA;ADwxIJ;ACrxIE;EACE,oBAAA;ADuxIJ;;AIt2JM;EACE,qBAAA;AJy2JR;;AIl2JE;EACE,cAAA;AJq2JJ;;AIh2JE;EACE,2EAAA;EACA,sBAAA;EACA,4CAAA;EACA,YAAA;EACA,YAAA;AJm2JJ;AI71JQ;EACE,2EAAA;EACA,sBAAA;EACA,6CAAA;EACA,aAAA;AJ+1JV;AI71JU;EACE,UAAA;AJ+1JZ;AIz1JQ;EACE,2EAAA;EACA,sBAAA;EACA,6CAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;AJ21JV;;AIp1JA;EACE;IACE,0BAAA;EJu1JF;EIp1JA;IAEE,0BAAA;EJq1JF;EIl1JA;IACE,0BAAA;EJo1JF;AACF;AIj1JA;EACE;IACE,0BAAA;EJm1JF;EIh1JA;IAEE,0BAAA;EJi1JF;EI90JA;IACE,0BAAA;EJg1JF;AACF;AI70JA;EACE;IACE,0BAAA;EJ+0JF;EI50JA;IAEE,0BAAA;EJ60JF;EI10JA;IACE,0BAAA;EJ40JF;AACF;AIz0JA;EACE;IACE,0BAAA;EJ20JF;EIx0JA;IAEE,0BAAA;EJy0JF;EIt0JA;IACE,0BAAA;EJw0JF;AACF;AIr0JA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;EAEA,YAAA;EACA,YAAA;EACA,gBHrDiB;EGsDjB,oBAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,4BAAA;AJs0JF;AIp0JE;EACE,qFAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,gCAAA;EACA,UAAA;EACA,6BAAA;EACA,YAAA;AJs0JJ;AIn0JE;EACE,qFAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,gCAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;AJq0JJ;AIl0JE;EAEE,WAAA;EACA,kBAAA;EACA,gBH9Fe;EG+Ff,WAAA;AJm0JJ;AIh0JE;EACE,YAAA;EACA,aAAA;EACA,UAAA;EACA,WAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;AJk0JJ;AI/zJE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;EACA,4BAAA;EACA,yBAAA;AJi0JJ;AI9zJE;EACE,kBAAA;EACA,eAAA;AJg0JJ;AI7zJE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;AJ+zJJ;AI7zJI;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,6BHpLU;EGqLV,WHrIa;EGsIb,gBAAA;EACA,iBAAA;AJ+zJN;AI7zJM;EACE,YAAA;EACA,mBAAA;AJ+zJR;;AIzzJA;EACE,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;AJ4zJF;;AIzzJA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;AJ4zJF;;AIzzJA;EACE;IACE,WAAA;EJ4zJF;AACF;AIzzJA;EACE;IACE,kBAAA;EJ2zJF;AACF;AIxzJA;EACE,kBAAA;EACA,sBAAA;EAEA,SAAA;EACA,gBAAA;AJyzJF;;AItzJA;;;EAGE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AJyzJF;;AItzJA;EACE,qBAAA;AJyzJF;;AItzJA;EAEE,uBAAA;AJwzJF;AItzJE;EACE,qCAAA;AJwzJJ;;AIpzJA;EACE,aAAA;EACA,oBAAA;EAEA,eAAA;AJuzJF;;AIpzJA;EACE,YAAA;AJuzJF;;AIpzJA;EACE,YAAA;AJuzJF;;AIpzJA;EACE;IACE,WAAA;EJuzJF;AACF;AIpzJA;EACE,oCAAA;AJszJF;;AInzJA;EACE,gBAAA;EACA,cAAA;AJszJF;;AInzJA;EACE,mBAAA;EACA,gBAAA;AJszJF;;AInzJA;EACE,kBAAA;AJszJF;;AInzJA;EACE,aAAA;EACA,gCAAA;AJszJF;;AInzJA;EACE,aAAA;EACA,mBAAA;AJszJF;;AInzJA;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;AJszJF;;AInzJA;EACE,uBAAA;AJszJF;AIpzJE;EACE,aAAA;EACA,eAAA;AJszJJ;;AIjzJE;EACE,wBHhVO;ADooKX;;AI9yJE;;EAEE,wEH7VS;EG8VT,eAAA;AJizJJ;;AI7yJA;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AJgzJF;;AAhpKA;EACE,kBAAA;EACA,mBAAA;AAmpKF;;AAhpKA;EACE,mBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;AAmpKF;;AAhpKA;EACE,aAAA;AAmpKF;;AAhpKA;EACE,kBAAA;EACA,mBAAA;AAmpKF;;AAhpKA;EACE,wBC1BS;AD6qKX;;AAhpKA;EACE,WAAA;AAmpKF;;AA/oKE;EACE,2BAAA;AAkpKJ;AA/oKE;EACE,yBAAA;AAipKJ;;AA7oKA;EACE,eAAA;EACA,kBAAA;AAgpKF;;AA7oKA;EACE,WAAA;EACA,wBClDS;EDmDT,gBAAA;AAgpKF;AA9oKE;EACE,wBAAA;AAgpKJ;AA7oKE;EACE,WAAA;EACA,UAAA;EACA,kBAAA;AA+oKJ;AA5oKE;EACE,aAAA;AA8oKJ;AA3oKE;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;AA6oKJ;AA3oKI;EACE,gBAAA;AA6oKN;AAzoKE;EACE,YAAA;EACA,UAAA;AA2oKJ;AAxoKE;EACE,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EAEA,8EAAA;EACA,WAAA;EACA,WAAA;AA0oKJ;AAvoKE;EACE,oBAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AAyoKJ;;AAroKA;EACE,kBAAA;AAwoKF;;AAroKA;EACE,qCAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;AAwoKF;;AAroKA;EACE,2BAAA;AAwoKF;AAtoKE;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAwoKJ;AA7nKI;EACE,0BAAA;EACA,4BAAA;EACA,4BAAA;AA+nKN;AA3nKE;EACE,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA6nKJ;AA3nKI;EACE,iBAAA;AA6nKN;AA3nKM;EACE,iBAAA;AA6nKR;AAznKI;EACE,qCAAA;AA2nKN;AApnKI;EACE,UAAA;AAsnKN;AAlnKE;EACE,UAAA;EACA,iBAAA;AAonKJ;AAhnKE;EACE,oCAAA;EACA,aAAA;AAknKJ;;AA9mKA;EACE,gBAAA;EACA,kBAAA;AAinKF;;AA9mKA;EACE,WAAA;AAinKF;AA/mKE;EACE,WAAA;AAinKJ;AA9mKE;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;AAgnKJ;AA7mKE;EACE,aAAA;EACA,oBAAA;AA+mKJ;AA5mKE;EACE,aAAA;EACA,oBAAA;AA8mKJ;AA1mKE;EACE,aAAA;EACA,oBAAA;AA4mKJ;;AAvmKA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,aAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AA0mKF;;AAvmKA;EACE,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AA0mKF;;AAvmKA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AA0mKF;;AAtmKA;EACE,mCAAA;EACA,UAAA;AAymKF;;AAtmKA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAymKF;;AAtmKA;EACE,mCAAA;EACA,mBAAA;EACA,UAAA;AAymKF;;AAtmKA;EACE,mCAAA;EACA,qBAAA;EACA,UAAA;AAymKF;;AAtmKA;EACE;IACE,UAAA;EAymKF;EAtmKA;IACE,UAAA;EAwmKF;EArmKA;IACE,UAAA;EAumKF;AACF;AAnmKA;EACE,UAAA;AAqmKF;AAnmKE;EACE,kBAAA;AAqmKJ;AAnmKI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAqmKN;;AAhmKA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;AAmmKF;AAjmKE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;AAmmKJ;AAhmKE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;AAkmKJ;AAhmKI;EACE,cAAA;EACA,wBC/TU;EDgUV,iBAAA;AAkmKN;;AA7lKA;EACE,aAAA;EACA,8BAAA;AAgmKF;AA9lKE;EAEE,aAAA;AA+lKJ;;AA3lKA;EACE,aAAA;AA8lKF;AA5lKE;EACE,YAAA;AA8lKJ;AA3lKE;EACE,YAAA;AA6lKJ;;AAzlKA;EACE,uBAAA;AA4lKF;;AAplKI;EACE,cAAA;AAulKN;;AA9kKI;EACE,UAAA;AAilKN;AA9kKI;EACE,UAAA;AAglKN;AA5kKE;EACE,kBAAA;AA8kKJ;AA3kKE;EACE,eAAA;AA6kKJ;AA1kKE;EACE,iBAAA;EACA,aAAA;EACA,yBAAA;AA4kKJ;AA1kKI;EACE,YAAA;AA4kKN;AAzkKI;EACE,mBAAA;EACA,qBAAA;EACA,uBAAA;AA2kKN;AAzkKM;EALF;IAMI,mBAAA;EA4kKN;AACF;;AAvkKA;EACE;IACE,kCCxZY;EDk+Kd;EAvkKA;IACE,yBAAA;EAykKF;EAtkKA;IACE,kCChaY;EDw+Kd;AACF;AArkKA;EACE;IACE,kCCraW;ED4+Kb;EApkKA;IACE,yBAAA;EAskKF;EAnkKA;IACE,kCC7aW;EDk/Kb;AACF;AAlkKA;EACE;IACE,mCClbY;EDs/Kd;EAjkKA;IACE,yBAAA;EAmkKF;EAhkKA;IACE,mCC1bY;ED4/Kd;AACF;AA/jKA;EACE;IACE,kCC/bc;EDggLhB;EA9jKA;IACE,yBAAA;EAgkKF;EA7jKA;IACE,kCCvcc;EDsgLhB;AACF;AA3jKA;EAYE,gBAAA;EACA,kBAAA;AAkjKF;AA5jKI;EADF;IAEI,WAAA;EA+jKJ;EA7jKI;IACE,mBAAA;EA+jKN;AACF;AAxjKE;EACE,kBAAA;AA0jKJ;AAvjKE;EACE,uBAAA;AAyjKJ;AAtjKE;EAqDE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;AAogKJ;AA1jKI;EACE,8BAAA;AA4jKN;AA1jKM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,+CAAA;EACA,cAAA;EACA,oBAAA;AA4jKR;AAxjKI;EACE,YAAA;AA0jKN;AAxjKM;EACE,uDAAA;AA0jKR;AArjKQ;EACE,0DAAA;AAujKV;AAjjKQ;EACE,yDAAA;AAmjKV;AA7iKQ;EACE,0DAAA;AA+iKV;AAziKQ;EACE,4DAAA;AA2iKV;AA/hKI;EACE,UAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8CAAA;AAiiKN;AA/hKM;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,+CAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAiiKR;AA/hKQ;EACE,WClhBC;EDmhBD,gBAAA;AAiiKV;AA/hKU;EAJF;IAKI,gBAAA;EAkiKV;AACF;AA3hKI;EACE,oBAAA;EACA,SAAA;EACA,2BAAA;AA6hKN;AA1hKI;EACE,QAAA;EACA,sBAAA;EACA,2BAAA;AA4hKN;AAzhKI;EACE,uBAAA;EACA,SAAA;EACA,2BAAA;AA2hKN;AAxhKI;EACE,QAAA;EACA,qBAAA;EACA,2BAAA;AA0hKN;AAphKI;EACE,mBAAA;AAshKN;;AAjhKA;EACE,oBCzgBO;AD6hLT;AAlhKE;EACE,6FAAA;EACA,sBAAA;EACA,2BAAA;EACA,oBAAA;EACA,iBAAA;AAohKJ;AAlhKI;EAPF;IAQI,mBCnhBG;IDohBH,oBAAA;EAqhKJ;AACF;AAhhKI;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAkhKN;AA/gKI;EACE,mBAAA;EACA,gBAAA;AAihKN;AA/gKM;EAJF;IAKI,mBAAA;EAkhKN;AACF;AA/gKI;EACE,qBAAA;EACA,gBAAA;AAihKN;AA/gKM;EACE,YAAA;AAihKR;AA7gKI;EACE,WAAA;AA+gKN;AA7gKM;EAHF;IAII,WAAA;EAghKN;AACF;;AA1gKA;EAIE,oBAAA;AA0gKF;AArgKM;EADF;IAEI,UAAA;EAwgKN;AACF;AAtgKM;EALF;IAMI,WAAA;EAygKN;AACF;AAngKE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AAqgKJ;AAjgKM;EACE,+BCvrBQ;AD0rLhB;AAhgKM;EACE,aAAA;AAkgKR;AAv/JM;EACE,+BCvsBQ;ADgsLhB;AAt/JM;EACE,aAAA;AAw/JR;AAr/JM;EACE,cAAA;AAu/JR;AAh/JE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAk/JJ;AA/+JE;EACE,aAAA;AAi/JJ;AA/+JI;EACE,kBAAA;EACA,mBAAA;AAi/JN;AA9+JI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAg/JN;AA5+JE;EAEE,kBAAA;EACA,yBCjuBkB;EDkuBlB,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AA6+JJ;AA3+JI;;;EAEE,iBAAA;AA8+JN;AA3+JI;EACE,wEC1xBO;ADuwLb;AAz+JE;EACE,sBCvuBO;ADktLX;AAx+JE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA0+JJ;AAv+JM;EACE,iBAAA;AAy+JR;AAr+JI;EACE,kBAAA;AAu+JN;AAn+JE;EACE,aAAA;EACA,gBAAA;AAq+JJ;AAn+JI;EACE,WAAA;EACA,wECzzBO;ED0zBP,gBAAA;EACA,kBAAA;EACA,yBAAA;AAq+JN;AAn+JM;EACE,iBAAA;AAq+JR;AA/9JE;EACE,YAAA;EACA,6BAAA;EACA,kBAAA;EAOA,wBAAA;EACA,sBAAA;AA29JJ;AAj+JI;EALF;IAMI,YAAA;IACA,iBAAA;EAo+JJ;AACF;AA/9JI;EACE,kBAAA;AAi+JN;AA79JQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,iCAAA;EACA,2BAAA;EACA,+BAAA;EACA,WAAA;EACA,yBCpzBY;ADmxLtB;AAx9JU;EACE,mCCh1BI;AD0yLhB;AAt9JQ;EACE,mCCr1BM;EDs1BN,+BCt1BM;EDu1BN,+FAAA;AAw9JV;AAj9JE;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAm9JJ;AAj9JI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;AAm9JN;;AA18JI;EAFF;IAGI,WAAA;EA88JJ;AACF;AA38JE;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AA68JJ;AA38JI;EACE,gBAAA;AA68JN;AA18JI;EACE,gCAAA;EACA,oBAAA;AA48JN;AAt8JI;EACE,mBAAA;AAw8JN;AAl8JM;EACE,mBAAA;AAo8JR;AAj8JM;EACE,eAAA;AAm8JR;AA57JU;EACE,yBC/4BS;AD60LrB;AAx7JI;EACE,gBAAA;AA07JN;AAx7JM;EACE,kBAAA;AA07JR;AAr7JI;;EAEE,eAAA;AAu7JN;AAj7JI;EACE,yBAAA;EACA,WAAA;EACA,gBAAA;AAm7JN;AAh7JI;EACE,gBAAA;EACA,cC96Be;ADg2LrB;AAh7JM;EACE,cAAA;AAk7JR;AA/6JM;EACE,iBAAA;EACA,cCn7Bc;EDo7Bd,eAAA;AAi7JR;AA56JE;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AA86JJ;AA56JI;EACE,gBAAA;EACA,2BAAA;AA86JN;AA16JE;EACE,wECj/BS;EDk/BT,kBAAA;AA46JJ;;AAx6JA;EACE,eAAA;EACA,iBAAA;AA26JF;AAz6JE;EAJF;IAKI,yBAAA;EA46JF;AACF;;AAv6JE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AA06JJ;AAv6JE;EACE,WAAA;AAy6JJ;AAt6JE;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAw6JJ;AAr6JE;EACE,sBAAA;EACA,cAAA;AAu6JJ;;AAn6JA;EACE,sBAAA;EACA,uBAAA;AAs6JF;;AAn6JA;EACE,gBAAA;AAs6JF;AAp6JE;EACE,0BAAA;AAs6JJ;;AAl6JA;EACE,UAAA;EACA,2BAAA;EACA,qBAAA;AAq6JF;;AA55JM;EACE,eAAA;AA+5JR;;AAr5JI;EACE,oBAAA;AAw5JN;;AAl5JA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,iCAAA;EACA,UAAA;AAq5JF;AAn5JE;EACE,sBAAA;AAq5JJ;AAl5JE;EACE,yBAAA;AAo5JJ;AAj5JE;EACE,oCAAA;AAm5JJ;AA/4JI;EACE,mCAAA;AAi5JN;AA94JI;EACE,UAAA;AAg5JN;AA34JI;EACE,0BAAA;AA64JN;AAz4JE;EACE,kBAAA;EACA,gBAAA;AA24JJ;AAx4JE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AA04JJ;AAx4JI;EALF;IAMI,YAAA;IACA,iBAAA;EA24JJ;AACF;AAz4JI;EACE,4BAAA;EACA,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AA24JN;AAz4JM;EACE,yBAAA;AA24JR;AAx4JM;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AA04JR;AAx4JQ;EACE,aAAA;AA04JV;AAt4JM;EACE,UAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;EAEA,gBAAA;AAw4JR;AAr4JM;EACE,2BAAA;EACA,kBAAA;AAu4JR;AAp4JU;EACE,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAs4JZ;AAn4JU;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,8EAAA;AAq4JZ;AAn4JY;EACE,WAAA;AAq4Jd;AAl4JY;EAEE,qBAAA;EACA,aAAA;AAm4Jd;AA93JQ;EACE,UAAA;AAg4JV;AA13JE;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AA43JJ;AA13JI;EACE,qBAAA;EACA,yBAAA;AA43JN;AAz3JI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AA23JN;AAz3JM;EACE,qBAAA;EACA,yBAAA;AA23JR;AAv3JI;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,yBAAA;AAy3JN;AAv3JM;EACE,qBAAA;EACA,yBAAA;AAy3JR;AAr3JI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;AAu3JN;AAr3JM;EACE,qBAAA;EACA,yBAAA;AAu3JR;AAl3JE;EACE,aAAA;AAo3JJ;;AAh3JA;EACE,gBAAA;AAm3JF","sourcesContent":["// Font\n@import './../../../assets/styles/variables';\n@import './../../../app/components/custom-profile/interpretive-guide/interpretive-guide.component.scss';\n@import './../../../app/components/fs-profile/fs-profile.component.scss';\n@import './../../../app/components/dashboard/dashboard.component.scss';\n@import './../../../app/components/dashboard/dashboard.component.scss';\n\n#mc_embed_signup_scroll .row {\n  margin-left: -10px;\n  margin-right: -10px;\n}\n\ndiv#mc_embed_signup_scroll {\n  background: #6d6e71;\n  padding: 20px;\n  color: #fff;\n  max-width: 400px;\n}\n\ndiv#mc_embed_signup_scroll h2 {\n  margin-top: 0;\n}\n\ndiv#mc_embed_signup_scroll div[class*=\"col-\"] {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n#mc_embed_signup {\n  font-family: $muso-300;\n}\n\ninput#mce-EMAIL {\n  color: #000;\n}\n\n.branding-details {\n  .ibox {\n    box-shadow: none !important;\n  }\n\n  .ibox-content {\n    border: 1px solid #e7eaec;\n  }\n}\n\n.presenter-title {\n  font-size: 20px;\n  margin-bottom: 5px;\n}\n\n::ng-deep .hs-form {\n  color: #fff;\n  font-family: $muso-300;\n  padding: 5px 6px;\n\n  .legal-consent-container {\n    display: none !important;\n  }\n\n  div.hs-email {\n    float: left;\n    width: 60%;\n    position: relative;\n  }\n\n  .hs_error_rollup {\n    display: none;\n  }\n\n  ul.hs-error-msgs {\n    margin-left: 0px;\n    padding-left: 0px;\n    position: absolute;\n    color: rgb(193, 226, 21);\n    margin-top: 3px;\n\n    li {\n      list-style: none;\n    }\n  }\n\n  div.hs_submit {\n    float: right;\n    width: 35%;\n  }\n\n  .hs-input {\n    background-color: #fff;\n    background-image: none;\n    border: 1px solid #e5e6e7;\n    border-radius: 1px;\n    color: inherit;\n    display: block;\n    padding: 6px 12px;\n    -webkit-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n    transition: border-color .15s ease-in-out 0s, box-shadow .15s ease-in-out 0s;\n    width: 100%;\n    color: #000;\n  }\n\n  input.hs-button.primary.large {\n    border: 0 !important;\n    padding: 8px 15px !important;\n    line-height: 1.4em;\n    background: #5EB85C;\n    color: #fff;\n    width: 100%;\n    margin-top: 23px;\n  }\n}\n\ndiv#f-end {\n  position: relative;\n}\n\n::ng-deep.prefers_to {\n  font-family: 'Helvetica LT W05 Roman';\n  color: #5C5D60 !important;\n  font-size: 14px !important;\n  line-height: 17px !important;\n  text-transform: none;\n  letter-spacing: -0.04px;\n  font-weight: normal;\n  display: inline;\n  margin-bottom: 10px !important;\n  padding-right: 13px;\n}\n\n::ng-deep.chart-container {\n  box-shadow: none !important;\n\n  &__head {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: center;\n    line-height: 1.5;\n\n    // p {\n    //     font-family: \"Helvetica LT W05 Light\";\n    //     line-height: 1.5;\n    // }\n\n    // .head__right {\n    //     text-align: right;\n    // }\n\n    .foursight-content {\n      font-size: 16px !important;\n      line-height: 19px !important;\n      letter-spacing: 0 !important;\n    }\n  }\n\n  .head {\n    padding-top: 15px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    .head__right {\n      text-align: right;\n\n      p {\n        line-height: 10px;\n      }\n    }\n\n    p {\n      font-family: \"Helvetica LT W05 Light\";\n    }\n\n  }\n\n  &.white-bg {\n\n    &.profile-section {\n      padding: 0;\n    }\n  }\n\n  .chart-section {\n    width: 97%;\n    margin: 1% 0 0 3%;\n  }\n\n\n  .y-dividers {\n    border: 3px solid rgb(209, 210, 212);\n    height: 420px;\n  }\n}\n\n.lmslider {\n  margin-top: 30px;\n  position: relative;\n}\n\n::ng-deep.lmslider__ftrplayer {\n  color: #000;\n\n  audio {\n    color: #000;\n  }\n\n  audio::-webkit-media-controls-mute-button {\n    display: none;\n    pointer-events: none;\n    visibility: hidden;\n  }\n\n  audio::-webkit-media-controls-volume-slider-container {\n    display: none;\n    pointer-events: none;\n  }\n\n  ::-webkit-slider-thumb {\n    display: none;\n    pointer-events: none;\n\n  }\n\n  audio::-webkit-media-controls-volume-slider {\n    display: none;\n    pointer-events: none;\n\n  }\n}\n\n.loader-container {\n  position: absolute;\n  left: 0;\n  right: 0;\n  text-align: center;\n  top: 0;\n  bottom: 0;\n  background: rgba(236, 236, 236, .9);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: none;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  z-index: 9999999999;\n  height: 100vh;\n  margin: 0 auto;\n}\n\n.loader-spin {\n  background-color: hsla(0, 0%, 92.5%, .9);\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.loader__inner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n  animation: blink 2s linear infinite;\n  opacity: 0;\n}\n\n#Path_130 {\n  animation: blink 2s linear infinite;\n  animation-delay: .5s;\n  opacity: 0;\n}\n\n#Path_132 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1s;\n  opacity: 0;\n}\n\n#Path_131 {\n  animation: blink 2s linear infinite;\n  animation-delay: 1.5s;\n  opacity: 0;\n}\n\n@keyframes blink {\n  0% {\n    opacity: 0;\n  }\n\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n\n}\n\n.branding-details {\n  width: 40%;\n\n  .list-unstyled {\n    padding-left: 20px;\n\n    &--wd {\n      width: 100%;\n      max-width: 100%;\n      text-align: left;\n      list-style: disc;\n    }\n  }\n}\n\n.dash-steps {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-end;\n\n  img {\n    max-width: 100%;\n    width: 100%;\n    height: auto;\n    max-height: 302px;\n    object-fit: contain;\n  }\n\n  .step-checlist {\n    padding-top: 10px;\n    display: flex;\n    align-items: center;\n\n    i {\n      font-size: 2em;\n      color: $develop-color;\n      margin-right: 5px;\n    }\n  }\n}\n\n.dash-steps-wrapper {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n\n  &:after,\n  &:before {\n    display: none;\n  }\n}\n\n.dash-common {\n  display: flex;\n\n  .float-e-margins {\n    height: 100%;\n  }\n\n  .ibox-content {\n    border: none;\n  }\n}\n\n.no-border {\n  border: none !important;\n}\n\n\n.imp-top {\n\n  h1 {\n\n    a {\n      color: inherit;\n    }\n  }\n}\n\n::ng-deep .challenges-heading {\n\n  .fn-col {\n\n    &:nth-child(1) {\n      width: 60%;\n    }\n\n    &:nth-child(2) {\n      width: 40%;\n    }\n  }\n\n  h2 {\n    margin-bottom: 2px;\n  }\n\n  p {\n    font-size: 14px;\n  }\n\n  &__icon {\n    text-align: right;\n    display: flex;\n    justify-content: flex-end;\n\n    img {\n      width: 100px;\n    }\n\n    ::ng-deep .unliked-profile {\n      transform: scale(3);\n      display: inline-block;\n      transform-origin: right;\n\n      @media #{$mobile} {\n        transform: scale(2);\n      }\n    }\n  }\n}\n\n@keyframes assessPulseClarify {\n  0% {\n    background-color: $clarify-color;\n  }\n\n  70% {\n    background-color: darken($clarify-color, 9%)\n  }\n\n  100% {\n    background-color: $clarify-color;\n  }\n}\n\n@keyframes assessPulseIdeate {\n  0% {\n    background-color: $ideate-color;\n  }\n\n  70% {\n    background-color: darken($ideate-color, 9%)\n  }\n\n  100% {\n    background-color: $ideate-color;\n  }\n}\n\n@keyframes assessPulseDevelop {\n  0% {\n    background-color: $develop-color;\n  }\n\n  60% {\n    background-color: darken($develop-color, 9%)\n  }\n\n  100% {\n    background-color: $develop-color;\n  }\n}\n\n@keyframes assessPulseImplement {\n  0% {\n    background-color: $implement-color;\n  }\n\n  60% {\n    background-color: lighten($implement-color, 9%)\n  }\n\n  100% {\n    background-color: $implement-color;\n  }\n}\n\n\n.assess {\n\n  .fn-col {\n    @media #{$mobile} {\n      width: 100%;\n\n      &:not(:last-child) {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  --imageGap: 7.5%;\n  --animDuration: 2s;\n\n  &__tab {\n    position: relative;\n  }\n\n  &__border {\n    opacity: var(--opacity);\n  }\n\n  &__image {\n\n    &box {\n      animation-direction: alternate;\n\n      img {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%) rotate(-45deg);\n        max-width: 75%;\n        pointer-events: none;\n      }\n    }\n\n    &--active {\n      --opacity: 1;\n\n      .assess__imagebox {\n        box-shadow: 0 0 0 2px $clrWhite , 0 0 10px rgb(0 0 0 / 20%);\n      }\n\n      &.assess__image--clarify {\n\n        .assess__imagebox {\n          animation: assessPulseClarify var(--animDuration) infinite;\n        }\n      }\n\n      &.assess__image--ideate {\n\n        .assess__imagebox {\n          animation: assessPulseIdeate var(--animDuration) infinite;\n        }\n      }\n\n      &.assess__image--develop {\n\n        .assess__imagebox {\n          animation: assessPulseDevelop var(--animDuration) infinite;\n        }\n      }\n\n      &.assess__image--implement {\n\n        .assess__imagebox {\n          animation: assessPulseImplement var(--animDuration) infinite;\n        }\n      }\n\n\n    }\n\n    position: absolute;\n    width: 40.762%;\n    height: 40.762%;\n    opacity: var(--opacity);\n\n    &box {\n      width: 70%;\n      padding-bottom: 70%;\n      background-color: var(--clrProfile);\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%) rotate(45deg);\n\n      &content {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%) rotate(-45deg);\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        h3 {\n          color: $clrWhite;\n          font-size: 1.7vw;\n\n          @media #{$mobile} {\n            font-size: 4.5vw;\n          }\n        }\n\n      }\n    }\n\n\n    &--clarify {\n      top: var(--imageGap);\n      left: 50%;\n      transform: translateX(-50%);\n    }\n\n    &--ideate {\n      top: 50%;\n      right: var(--imageGap);\n      transform: translateY(-50%);\n    }\n\n    &--develop {\n      bottom: var(--imageGap);\n      left: 50%;\n      transform: translateX(-50%);\n    }\n\n    &--implement {\n      top: 50%;\n      left: var(--imageGap);\n      transform: translateY(-50%);\n    }\n  }\n\n  &__content {\n\n    &>*:not(:last-child) {\n      margin-bottom: calc($secPad / 3);\n    }\n  }\n}\n\n::ng-deep.share-result {\n  padding-bottom: $secPad;\n\n  &__wrapper {\n    background-image: url(#{$adminUpload}242/original.png);\n    background-size: cover;\n    background-position: center;\n    padding-block: ($secPad + 40);\n    padding-end: ($secPad);\n\n    @media #{$mobile} {\n      padding-block: $secPad;\n      padding-inline: calc($secPad / 3);\n    }\n  }\n\n  &__social {\n\n    ul {\n      margin: 0;\n      padding: 0;\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      align-items: center;\n      line-height: 0;\n    }\n\n    li {\n      margin-inline: 12px;\n      list-style: none;\n\n      @media #{$mobile} {\n        margin-inline: 10px;\n      }\n    }\n\n    a {\n      display: inline-block;\n      transition: 0.3s;\n\n      &:hover {\n        opacity: 0.8;\n      }\n    }\n\n    img {\n      width: 36px;\n\n      @media #{$mobile} {\n        width: 30px;\n      }\n    }\n  }\n}\n\n\n::ng-deep.dashcheck {\n\n  $dashcheck: \".dashcheck\";\n\n  padding-block-end: 0;\n\n  &__colrow {\n\n    .fn-col {\n      @media #{$tablet} {\n        width: 50%;\n      }\n\n      @media #{$mobile} {\n        width: 100%;\n      }\n\n    }\n  }\n\n\n  &__cell {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    cursor: pointer;\n\n    &:hover {\n\n      #{$dashcheck}__box {\n        border-color: $develop-color;\n      }\n\n      #{$dashcheck}__content {\n        display: none;\n      }\n\n      // #{$dashcheck}__activecontent {\n      //     display: block;\n      // }\n\n    }\n\n    &--active {\n\n      #{$dashcheck}__box {\n        border-color: $develop-color;\n      }\n\n      #{$dashcheck}__content {\n        display: none;\n      }\n\n      #{$dashcheck}__activecontent {\n        display: block;\n      }\n\n\n    }\n  }\n\n  &__box {\n    position: relative;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    border: 2px solid $color-neutral-light;\n    border-radius: 5px;\n    overflow: hidden;\n  }\n\n  &__image {\n    padding: 15px;\n\n    &inner {\n      position: relative;\n      padding-bottom: 70%;\n    }\n\n    img {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n    }\n  }\n\n  &__content,\n  &__activecontent {\n    text-align: center;\n    background-color: $color-neutral-light;\n    padding: calc($secPad / 3) calc($secPad / 2);\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    h3,\n    h6 {\n      font-weight: bold;\n    }\n\n    *:not(i) {\n      font-family: $font-stack;\n    }\n  }\n\n  &__activecontent {\n    background-color: $clrWhite;\n  }\n\n  &__time {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n\n    i {\n      &:not(:last-child) {\n        margin-right: 3px;\n      }\n    }\n\n    h6 {\n      font-size: inherit;\n    }\n  }\n\n  &__button {\n    display: none;\n    margin-top: 20px;\n\n    .fbtn {\n      width: 100%;\n      font-family: $font-stack;\n      font-weight: 700;\n      border-radius: 5px;\n      text-transform: uppercase;\n\n      i {\n        margin-right: 7px;\n\n      }\n    }\n  }\n\n  &__dots {\n    --size: 38px;\n    --sizeHalf: (var(--size) / 2);\n    --shadowSize: 14px;\n\n    @media #{$mobile} {\n      --size: 26px;\n      --shadowSize: 8px;\n    }\n\n    margin-block-start: calc($secPad / 2);\n    margin-block-end: ($secPad);\n\n    .dashcheck__col {\n      position: relative;\n\n      &:not(:last-child) {\n\n        &::before {\n          content: \"\";\n          position: absolute;\n          top: 50%;\n          left: calc(50% + var(--sizeHalf));\n          transform: translateY(-50%);\n          width: calc(100% - var(--size));\n          height: 1px;\n          background-color: $color-neutral-light;\n        }\n      }\n\n      &--active {\n\n        &:not(:last-child) {\n          &::before {\n            background-color: $develop-color;\n          }\n        }\n\n        #{$dashcheck}__dot {\n          background-color: $develop-color;\n          border-color: $develop-color;\n          box-shadow: 0 0 0 var(--shadowSize) $clrWhite, 0 0 0 calc(var(--shadowSize) + 1px) $develop-color;\n        }\n\n      }\n    }\n  }\n\n  &__dot {\n    width: var(--size);\n    height: var(--size);\n    border: 1px solid $color-neutral-light;\n    border-radius: 50%;\n    margin-inline: auto;\n    position: relative;\n    z-index: 1;\n\n    svg {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      width: 17px;\n    }\n  }\n}\n\n::ng-deep.presenter {\n\n  .fn-col {\n\n    @media #{$mobile} {\n      width: 100%;\n    }\n  }\n\n  &__item {\n    border: 1px solid $color-neutral-light;\n    padding: calc($secPad / 3);\n    border-radius: 5px;\n    height: 100%;\n\n    &+div {\n      margin-top: calc($secPad / 2);\n    }\n\n    h2 {\n      border-bottom: 1px solid $color-neutral-light;\n      padding-bottom: 10px;\n    }\n  }\n\n  &__content {\n\n    &:not(:last-child) {\n      margin-bottom: 15px;\n    }\n\n\n    ul {\n\n      &:not(:last-child) {\n        margin-bottom: 10px;\n      }\n\n      &:not(.presenter__address) {\n        padding-left: 0;\n      }\n\n      &.custom-list {\n\n        li {\n\n          &::before {\n            background-color: $color-neutral-dark;\n          }\n        }\n      }\n    }\n\n    li {\n      list-style: none;\n\n      &:not(:last-child) {\n        margin-bottom: 4px;\n      }\n\n    }\n\n    p,\n    li {\n      font-size: 15px;\n    }\n  }\n\n  &__address {\n\n    &--spc {\n      margin: 0 auto !important;\n      width: 100%;\n      max-width: 130px;\n    }\n\n    li {\n      list-style: none;\n      color: $color-neutral-dark;\n\n      a {\n        color: inherit;\n      }\n\n      i {\n        margin-right: 7px;\n        color: $color-neutral-light;\n        font-size: 18px;\n      }\n    }\n  }\n\n  &__broughtby {\n    display: inline-block;\n    width: 100%;\n    margin: 20px 0 0;\n    text-align: center;\n\n    img {\n      min-width: 250px;\n      max-width: 250px !important;\n    }\n  }\n\n  .fn-btn {\n    font-family: $font-stack;\n    border-radius: 3px;\n  }\n}\n\n::ng-deep .footer {\n  position: fixed;\n  margin-left: auto;\n\n  @media screen and (min-width: 769px) {\n    width: calc(100% - 220px);\n  }\n}\n\n::ng-deep .all-learner-maps {\n\n  &.lm-an-cards {\n    display: none;\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n\n  .car-small-heading {\n    color: #fff;\n  }\n\n  .practioner-dash-wrap--ss {\n    background: #F1F1F2;\n    border-radius: 6px;\n    color: #fff;\n    padding: 30px 38px;\n  }\n\n  .product-imitation {\n    background-color: #fff;\n    color: #676a6c;\n  }\n}\n\n::ng-deep .unliked-profile .profile_types {\n  width: 35px !important;\n  height: 16px !important;\n}\n\n::ng-deep .lmslider__notes {\n  padding-top: 0px;\n  \n  > h3 {\n    text-transform: capitalize;\n  }\n}\n\n.ig-right {\n  width: 25%;\n  justify-content: flex-start;\n  align-items: flex-end;\n}\n\n.breadcrumb {\n\n  li {\n\n    strong {\n\n      span {\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n::ng-deep .modal-body {\n\n  .expire-form {\n\n    p {\n      padding-bottom: 60px;\n    }\n  }\n}\n\n// Modal Design\n::ng-deep .modal {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  display: none;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  outline: 0;\n\n  &-title {\n    float: none !important;\n  }\n\n  &.show {\n    display: block !important;\n  }\n\n  &.grey {\n    background: rgba(236, 236, 236, 0.9);\n  }\n\n  &.fade {\n    .modal-dialog {\n      transition: transform 0.3s ease-out;\n    }\n\n    &.in {\n      opacity: 1;\n    }\n  }\n\n  &.in {\n    .modal-dialog {\n      transform: translate(0, 0);\n    }\n  }\n\n  &.modal-open {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n\n  .modal-dialog {\n    position: relative;\n    width: auto;\n    margin: 10px;\n\n    @media (min-width: 768px) {\n      width: 600px;\n      margin: 30px auto;\n    }\n\n    .modal-content {\n      background-clip: padding-box;\n      background-color: #FFFFFF;\n      border: 1px solid rgba(0, 0, 0, 0);\n      border-radius: 4px;\n      box-shadow: 0 1px 3px rgb(0 0 0 / 30%);\n      outline: 0 none;\n      position: relative;\n\n      .all_guides {\n        border: 1px solid #e5e5e5;\n      }\n\n      .close {\n        float: right;\n        font-size: 21px;\n        font-weight: bold;\n        line-height: 1;\n        color: #000;\n        text-shadow: 0 1px 0 #fff;\n        filter: alpha(opacity=20);\n        opacity: 0.2;\n\n        &:focus-visible {\n          outline: none;\n        }\n      }\n\n      button.close {\n        padding: 0;\n        cursor: pointer;\n        background: transparent;\n        border: 0;\n        -webkit-appearance: none;\n        appearance: none;\n      }\n\n      .modal-body {\n        padding: 20px 30px 0px 30px;\n        position: relative;\n\n        form {\n          label {\n            display: inline-block;\n            max-width: 100%;\n            margin-bottom: 5px;\n            font-weight: 700;\n          }\n\n          input[type=text] {\n            width: 100%;\n            color: inherit;\n            display: block;\n            font-size: 14px;\n            line-height: 1.4;\n            padding: 6px 12px;\n            border-radius: 1px;\n            background-image: none;\n            background-color: #fff;\n            border: 1px solid #e5e6e7;\n            transition: border-color .15s ease-in-out 0s, box-shadow .15s ease-in-out 0s;\n\n            &::-webkit-input-placeholder {\n              color: #999;\n            }\n\n            &:focus,\n            &:focus-visible {\n              border-color: #1ab394;\n              outline: none;\n            }\n          }\n        }\n\n        &.no-pad {\n          padding: 0;\n        }\n      }\n    }\n  }\n\n  .f-btn {\n    color: #fff;\n    font-size: 14px;\n    border-color: #73BF38;\n    background-color: #73BF38;\n\n    &:hover {\n      border-color: #4cae4c;\n      background-color: #4cae4c;\n    }\n\n    &--dngr {\n      color: #fff;\n      border-color: #ED5565;\n      background-color: #ED5565;\n\n      &:hover {\n        border-color: #ec4758;\n        background-color: #ec4758;\n      }\n    }\n\n    &--info {\n      color: #fff;\n      font-size: 12px;\n      line-height: 1.5;\n      padding: 5px 10px;\n      border-color: #23c6c8;\n      background-color: #23c6c8;\n\n      &:hover {\n        border-color: #21b9bb;\n        background-color: #21b9bb;\n      }\n    }\n\n    &--wrng {\n      color: #fff;\n      border-color: #f8ac59;\n      background-color: #f8ac59;\n\n      &:hover {\n        border-color: #f7a54a;\n        background-color: #f7a54a;\n      }\n    }\n  }\n\n  .hidden {\n    display: none;\n  }\n}\n\n::ng-deep.modal-open {\n  overflow: hidden;\n}","// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","// fonts\n@import '../../../../assets/styles/variables';\n\n@import url('https://assets.foursightonline.com/app/fonts/webfonts/webfonts.css');\n\n$profile: '.fn-profile';\n\n#{$profile} {\n\n  .section-title {\n\n    width: min(620px, 100%);\n    margin-inline: auto;\n\n    &__linkcontainer {\n      flex-direction: column;\n    }\n  }\n\n  &__blocks {\n\n    --dotsGap: 10px;\n\n    .f-flex {\n      align-items: center;\n\n      &:nth-child(1) {\n        .fn-profile__pic {\n\n          figure {\n\n            &::before {\n              display: none;\n            }\n          }\n        }\n      }\n\n      &:nth-child(even) {\n        flex-direction: row-reverse;\n\n\n        #{$profile}__pic {\n\n          figure {\n\n            &::after {\n              left: auto;\n              right: calc(100% + var(--dotsGap));\n            }\n          }\n        }\n      }\n\n      &+div {\n        margin-top: 100px;\n\n        @media #{$mobile} {\n          margin-top: calc(#{$secPad} / 2);\n        }\n      }\n\n      &>div:first-child {\n        @media #{$mobile-up} {\n          width: 45%;\n        }\n\n      }\n\n      &>div:last-child {\n        @media #{$mobile-up} {\n          width: 55%;\n        }\n\n      }\n    }\n\n    .fn-col {\n      position: relative;\n\n      &:nth-child(1) {\n        width: 45%;\n\n        @media #{$mobile} {\n          width: 100%;\n\n          &:not(:last-child) {\n            margin-bottom: 20px;\n          }\n        }\n      }\n\n      &:nth-child(2) {\n        width: 55%;\n\n        @media #{$mobile} {\n          width: 100%;\n        }\n      }\n    }\n  }\n\n  &__pic {\n\n    max-width: 284px;\n    width: 100%;\n    margin-inline: auto;\n\n\n    @media #{$mobile} {\n      width: 200px;\n    }\n\n    figure {\n      position: relative;\n      padding-bottom: 100%;\n\n      &::before {\n        content: \"\";\n        position: absolute;\n        left: 50%;\n        transform: translateX(-50%);\n        bottom: calc(100% + var(--dotsGap));\n        width: 8px;\n        height: 60px;\n        background-image: url(#{$adminUpload}226/original.png);\n\n        @media #{$tablet} {\n          display: none;\n        }\n      }\n\n      &::after {\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        left: calc(100% + var(--dotsGap));\n        width: 62px;\n        height: 8px;\n        background-image: url(#{$adminUpload}219/original.png);\n\n        @media #{$tablet} {\n          display: none;\n        }\n      }\n\n      img {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n        border-radius: 100%;\n      }\n    }\n\n    h5 {\n      font-size: calc(#{$fn-fs-h6} - 2px);\n      margin-top: 20px;\n      text-align: center;\n      max-width: 170px;\n      margin-inline: auto;\n\n    }\n  }\n\n  &__content {\n    max-width: 88%;\n    margin-inline: auto;\n\n    p {\n      line-height: 1.8;\n    }\n  }\n}\n\n.fn-framework {\n\n  &__top {\n    background-color: $color-neutral-dark;\n    padding: calc($secPad / 2);\n\n    @media #{$tablet} {\n      padding: 30px;\n    }\n\n    h2 {\n      color: $clrWhite;\n\n      @media #{$mobile} {\n        margin-bottom: var(--hGap);\n      }\n    }\n\n    h3 {\n      color: $clrWhite;\n      font-weight: normal;\n      font-family: $font-stack;\n      line-height: 1.4;\n    }\n\n    p {\n      color: $clrWhite;\n    }\n  }\n\n  &__bottom {\n    max-width: 800px;\n    margin-inline: auto;\n    margin-top: calc($secPad / 2);\n\n    @media #{$mobile} {\n      margin-top: calc($secPad / 2);\n    }\n\n    p {\n      color: $color-neutral-dark-500;\n    }\n\n    img {\n      width: 334px;\n      margin-inline: auto;\n      display: block;\n    }\n\n    .fn-row {\n      @media #{$mobile} {\n        flex-direction: column-reverse;\n      }\n    }\n  }\n}\n\n\n.fn-preferences {\n\n  &__sign {\n    margin-bottom: 30px;\n\n    img {\n      width: 130px;\n    }\n  }\n\n  &__icon {\n    position: absolute;\n    top: calc(#{$secPad} - 20px);\n    right: calc(#{$secPad} - 20px);\n    max-width: 220px;\n    max-height: 180px;\n    z-index: -1;\n\n\n    @media #{$mobile} {\n      max-width: 150px;\n      top: 20px;\n      right: 20px;\n    }\n  }\n\n  &__blocks {\n\n    &>.f-flex {\n\n      margin-inline: 0;\n\n      @media #{$mobile} {\n\n        &+div {\n          margin-top: calc($secPad / 2);\n        }\n      }\n\n      &:nth-child(even) {\n        flex-direction: row-reverse;\n      }\n\n      &>[class*=\"f-col-\"] {\n\n        position: relative;\n        padding: calc(#{$secPad} - 20px);\n\n        @media #{$mobile} {\n          padding: calc($secPad / 3);\n        }\n\n        &:nth-child(1) {\n          background-color: var(--clrProfile);\n          display: flex;\n          flex-wrap: wrap;\n          justify-content: center;\n          flex-direction: column;\n          z-index: 0;\n\n          @media #{$mobile} {\n            border-top-right-radius: ($secPad - 10);\n          }\n\n          &>*:not(:last-child) {\n            margin-bottom: calc(var(--hGap) * 2.5);\n\n            @media #{$mobile} {\n              margin-bottom: var(--hGap);\n            }\n          }\n        }\n\n        &:nth-child(2) {\n\n          @media #{$mobile} {\n            background-color: darken($clrWhite , 5%);\n          }\n        }\n\n        [class*=\"f-col-\"] {\n          @media #{$mobile} {\n            width: 100%;\n\n            &:not(:last-child) {\n              margin-bottom: calc($secPad / 2);\n            }\n          }\n        }\n      }\n    }\n\n    h2 {\n      color: $clrWhite;\n    }\n\n    h3 {\n      font-family: $font-stack;\n      font-size: $fn-fs-h4;\n      color: $clrWhite;\n      line-height: 1.3;\n      font-weight: normal;\n\n      @media #{$mobile} {\n        font-size: $fn-fs-h4-mobile;\n      }\n    }\n\n    ul {\n\n      &+.f-flex {\n        margin-block-start: ($secPad - 30px);\n\n        &>[class*=\"f-col-\"] {\n\n          @media #{$tablet} {\n            width: 100%;\n\n            &:not(:last-child) {\n              margin-bottom: var(--gap-2);\n            }\n          }\n        }\n\n        &+* {\n          margin-block-start: ($secPad - 30px);\n        }\n      }\n    }\n\n    li {\n\n      &::before {\n        background-color: $color-neutral-dark;\n      }\n    }\n\n    h5 {\n      color: var(--clrProfile);\n      margin-bottom: calc(var(--hGap) / 2);\n\n      &+ul {\n\n        li {\n          font-size: 16px;\n        }\n      }\n    }\n\n    p {\n      font-size: 16px;\n    }\n  }\n}\n\n\n.fn-communicate {\n\n  &__items {\n    padding-block: calc($secPad / 2);\n\n    &:first-child {\n      padding-top: 0;\n    }\n\n    &-heading {\n\n      @media #{$mobile} {\n        display: none;\n\n        &+div {\n          padding-top: 0;\n        }\n      }\n    }\n\n    &:not(:last-child) {\n      border-bottom: 1px solid $clrGrey;\n    }\n\n    .fn-communicate__title {\n      text-align: center;\n      color: $clrWhite;\n      background-color: var(--clrProfile);\n      padding-block: calc($secPad / 2);\n      padding-inline: calc($secPad / 3);\n\n      @media #{$mobile} {\n        padding-block: calc($secPad / 5);\n        padding-inline: calc($secPad / 4);\n        width: fit-content;\n      }\n    }\n  }\n\n  p {\n\n    @media #{$mobile} {\n\n      &::before {\n        content: attr(data-title) \" : \";\n        font-weight: 600;\n        margin-right: 3px;\n      }\n    }\n  }\n}\n\n\n.fn-collaborate {\n\n  .f-col-3 {\n\n    @media (min-width: 768px) and (max-width: 991px) {\n      width: 50%;\n    }\n  }\n\n  &__cell {\n\n    background-color: $clrWhite;\n    height: 100%;\n    padding: calc($secPad / 3);\n\n    h3 {\n      color: var(--clrProfile);\n      word-break: break-word;\n    }\n\n    .custom-list {\n\n      li {\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n.fn-manage {\n\n  &__graph {\n\n    &:not(:last-child) {\n      margin-bottom: calc($secPad / 2);\n    }\n\n    img {\n      max-width: none;\n      width: 100%;\n    }\n  }\n\n  .fn-col {\n\n    @media #{$tablet} {\n      width: 50%;\n    }\n  }\n\n  &__cell {\n    text-align: center;\n    max-width: 200px;\n    margin-inline: auto;\n\n    img {\n      max-width: 32px;\n      max-height: 61px;\n      margin-bottom: calc($secPad / 3);\n    }\n\n    h3 {\n      width: min-content;\n      margin-inline: auto;\n    }\n  }\n}\n\n.fn-tips {\n  counter-reset: tips-count;\n\n  .fn-col {\n    @media #{$mobile} {\n      width: 100%;\n    }\n  }\n\n  &__cell {\n    height: 100%;\n    position: relative;\n    padding-left: ($secPad);\n\n    &::before {\n      counter-increment: tips-count;\n      content: counter(tips-count) \".\";\n      color: $color-neutral-dark;\n      font-size: $fn-fs-h1;\n      font-family: $muso-700;\n      position: absolute;\n      top: -5px;\n      left: 0;\n    }\n  }\n\n  &__bottom {\n    width: min(1000px, 100%);\n    margin-inline: auto;\n\n    p {\n      a {\n        font-size: 20px;\n      }\n    }\n\n    &>*:not(:last-child) {\n      margin-bottom: calc($secPad / 2);\n    }\n\n    .btn {\n      padding: 10px 25px;\n      font-size: 1.2em;\n    }\n  }\n}\n\n.modal-header {\n  padding: 15px;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.pa_assessment {\n  line-height: 2em;\n  padding: 0.75rem 0.75rem 0.75rem 0 !important;\n}\n\n.clearfix {\n  clear: both;\n}\n\n.package-form {\n\n  select {\n    border: 1px solid #ddd;\n    padding: 10px !important;\n    height: 40px;\n    background: #F8F8F8;\n    color: #636363;\n    font-family: \"Museo-300\";\n    margin-bottom: 10px;\n    width: 55%;\n  }\n\n  .assessment-select {\n\n    select {\n      height: 30px;\n      padding: 5px !important;\n      width: 45%;\n      background-color: #fff;\n    }\n  }\n\n  label {\n    width: 55%;\n    line-height: 2em;\n    padding: 0.75rem 0.75rem 0.75rem 0;\n    margin-bottom: 5px;\n  }\n\n  .btn {\n    margin-top: 10px;\n\n    &-sm {\n      padding: 5px 10px;\n    }\n  }\n\n  .guide-rdbtn {\n    padding-bottom: 25px;\n\n    label {\n      padding: 0 !important;\n      width: 65%;\n    }\n\n    &--disable {\n      pointer-events: none;\n      opacity: 0.5;\n    }\n  }\n\n  .modal-body__buttons {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n    border-top: 1px solid #ddd;\n    width: calc(100% + 32px);\n    margin: 0 -16px;\n    padding: 5px 10px;\n    background-color: #f6f6f6;\n\n    .btn {\n      margin-top: 0;\n\n      &-prim {\n        margin-inline-start: 10px;\n\n      }\n\n      &-disable {\n        cursor: not-allowed;\n        pointer-events: none;\n      }\n    }\n  }\n}\n\n.modal-title {\n  float: left;\n\n  &--fs {\n    font-size: 16px;\n  }\n}\n\n.modal-body {\n  padding: 20px 30px 0;\n}\n\n.modal-pf {\n  .col-sm-5 {\n    padding: 0 15px;\n  }\n\n  .right-button {\n\n    p {\n      margin-bottom: 10px;\n    }\n\n    &.text-right {\n      width: 100%;\n      text-align: center;\n      margin: 3px 0 8px;\n\n      a {\n        padding: 5px 10px;\n        width: 100%;\n      }\n    }\n  }\n}\n\n.fn__guidbtn {\n  position: relative;\n  padding-bottom: 20px;\n  max-width: 820px;\n  width: 100%;\n\n  a {\n    position: absolute;\n    right: -10px;\n    top: 0;\n    width: 100%;\n    max-width: 245px;\n    cursor: pointer;\n    border-radius: 4px;\n    \n    @media #{$tablet} {\n      right: 0;\n    }\n  }\n}\n\n.guide-modal {\n\tdisplay: none;\n}\n\n/****************\n    14-December \n****************/\n\n// Profile Styling\n\n$profile: '.fn-profile';\n\n#{$profile} {\n\n  &__pic {\n\n    figure {\n      margin: 0;\n    }\n  }\n}","/* style-for-Profile-chart */\n\n// fonts\n@import './../../../assets/styles/variables';\n\n@import url('https://assets.foursightonline.com/app/fonts/webfonts/webfonts.css');\n\n@font-face {\n  font-family: 'Conv_museo-500-webfont';\n  src: url($assets+'/fonts/museo-500-webfont.eot');\n  src: local('☺'), url($assets+'/fonts/museo-500-webfont.woff') format('woff'), url($assets+'/fonts/museo-500-webfont.ttf') format('truetype'), url($assets+'/fonts/museo-500-webfont.svg') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n// vendor prefixes mixin\n@mixin prefix($property, $value, $prefixes: ()) {\n  @each $prefix in $prefixes {\n    #{'-' + $prefix + '-' + $property}: $value;\n  }\n\n  // Output standard non-prefixed declaration\n  #{$property}: $value;\n}\n\n/*========== mixin for animation ====================*/\n//Animations\n@mixin animation($animation) {\n  -webkit-animation: $animation;\n  -o-animation: $animation;\n  animation: $animation;\n}\n\n@mixin animation-name($name) {\n  -webkit-animation-name: $name;\n  animation-name: $name;\n}\n\n@mixin animation-duration($duration) {\n  -webkit-animation-duration: $duration;\n  animation-duration: $duration;\n}\n\n@mixin animation-timing-function($timing-function) {\n  -webkit-animation-timing-function: $timing-function;\n  animation-timing-function: $timing-function;\n}\n\n@mixin animation-delay($delay) {\n  -webkit-animation-delay: $delay;\n  animation-delay: $delay;\n}\n\n@mixin animation-iteration-count($iteration-count) {\n  -webkit-animation-iteration-count: $iteration-count;\n  animation-iteration-count: $iteration-count;\n}\n\n@mixin animation-direction($direction) {\n  -webkit-animation-direction: $direction;\n  animation-direction: $direction;\n}\n\n@mixin animation-fill-mode($fill-mode) {\n  -webkit-animation-fill-mode: $fill-mode;\n  animation-fill-mode: $fill-mode;\n}\n\n.chart-section {\n\n  //padding: 25px 0 43px 0;\n  // min-width: 580px;\n  width: 90%;\n  margin: 5% auto 0 auto;\n  padding-bottom: 20px;\n\n  /*------background colors used in chart---------*/\n  // .blue-bg {\n  //   background-color: $clarify-color !important;\n  // }\n  // .orange-bg {\n  //   background-color: $ideate-color !important;\n  // }\n  // .green-bg {\n  //   background-color: $develop-color !important;\n  // }\n  // .purple-bg {\n  //   background-color: $implement-color !important;\n  // }\n\n  /*------chart area wrapper---------*/\n\n  /*------main chart wrapper---------*/\n  .chart-main {\n    width: 100%;\n    height: 250px;\n    display: table;\n    border-collapse: collapse;\n    margin: 0 auto;\n    float: none;\n    position: relative;\n  }\n\n  /*------y dividers css---------*/\n  .y-dividers {\n    display: table;\n    border-collapse: collapse;\n    width: 100%;\n    height: 100%;\n    //position: absolute;\n    left: 0px;\n    top: 0px;\n  }\n\n  @media screen and (-ms-high-contrast: active),\n  (-ms-high-contrast: none) {\n    .y-dividers {\n      position: absolute;\n    }\n  }\n\n  .dividers-yxis {\n    border-right: 1px solid #eee;\n    border-collapse: collapse;\n    display: table-cell;\n    width: 20%;\n    table-layout: fixed;\n    position: relative;\n  }\n\n  .dividers-yxis:first-child {\n    border-left: 1px solid #eee;\n  }\n\n  /*------x dividers css---------*/\n  .x-dividers {\n    display: block;\n    border-collapse: collapse;\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n\n    .owl-carousel & {\n      -webkit-backface-visibility: hidden;\n      backface-visibility: hidden;\n    }\n  }\n\n  .dividers-xxis {\n    border-collapse: collapse;\n    width: 100%;\n    height: 20%;\n    border-bottom: 1px solid #eee;\n    position: relative;\n  }\n\n  .dividers-xxis:first-child {\n    border-top: 1px solid #eee;\n  }\n\n  /*------chart labels css---------*/\n  .side-label {\n    font-size: 16px;\n    color: rgba(0, 0, 0, .4) !important;\n    position: absolute;\n    left: -25px;\n    top: -8px;\n    text-align: right;\n    width: 20px;\n  }\n\n  .label-0 {\n    position: absolute;\n    top: inherit;\n    bottom: -8px;\n  }\n\n  /*------preferences css---------*/\n  .preference {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    left: 0;\n    top: 0;\n    padding: 0 30px;\n    font-size: 16px;\n    font-weight: 500;\n  }\n\n  .high_prefer {\n    position: absolute;\n    top: 20px;\n    color: rgba(0, 0, 0, .4) !important;\n    left: 30px;\n  }\n\n  .low_prefer {\n    position: absolute;\n    bottom: 20px;\n    color: rgba(0, 0, 0, .4) !important;\n    left: 30px;\n  }\n\n  /*------neutral bar css---------*/\n  .neutral {\n    display: block;\n    margin-left: -30px;\n    margin-right: -30px;\n    background: $integrator-color !important;\n    position: absolute;\n    padding-left: 30px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    z-index: 1;\n    width: 100%;\n    height: 30px;\n    // -webkit-transform: translateY(-50%);\n    // -ms-transform: translateY(-50%);\n    // transform: translateY(-50%);\n    text-align: left;\n  }\n\n  .neutral span {\n    position: absolute;\n    left: 0;\n    font-size: 12px;\n  }\n\n  .neutral_high_value {\n    top: -15px;\n  }\n\n  .neutral_low_value {\n    bottom: -15px;\n  }\n\n  /*------chart titles css---------*/\n  .chart-title {\n    text-transform: uppercase;\n    font-size: 16px;\n    color: $color-light-type !important;\n    display: inline-block;\n    padding: 5px 0px;\n    width: 110px;\n    text-align: center;\n    position: absolute;\n    bottom: -31px;\n    right: -55px;\n    cursor: pointer;\n    z-index: 99;\n\n    html.mac.safari & {\n      bottom: -45px;\n    }\n  }\n\n  .chart-title.blue-bg:before,\n  .chart-title.orange-bg:before,\n  .chart-title.green-bg:before,\n  .chart-title.purple-bg:before {\n    content: \"\";\n    position: absolute;\n    top: -10px;\n    left: 0;\n    width: 0;\n    height: 0;\n    border-style: solid;\n    line-height: 0px;\n    border-width: 0 55px 10px 55px;\n    _filter: progid:DXImageTransform.Microsoft.Chroma(color='#000000');\n  }\n\n  // .chart-title.blue-bg:before {\n  //   border-color: transparent transparent $clarify-color transparent;\n  //   _border-color: #000000 #000000 $clarify-color #000000;\n  // }\n  // .chart-title.orange-bg:before {\n  //   border-color: transparent transparent $ideate-color transparent;\n  //   _border-color: #000000 #000000 $ideate-color #000000;\n  // }\n  // .chart-title.green-bg:before {\n  //   border-color: transparent transparent $develop-color transparent;\n  //   _border-color: #000000 #000000 $develop-color #000000;\n  // }\n  // .chart-title.purple-bg:before {\n  //   border-color: transparent transparent $implement-color transparent;\n  //   _border-color: #000000 #000000 $implement-color #000000;\n  // }\n\n  /*------chart pointers css---------*/\n  .chart_pointers {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 5;\n  }\n\n  .pointer {\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    display: inline-block;\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    color: $color-light-type !important;\n    font-weight: 600;\n    font-size: 16px;\n    text-align: center;\n    line-height: 35px;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    margin-bottom: -35px;\n    font-weight: 600;\n    font-family: \"Helvetica LT W05 Bold\" !important;\n  }\n\n  .pointer.clarify_pointer {\n    left: -ms-calc(20% - 17px);\n    left: calc(20% - 17px);\n  }\n\n  .pointer.ideate_pointer {\n    left: -ms-calc(40% - 17px);\n    left: -o-calc(40% - 17px);\n    left: calc(40% - 17px);\n  }\n\n  .pointer.develop_pointer {\n    left: -ms-calc(60% - 17px);\n    left: -o-calc(60% - 17px);\n    left: calc(60% - 17px);\n  }\n\n  .pointer.implement_pointer {\n    left: -ms-calc(80% - 17px);\n    left: -o-calc(80% - 17px);\n    left: calc(80% - 17px);\n  }\n\n  /*------chart pointers css end---------*/\n\n  /*------connector css start---------*/\n  .connectors {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n\n  .connector_block {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 20%;\n    z-index: 4;\n  }\n\n  .block1 {\n    margin-left: 20%;\n  }\n\n  .block2 {\n    margin-left: 60%;\n  }\n\n  .block3 {\n    margin-left: 40%;\n  }\n\n  .connector_line {\n    position: absolute;\n    width: 8px;\n    margin-top: -15px;\n    background-color: $profile-connector-color !important;\n  }\n\n  .connector_point {\n    position: absolute;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n    width: 35px;\n    height: 35px;\n    margin-bottom: -35px;\n  }\n\n  #connector_clarify_pointer,\n  #connector_develop_pointer,\n  #mid_connector_1 {\n    left: -17px;\n  }\n\n  #connector_ideate_pointer,\n  #connector_implement_pointer,\n  #mid_connector_2 {\n    right: -17px;\n  }\n\n  /*------connector css end---------*/\n\n  .hidden-xs {\n    display: block;\n  }\n\n  .visible-xs {\n    display: none;\n  }\n\n  .chart-title.sm .visible-xs {\n    display: block !important;\n  }\n\n  .chart-title.sm .hidden-xs {\n    display: none !important;\n  }\n\n  .chart-title.sm {\n    width: 52px;\n    padding-left: 10px;\n    padding-right: 10px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    right: -25px;\n    text-transform: capitalize;\n    font-size: 14px;\n  }\n\n  .chart-title.blue-bg.sm:before,\n  .chart-title.orange-bg.sm:before,\n  .chart-title.green-bg.sm:before,\n  .chart-title.purple-bg.sm:before {\n    border-width: 0 26px 10px 26px;\n  }\n\n  @media only screen and (max-width: 689px) {\n    #chartarea {\n      min-width: 320px;\n      padding-left: 15px;\n    }\n\n    .chart-title {\n      width: 52px;\n      padding-left: 10px;\n      padding-right: 10px;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      right: -25px;\n    }\n\n    .chart-title.blue-bg:before,\n    .chart-title.orange-bg:before,\n    .chart-title.green-bg:before,\n    .chart-title.purple-bg:before {\n      border-width: 0 26px 10px 26px;\n    }\n\n    .chart-main {\n      height: 300px;\n      font-size: 14px;\n    }\n\n    .chart-title,\n    .side-label,\n    .pointer {\n      font-size: 14px;\n    }\n\n    .connector_line {\n      width: 5px;\n    }\n\n    .hidden-xs {\n      display: none;\n    }\n\n    .visible-xs {\n      display: block;\n    }\n  }\n\n  @media only screen and (max-width: 767px) {\n    .chart-main {\n      height: 280px;\n\n      ::ng-deep .result & {\n        height: 130px;\n        margin-bottom: 30px;\n      }\n\n      .preference {\n        font-size: 12px;\n      }\n\n      .high_prefer {\n        top: 5px;\n      }\n\n      .low_prefer {\n        bottom: 5px;\n      }\n    }\n\n    // .chart-title.sm{\n    //   width: 52px;\n    //   padding-left: 10px;\n    //   padding-right: 10px;\n    //   white-space: nowrap;\n    //   text-overflow: ellipsis;\n    //   right: -25px;\n    //   text-transform: capitalize;\n    //   font-size: 14px;\n    // }\n    // .chart-title.blue-bg.sm:before,\n    // .chart-title.orange-bg.sm:before,\n    // .chart-title.green-bg.sm:before,\n    // .chart-title.purple-bg.sm:before{\n    //   border-width: 0 26px 10px 26px;\n    // }\n\n    .chart-title {\n      width: 52px;\n      padding-left: 10px;\n      padding-right: 10px;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      right: -25px;\n\n      body.mini-navbar & {\n        width: 40px !important;\n        right: -21px !important;\n      }\n    }\n\n    .chart-title.blue-bg:before,\n    .chart-title.orange-bg:before,\n    .chart-title.green-bg:before,\n    .chart-title.purple-bg:before {\n      border-width: 0 26px 10px 26px;\n\n      body.mini-navbar & {\n        border-width: 0 20px 10px 20px !important;\n      }\n    }\n\n    .preference {\n      font-size: 14px;\n    }\n\n    .pointer {\n      -webkit-transform: translateY(-50%) scale(0.8);\n      -moz-transform: translateY(-50%) scale(0.8);\n      -ms-transform: translateY(-50%) scale(0.8);\n      -o-transform: translateY(-50%) scale(0.8);\n      transform: translateY(-50%) scale(0.8);\n    }\n  }\n\n  @media only screen and (max-width: 390px) {\n    #chartarea {\n      min-width: 250px;\n    }\n\n    .chart-title {\n      width: 40px;\n    }\n\n    .chart-title.blue-bg:before,\n    .chart-title.orange-bg:before,\n    .chart-title.green-bg:before,\n    .chart-title.purple-bg:before {\n      border-width: 0 20px 10px 20px;\n    }\n  }\n\n  @media only screen and (max-height: 600px) {\n    .chart-main {\n      height: 250px;\n      font-size: 14px;\n    }\n\n    .chart-title,\n    .side-label,\n    .pointer {\n      font-size: 14px;\n    }\n\n    .chart-title.blue-bg:before,\n    .chart-title.orange-bg:before,\n    .chart-title.green-bg:before,\n    .chart-title.purple-bg:before {\n      top: -10px;\n    }\n\n    .connector_line {\n      width: 5px;\n    }\n  }\n}\n\n.print-info {\n  display: block;\n  font-size: 10px;\n  margin-top: 5px;\n  color: $body-content-color;\n  margin-bottom: 5px;\n\n  a {\n    font-size: inherit !important;\n  }\n}\n\n#print-button {\n  // padding-bottom: 20px;\n  margin-bottom: -8px;\n\n  @media #{$mobile} {\n    margin: 0;\n    width: 100%;\n\n    select,\n    .btn {\n      width: 100%;\n    }\n  }\n\n}\n\n@media only screen and (max-height: 414px) and (orientation:landscape) {\n\n  .chart-title.sm {\n    width: 42px !important;\n    right: -21px !important;\n    font-size: 12px !important;\n  }\n\n  .chart-title.blue-bg.sm:before,\n  .chart-title.orange-bg.sm:before,\n  .chart-title.green-bg.sm:before,\n  .chart-title.purple-bg.sm:before {\n    border-width: 0 21px 10px 21px !important;\n  }\n}\n\n.chart-container,\n.below-chart {\n  padding: 25px;\n  max-width: 820px;\n  width: 100%;\n}\n\n#print-button a {\n  display: block;\n  font-size: 12px;\n  line-height: 1;\n  margin-bottom: 7px;\n  text-align: right;\n}\n\n.interpretive-wrapper {\n  max-width: 820px;\n  width: 100%;\n  font-family: \"Museo-regular\";\n  margin-block-start: -60px;\n}\n\n.interpretive-wrapper .toolsguide {\n  background: $color-light-type;\n}\n\nsection#four-profile {\n  padding: 0;\n}\n\n.toolsguide {\n  padding: 40px 40px 30px;\n}\n\n#four-profile .toolsguide-heading,\n#four-profile .toolsguide-content {\n  padding: 15px 30px;\n}\n\n.toolsguide .toolsguide-heading .toolsguide-heading-text {\n  font-size: 40px;\n  font-weight: 600;\n}\n\n#four-profile .toolsguide-heading,\n#four-profile .toolsguide-content {\n  padding: 15px 30px;\n}\n\n#four-think .box {\n  margin: 15px 1%;\n  min-height: 265px;\n}\n\n.toolsguide .box.clarify {\n  border: 1px solid $clarify-color !important;\n  box-shadow: 0 0 1px 0 $clarify-color !important;\n}\n\n#four-think .box h2 {\n  border-bottom: 1px solid;\n  box-shadow: 0 1px 1px -1px;\n  padding-bottom: 5px;\n}\n\n.toolsguide .box.clarify h2,\n.toolsguide .box.clarify h4 {\n  color: $clarify-color !important;\n}\n\n.toolsguide .box h2 {\n  font-size: 30px;\n}\n\n.toolsguide .toolsguide-content ul {\n  padding: 0;\n  list-style-position: inherit;\n  list-style-type: none;\n  font-family: \"Museo-300\";\n}\n\n.toolsguide .box ul {\n  margin: 0;\n  padding: 0;\n  list-style-position: inside;\n}\n\n.toolsguide .box ul li {\n  font-family: \"Museo-300\";\n  font-size: 14px;\n  line-height: 18px;\n  margin-bottom: 5px;\n}\n\n.toolsguide .toolsguide-content ul li {\n  font-family: \"Museo-300\";\n}\n\n.toolsguide .toolsguide-content ul li:before {\n  content: '\\2022';\n  margin-right: 5px;\n}\n\n.toolsguide .box.ideate {\n  border: 1px solid $ideate-color !important;\n  box-shadow: 0 0 1px 0 $ideate-color !important;\n}\n\n.toolsguide .box.ideate h2,\n.toolsguide .box.ideate h4 {\n  color: $ideate-color !important;\n}\n\n.toolsguide .box.develop {\n  border: 1px solid $develop-color !important;\n  box-shadow: 0 0 1px 0 $develop-color !important;\n}\n\n.toolsguide .box.develop h2,\n.toolsguide .box.develop h4 {\n  color: $develop-color !important;\n}\n\n.toolsguide .box.implement {\n  border: 1px solid $implement-color !important;\n  box-shadow: 0 0 1px 0 $implement-color !important;\n}\n\n.toolsguide .box.implement h2,\n.toolsguide .box.implement h4 {\n  color: $implement-color !important;\n}\n\n.toolsguide .toolsguide-heading .toolsguide-heading-text {\n  font-size: 40px;\n  font-weight: 600;\n}\n\n#four-box .box {\n  margin: 15px 1%;\n  min-height: 600px;\n}\n\n.toolsguide .box.clarify {\n  border: 1px solid $clarify-color !important;\n  box-shadow: 0 0 1px 0 $clarify-color !important;\n}\n\n.toolsguide .box .box-top {\n  padding: 15px;\n  margin: 0 -15px;\n}\n\n.toolsguide .box.clarify .box-top {\n  background: $clarify-color !important;\n}\n\n.toolsguide .toolsguide-content h4 {\n  font-size: 16px;\n}\n\n.toolsguide .box.ideate .box-top {\n  background: $ideate-color !important;\n}\n\n.toolsguide .box.develop .box-top {\n  background: $develop-color !important;\n}\n\n.toolsguide .box h2 img {\n  margin-left: 20px;\n}\n\n.toolsguide .box.implement .box-top {\n  background: $implement-color !important;\n}\n\n.toolsguide .toolsguide-content span.num {\n  font-size: 28px;\n  line-height: 20px;\n  margin-top: 6px;\n  display: block;\n  width: 20px;\n  float: left;\n}\n\n.toolsguide .toolsguide-content .num-p p {\n  float: right;\n  width: calc(100% - 30px);\n  font-size: 14px;\n}\n\n.toolsguide .toolsguide-content h3 {\n  font-size: 20px;\n}\n\n.pref {\n  margin-top: 15px;\n}\n\n.toolsguide .toolsguide-content h4 {\n  font-size: 16px;\n}\n\n.pref span {\n  padding: 2px 4px;\n  color: $color-light-type !important;\n  font-size: 14px;\n}\n\n.pref.clarify span {\n  background: $clarify-color !important;\n}\n\n.pref.clarify ul li {\n  color: $clarify-color !important;\n}\n\n.pref.ideate span {\n  background: $ideate-color !important;\n}\n\n.pref.ideate ul li {\n  color: $ideate-color !important;\n}\n\n.pref.developer span {\n  background: $develop-color !important;\n}\n\n.pref.developer ul li {\n  color: $develop-color !important;\n}\n\n.pref.implement span {\n  background: $implement-color !important;\n}\n\n.pref.implement ul li {\n  color: $implement-color !important;\n}\n\n.toolsguide .footer-xs {\n  background-color: #e6e7e8;\n  font-size: 12px !important;\n  padding: 10px 40px;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: 0;\n}\n\n.fs-graph-logo {\n  max-width: 300px;\n  width: 100%;\n}\n\n.below-chart .left-label {\n  background-color: $color-neutral-dark !important;\n  float: left;\n  font-size: 25px !important;\n  line-height: 30px;\n  letter-spacing: 0.8px;\n  padding: 5px 11px 5px 11px !important;\n  text-transform: none;\n  font-family: 'Helvetica LT W05 Bold';\n  margin-bottom: 0 !important;\n}\n\n.below-chart .right-label {\n  float: right;\n  margin-bottom: 0 !important;\n\n  .eq-developer {\n    margin-bottom: 0 !important;\n  }\n}\n\n.right-label-text span.eq-clarifier {\n  background-color: $clarify-color !important;\n  display: none;\n}\n\n.right-label-text span .icon-plus {\n  width: 32px;\n  font-size: 14px;\n  display: inline-block;\n  text-align: center;\n  color: #929394;\n  display: inline-block;\n  font: 14px/1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  @media (max-width:992px) {\n    width: 25px;\n  }\n}\n\n.right-label-text .icon-plus:before {\n  content: \"\\f067\";\n}\n\n.right-label-text .eq-developer {\n  background-color: $develop-color !important;\n}\n\n.below-chart span {\n  color: $color-light-type !important;\n  padding: 10px;\n}\n\n.right-label-text .eq-ideator {\n  background-color: $ideate-color !important;\n}\n\n.right-label-text .eq-implementer {\n  background-color: $implement-color !important;\n}\n\n\n@media (min-width: 768px) {\n  #four-think .box {\n    width: 48%;\n  }\n\n  #four-box .box {\n    width: 48%;\n  }\n}\n\n/*================= css copied from charts.scss ================*/\n// comparison-chart-1\n.comparison-chart-1 {\n  border-left: 1px solid #c0c0c0;\n  border-bottom: 1px solid #c0c0c0;\n  height: 200px;\n  position: relative;\n  margin-top: 50px;\n\n  ul {\n    padding: 0;\n    margin: 0;\n    display: flex;\n\n    li {\n      list-style: none;\n      width: 20%;\n      margin: 0 2.5%;\n      flex: 1;\n      position: absolute;\n      bottom: 0px;\n\n      span {\n        width: 50%;\n        display: block;\n        border: 0.5px solid $color-light-type;\n        float: left;\n        position: absolute;\n        bottom: 0;\n\n        .competitor-name {\n          color: $color-light-type;\n          font-size: 11px;\n          position: absolute;\n          bottom: 0px;\n          margin: 0px;\n          left: 2px;\n        }\n\n        .competitor-score {\n          text-align: center;\n          margin-top: -20px;\n        }\n      }\n\n      span:last-child {\n        margin-left: 50%;\n        opacity: 0.7;\n      }\n    }\n\n    .clarify-comparison {\n      span {\n        background-color: $clarify-color !important;\n      }\n    }\n\n    &.remove-color .clarify-comparison {\n      span {\n        background-color: $clarify-color !important;\n      }\n\n      span:last-child {\n        background-color: $color-neutral-mid !important;\n      }\n    }\n\n    .ideate-comparison {\n      margin-left: 25%;\n\n      span {\n        background-color: $ideate-color !important;\n      }\n    }\n\n    &.remove-color .ideate-comparison {\n      span {\n        background-color: $clarify-color !important;\n      }\n\n      span:last-child {\n        background-color: $color-neutral-mid !important;\n      }\n    }\n\n    .develop-comparison {\n      margin-left: 50%;\n\n      span {\n        background-color: $develop-color !important;\n      }\n    }\n\n    &.remove-color .develop-comparison {\n      span {\n        background-color: $clarify-color !important;\n      }\n\n      span:last-child {\n        background-color: $color-neutral-mid !important;\n      }\n    }\n\n    .implement-comparison {\n      margin-left: 75%;\n\n      span {\n        background-color: $implement-color !important;\n      }\n    }\n\n    &.remove-color .implement-comparison {\n      span {\n        background-color: $clarify-color !important;\n      }\n\n      span:last-child {\n        background-color: $color-neutral-mid !important;\n      }\n    }\n  }\n}\n\n.client-detail {\n  .list-unstyled {\n    width: 100%;\n    float: left;\n    margin-bottom: 35px;\n\n    li {\n      //width: 50%;\n      //float:left;\n\n      @media screen and (max-width: 599px) {\n        width: 100%;\n      }\n\n      h2 {\n        font-size: 20px;\n        font-weight: bold;\n      }\n\n      span {\n        font-size: 18px;\n      }\n    }\n  }\n\n  .profile-headers {\n    clear: both;\n    float: left;\n    width: 100%;\n    margin: 30px 0;\n    font-size: 18px;\n    font-family: $font-museo;\n\n    @media(max-width:767px) {\n      font-size: 13px;\n    }\n\n    .profile-equation-wrapper {\n      font-family: $font-stack;\n\n      @media(max-width:950px) {\n        float: left !important;\n        clear: both;\n        margin-top: 10px;\n      }\n\n      @media(max-width:767px) {\n        float: right !important;\n        clear: none;\n      }\n\n      @media(max-width:599px) {\n        float: left !important;\n        clear: both;\n      }\n\n      span {\n        color: $color-light-type;\n        padding: 7px;\n\n        @media(max-width:950px) {\n          float: left;\n          margin-bottom: 10px;\n        }\n\n        @media(max-width:375px) {\n          display: block;\n        }\n      }\n\n      .eq-plus {\n        color: $color-neutral-dark;\n      }\n    }\n\n    .profile-equation-result {\n      background: $color-neutral-dark;\n      padding: 7px;\n      font-family: $font-stack;\n\n      a {\n        color: $color-light-type;\n        text-decoration: none;\n      }\n    }\n\n    .eq-clarifier,\n    .eq-ideator,\n    .eq-developer,\n    .eq-implementer {\n      //background-color: transparent;\n    }\n\n    .eq-clarifier {\n      //color: $clarify-color;\n    }\n\n    .eq-ideator {\n      //color:$ideate-color;\n    }\n\n    .eq-developer {\n      //color:$develop-color;\n    }\n\n    .eq-implementer {\n      //color: $implement-color;\n    }\n\n    //.right-label-text .icon-plus{\n    //  &:before{\n    //    content: \"&\";\n    //  }\n    //}\n\n  }\n\n  .client_description {\n    clear: both;\n    text-align: justify;\n    font-size: 16px;\n    margin-bottom: 30px;\n    -webkit-column-count: 2;\n    -ms-column-count: 2;\n    -moz-column-count: 2;\n    column-count: 2;\n    -webkit-column-gap: 20;\n    -ms-column-gap: 20;\n    -moz-column-gap: 20;\n    column-gap: 20;\n\n    @media screen and (max-width: 599px) {\n      -webkit-column-count: 1;\n      -ms-column-count: 1;\n      -moz-column-count: 1;\n      column-count: 1;\n      -webkit-column-gap: 0;\n      -ms-column-gap: 0;\n      -moz-column-gap: 0;\n      column-gap: 0;\n    }\n\n    span.pull-left {\n      padding-right: 10px;\n      padding-bottom: 10px;\n    }\n\n    span.profile-desc {\n      font-weight: bold;\n    }\n  }\n}\n\n.group-profile.teammates-group {\n  height: 230px;\n  border: none;\n  max-width: 90%;\n  margin: 0 auto;\n\n  .main-group-profile {\n    height: 230px;\n\n    .common-profile {\n      max-height: 50px;\n    }\n\n    .integrators-region {\n      height: 30px;\n      margin-top: -15px;\n\n      h4 {\n        line-height: 30px;\n      }\n    }\n\n    .profile-flex-bottom {\n      margin-top: 15px;\n\n      .common-low {\n        h5 {\n          margin: 0px;\n          margin-top: 5px;\n        }\n      }\n    }\n\n    .profile-flex-top {\n      .common-high {\n        .top-label-scores {\n          margin: 0;\n          margin-bottom: 5px;\n        }\n      }\n    }\n  }\n}\n\n// comparison-chart-2\n.comparison-chart-2 {\n  border-left: 1px solid #c0c0c0;\n  border-bottom: 1px solid #c0c0c0;\n  height: 200px;\n  position: relative;\n\n  .diff-score {\n    position: absolute;\n    color: #333;\n    top: -20px;\n  }\n\n  .other-User {\n    .diff-score {\n      right: -3px;\n    }\n  }\n\n  .current-User {\n    .diff-score {\n      left: -3px;\n    }\n  }\n\n  .score_calculator {\n    position: absolute;\n    top: 0;\n    left: -20px;\n    bottom: 0;\n    width: 20px;\n\n    .start,\n    .end {\n      position: absolute;\n    }\n\n    .start {\n      bottom: -5px;\n      left: 7px;\n    }\n\n    .end {\n      top: -5px;\n    }\n\n  }\n\n  ul {\n    padding: 0;\n    margin: 0 0 0 4.5%;\n    display: flex;\n    opacity: 0;\n    @include animation-fill-mode(forwards);\n    @include animation-name(chartOpacity);\n    @include animation-duration(3s);\n    @include animation-timing-function(ease);\n    @include animation-delay(2000ms);\n\n    li {\n      list-style: none;\n      width: 20%;\n      margin: 0;\n      flex: 1;\n      position: absolute;\n      bottom: 0px;\n\n      span {\n        width: 50%;\n        display: block;\n        border: 0.5px solid #000;\n        float: left;\n        position: absolute;\n        bottom: 0;\n        z-index: 1;\n        @include prefix(box-shadow, 2px 1px 5px rgba(0, 0, 0, 0.35), webkit ms moz o);\n\n        .competitor-name {\n          color: $color-light-type;\n          font-size: 11px;\n          position: absolute;\n          bottom: 0px;\n          margin: 0px;\n          left: 2px;\n        }\n\n        .competitor-score {\n          text-align: left;\n          margin-top: 2px;\n          color: $color-light-type;\n          margin-left: 3px;\n          margin-right: 3px;\n        }\n      }\n\n      span:last-child {\n        opacity: 0.7;\n        z-index: 0;\n        left: 30%;\n        @include prefix(box-shadow, none, webkit ms moz o);\n\n        .competitor-name {\n          right: 5px;\n          left: inherit;\n          text-align: right;\n        }\n\n        .competitor-score {\n          text-align: right;\n        }\n      }\n    }\n\n    .clarify-comparison {\n      span {\n        background-color: $clarify-color !important;\n      }\n    }\n\n    .ideate-comparison {\n      margin-left: 25%;\n\n      span {\n        background-color: $ideate-color !important;\n      }\n    }\n\n    .develop-comparison {\n      margin-left: 50%;\n\n      span {\n        background-color: $develop-color !important;\n      }\n    }\n\n    .implement-comparison {\n      margin-left: 75%;\n\n      span {\n        background-color: $implement-color !important;\n      }\n    }\n  }\n}\n\n// Chart 3\n$base: 0%;\n$data-1: 25%;\n$data-2: 55%;\n$data-3: 35%;\n$data-4: 50%;\n$data-5: 10%;\n$data-6: 30%;\n$data-7: 0%;\n$data-8: 40%;\n\n.grid {\n  border-left: 1px solid #000;\n  box-shadow: 0px 1px 0 rgba(0, 0, 0, 1);\n  border-top: 0;\n  border-bottom: 0;\n  width: 100%;\n  max-width: 700px;\n  height: 200px;\n  margin: 50px auto;\n  position: relative;\n\n  .score_calculator {\n    position: absolute;\n    top: 0;\n    left: -20px;\n    bottom: 0;\n    width: 20px;\n\n    .start,\n    .end {\n      position: absolute;\n    }\n\n    .start {\n      bottom: -5px;\n      left: 7px;\n    }\n\n    .end {\n      top: -5px;\n    }\n\n  }\n\n  ul {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    height: 100%;\n    position: relative;\n\n    li {\n      width: 25%;\n      position: absolute;\n      left: 0px;\n      bottom: 0;\n      top: 0px;\n\n      .commonGraph {\n        opacity: .65;\n        width: 100%;\n        height: 100%;\n        position: relative;\n        @include prefix(transition, all 400ms ease-in-out, webkit ms moz);\n\n        &:hover {\n          opacity: .8;\n        }\n      }\n\n      .graph {\n        z-index: 1;\n      }\n\n      .graph2 {\n        position: absolute;\n        left: 0;\n        bottom: 0;\n        z-index: 1;\n      }\n\n      &.clarify-comparison {\n\n        .graph,\n        .graph2 {\n          background: $clarify-color;\n        }\n\n        //.graph{\n        //  clip-path: polygon(\n        //    0% $base,\n        //    100% $data-1,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $base,\n        //    100% $data-1,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n        //\n        //.graph2{\n        //  clip-path: polygon(\n        //    0% $base,\n        //    100% $data-2,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $base,\n        //    100% $data-2,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n\n      }\n\n      &.ideate-comparison {\n        left: 25%;\n\n        .graph,\n        .graph2 {\n          background: $ideate-color;\n        }\n\n        //.graph{\n        //  clip-path: polygon(\n        //    0% $data-1,\n        //    100% $data-3,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $data-1,\n        //    100% $data-3,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n        //.graph2{\n        //  clip-path: polygon(\n        //    0% $data-2,\n        //    100% $data-4,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $data-2,\n        //    100% $data-4,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n\n      }\n\n      &.develop-comparison {\n        left: 50%;\n\n        .graph,\n        .graph2 {\n          background: $develop-color;\n        }\n\n        //.graph{\n        //  clip-path: polygon(\n        //    0% $data-3,\n        //    100% $data-5,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $data-3,\n        //    100% $data-5,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n        //.graph2{\n        //  clip-path: polygon(\n        //    0% $data-4,\n        //    100% $data-6,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $data-4,\n        //    100% $data-6,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n      }\n\n      &.implement-comparison {\n        left: 75%;\n\n        .graph,\n        .graph2 {\n          background: $implement-color;\n        }\n\n        //.graph{\n        //  clip-path: polygon(\n        //    0% $data-5,\n        //    100% $data-7,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $data-5,\n        //    100% $data-7,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n        //.graph2{\n        //  clip-path: polygon(\n        //    0% $data-6,\n        //    100% $data-8,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //  -webkit-clip-path: polygon(\n        //    0% $data-6,\n        //    100% $data-8,\n        //    // base\n        //    100% 100%,\n        //    0% 100%\n        //  );\n        //}\n      }\n    }\n  }\n}\n\n::ng-deep .profile-section {\n\n  &.chart-container {\n\n    &__pd {\n      padding: 0 !important;\n      box-shadow: none !important;\n\n      &>h2 .form-inline {\n\n        @media #{$mobile} {\n          margin-top: 20px;\n        }\n\n        input+input {\n          margin-top: 10px;\n        }\n      }\n\n      &>h2 {\n\n        display: flex;\n        flex-direction: column-reverse;\n\n        span {\n\n          @media #{$mobile-up} {\n            text-align: right;\n          }\n        }\n\n      }\n\n      .chart-section {\n        margin: 0 0 0 29px;\n        width: 96.5%;\n      }\n\n    }\n  }\n\n  .chart-section {\n    margin-top: 0;\n\n    .side-label {\n      font-size: 12px;\n      line-height: 14px;\n      color: #999999 !important;\n      position: absolute;\n      left: -35px !important;\n      text-align: right;\n      width: 20px;\n      letter-spacing: 0.01px;\n      font-family: \"Helvetica LT W05 Light\";\n    }\n\n    .high_prefer {\n      position: absolute;\n      top: 2px !important;\n      left: 9px !important;\n      width: 110px;\n      font-weight: normal;\n      font-size: 14px !important;\n      line-height: 17px !important;\n      font-family: \"Helvetica LT W05 Roman\";\n      text-align: left;\n      color: #5C5D60 !important;\n    }\n\n    .low_prefer {\n      position: absolute;\n      bottom: 20px;\n      left: 9px;\n      font-size: 14px;\n      line-height: 17px;\n      width: 110px;\n      text-align: left;\n      font-family: \"Helvetica LT W05 Roman\";\n      color: #5C5D60 !important;\n    }\n\n    .neutral .neutralBartext {\n      left: 9px !important;\n      position: absolute;\n      font-weight: normal;\n      font-size: 14px !important;\n      line-height: 17px !important;\n      font-family: \"Helvetica LT W05 Roman\";\n      color: #5C5D60 !important;\n    }\n\n    .neutral_high_value {\n      font-size: 14px !important;\n      font-weight: normal;\n      line-height: 17px !important;\n      font-family: \"Helvetica LT W05 Roman\";\n      color: #999 !important;\n      left: 9px !important;\n    }\n\n    .neutral_low_value {\n      font-size: 14px !important;\n      font-weight: normal;\n      line-height: 17px !important;\n      font-family: \"Helvetica LT W05 Roman\";\n      color: #999 !important;\n      left: 9px !important;\n    }\n\n    .chart-main {\n      .chart-title span {\n        font-size: 11px !important;\n        line-height: 14px;\n        font-family: 'Helvetica LT W05 Bold';\n      }\n\n      @media only screen and (max-width:1023px) {\n        .visible-xs {\n          display: block !important;\n        }\n\n        .hidden-xs {\n          display: none !important;\n        }\n\n        .chart-title.blue-bg:before,\n        .chart-title.orange-bg:before,\n        .chart-title.green-bg:before,\n        .chart-title.purple-bg:before {\n          border-width: 0 26px 10px 26px;\n        }\n\n        .chart-title {\n          width: 52px;\n          padding-left: 10px;\n          padding-right: 10px;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          right: -25px;\n          text-transform: capitalize;\n          font-size: 14px;\n        }\n      }\n\n      @media(min-width:768px) {\n        height: 350px;\n      }\n    }\n  }\n}\n\n::ng-deep #f-profile {\n  .chart-section {\n    .chart-main {\n      @media(max-width:1023px) {\n        .visible-xs {\n          display: block !important;\n        }\n\n        .hidden-xs {\n          display: none !important;\n        }\n\n        .chart-title.blue-bg:before,\n        .chart-title.orange-bg:before,\n        .chart-title.green-bg:before,\n        .chart-title.purple-bg:before {\n          border-width: 0 26px 10px 26px;\n        }\n\n        .chart-title {\n          width: 52px;\n          padding-left: 10px;\n          padding-right: 10px;\n          white-space: nowrap;\n          text-overflow: ellipsis;\n          right: -25px;\n          text-transform: capitalize;\n          font-size: 14px;\n        }\n      }\n\n      @media(max-width:767px) {\n        height: 235px;\n      }\n    }\n  }\n}\n\n::ng-deep .below-chart-description {\n  background-color: $color-neutral-dark !important;\n  color: $color-light-type;\n  padding: 25px 25px 0;\n  max-width: 820px;\n  width: 100%;\n\n  .height30 {\n    height: 30px;\n  }\n\n  .custom-footer {\n    margin-left: -25px;\n    margin-right: -25px;\n    background: $color-light-type;\n    color: $body-content-color;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    vertical-align: middle;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n    padding: 15px 0px;\n\n    @media(max-width:767px) {\n      display: block;\n      float: left;\n\n      .col-xs-12 {\n        text-align: center !important;\n        margin-bottom: 10px;\n      }\n    }\n\n    p {\n      margin: 0;\n      font-size: 12px !important;\n      color: #5C5D60 !important;\n    }\n\n    a {\n      font-size: 12px !important;\n    }\n\n  }\n}\n\n.quick-gd {\n  width: 100%;\n  max-width: 820px;\n  position: relative;\n  margin-block-start: -15px;\n\n  .quick-gd__arrow {\n    border-left: 70px solid transparent;\n    border-right: 70px solid transparent;\n    border-top: 60px solid #7bbc43;\n    max-width: 100px;\n    position: relative;\n    width: 100%;\n    min-height: 100px;\n    margin: 21px auto;\n    cursor: pointer;\n\n    span {\n      position: absolute;\n      top: -60px;\n      left: -20px;\n      z-index: 9;\n      max-width: 50px;\n      font-size: 14px;\n      font-weight: bold;\n      color: #fff;\n    }\n  }\n}\n\n#build-term {\n  .toolsguide-heading {\n    min-height: 90px;\n  }\n\n  .lg-text {\n    font-size: 18px;\n    margin-bottom: 15px;\n  }\n\n  .side-bar {\n    background: #e6e7e9 !important;\n    padding: 20px;\n  }\n}\n\n#four-box .box {\n  @media(min-width:768px) {\n    width: 48%;\n  }\n\n  margin:15px 1%;\n  min-height:600px;\n\n  .col-xs-6 {\n    &:first-child {\n      padding-right: 7.5px;\n    }\n\n    &:last-child {\n      padding-left: 7.5px;\n    }\n  }\n}\n\n\n.right-button {\n  &.text-right {\n    width: 100%;\n    text-align: center;\n    margin: 3px 0 8px 0;\n\n    a.btn {\n      /*width: 230px;*/\n      display: block;\n    }\n  }\n\n  &.disable-btn {\n    a {\n      cursor: not-allowed;\n    }\n  }\n\n}\n\n.d-block {\n  display: block;\n}\n\n.no-bottom-pad {\n  // padding-bottom: 0px;\n\n  h5 {\n    font-size: 17px;\n  }\n\n  .close {\n    margin-top: -24px;\n  }\n}\n\n.modal-dialog {\n  width: 470px;\n}\n\n@media print {\n\n  /*#chartarea {\n      width: 580px;\n    }*/\n  .chart-title {\n    color: $color-light-type$color-light-type !important;\n\n    .visible-xs,\n    .hidden-xs {\n      color: $color-light-type$color-light-type !important;\n    }\n  }\n\n  /* Guide Report print style*/\n\n  body {\n    color: $body-content-color !important;\n  }\n\n  .below-chart,\n  .below-chart-description {\n    margin-left: 20px;\n\n  }\n\n  .below-chart-description {\n\n    p,\n    big,\n    a,\n    span,\n    sup {\n      color: $color-light-type !important;\n    }\n  }\n\n  .chart-container {\n    padding-top: 0px;\n    margin-bottom: 20px;\n  }\n\n  .short-guide,\n  .long-guide {\n    .innovation-section {\n      margin: 0px auto;\n      padding: 15px 15px 50px;\n      min-height: 960px;\n    }\n\n    #four-profile {\n      padding-top: 0;\n\n      .toolsguide-heading {\n        padding: 0px;\n      }\n\n      .toolsguide-content {\n        padding: 0;\n      }\n    }\n\n    #four-box .box {\n      min-height: 430px;\n      margin: 0px 1% 15px;\n\n      .box-top {\n        img {\n          width: 55px;\n        }\n      }\n\n      h2 {\n        margin: 5px 0;\n      }\n\n      .col-xs-6:first-child {\n        padding: 0px 7.5px;\n      }\n\n      ul li {\n        line-height: 16px;\n      }\n    }\n\n    #four-think .box {\n      min-height: 225px;\n      margin: 2px;\n    }\n\n    #dots-img {\n      background: url($assets+\"/images/dotk.jpg\") !important;\n      background-size: cover !important;\n      min-height: 900px;\n    }\n\n    .toolsguide .box .box-top {\n      padding: 0px 15px;\n    }\n\n    #four-think .box h2 {\n      margin: 5px 0;\n    }\n\n    .toolsguide {\n      page-break-after: always;\n\n      &:last-child {\n        page-break-after: auto;\n      }\n\n      .toolsguide-content aside {\n        padding: 0px;\n      }\n\n      .footer-lg {\n        background-color: $color-neutral-dark !important;\n\n        .text,\n        a {\n          color: $color-light-type !important;\n        }\n\n        a[href]:after {\n          color: $color-light-type !important;\n        }\n      }\n\n      .pref.clarify span {\n        background: #00aed9 !important;\n        ;\n      }\n\n      .pref.ideate span {\n        background: #f68c1f !important;\n      }\n\n      .pref.developer span {\n        background: #66bd4a !important;\n      }\n\n      .pref.implement span {\n        background: #ef465b !important;\n      }\n\n      .pref.clarify ul li {\n        color: #00aed9 !important;\n      }\n\n      .pref.developer ul li {\n        color: #66bd4a !important;\n      }\n\n      .pref.ideate ul li {\n        color: #f68c1f !important;\n      }\n\n      .pref.implement ul li {\n        color: #ef465b !important;\n      }\n\n      .toolsguide-heading-text {\n        margin: 0px;\n      }\n\n      .footer-xs {\n        background-color: #e6e7e8 !important;\n      }\n\n      .box.clarify {\n\n        h2,\n        h4 {\n          color: #00aed9 !important;\n        }\n\n        .box-top {\n          background-color: #00aed9 !important;\n        }\n      }\n\n      .box.ideate {\n\n        h2,\n        h4 {\n          color: #f68c1f !important;\n        }\n\n        .box-top {\n          background-color: #f68c1f !important;\n        }\n      }\n\n      .box.develop {\n\n        h2,\n        h4 {\n          color: #66bd4a !important;\n        }\n\n        .box-top {\n          background-color: #66bd4a !important;\n        }\n      }\n\n      .box.implement {\n\n        h2,\n        h4 {\n          color: #ef465b !important;\n        }\n\n        .box-top {\n          background-color: #ef465b !important;\n        }\n      }\n\n      .box ul li {\n        margin-bottom: 0px;\n      }\n    }\n  }\n}\n\n.profile-section h2 {\n  color: #5C5D60;\n  font-size: 32px;\n  margin: 0 0 0;\n  letter-spacing: -0.1px;\n  font-family: 'Helvetica LT W05 Bold';\n}\n\n.profile-section p {\n  font-size: 12px !important;\n  color: #5C5D60 !important;\n  margin-bottom: 0;\n}\n\n.form-inline .fa,\n.pencil .fa {\n  font-size: 18px;\n}\n\n.grey {\n  background: rgba(236, 236, 236, 0.9);\n}\n\n.download_language {\n  margin-top: 20px;\n  font-size: 13px;\n}\n\n.long_guides {\n  margin-top: 20px;\n}\n\n.package-form {\n  display: inline-block;\n  width: 100%;\n\n  &--pd {\n\n    .modal-body {\n\n      select {\n        padding: 5px !important;\n      }\n    }\n  }\n\n  label,\n  select {\n    width: 55%;\n  }\n\n  label {\n    line-height: 2em;\n    padding: .75rem .75rem .75rem 0 !important;\n  }\n\n  select {\n    border: 1px solid #ddd;\n    padding: 10px !important;\n    height: 40px;\n    background: #F8F8F8;\n    color: #636363;\n    font-family: 'Museo-300';\n    margin-bottom: 10px;\n  }\n\n  select:focus {\n    outline: none;\n  }\n\n  .modal-body .warning {\n    padding-top: 10px;\n  }\n}\n\n.package-form .btn {\n  margin-top: 10px\n}\n\n.profile-description {\n  color: #5C5D60 !important;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.4px;\n  font-family: 'Helvetica LT W05 Roman';\n  margin-top: 13px;\n}\n\n.below-chart {\n  background: #f1f1f1;\n  margin-bottom: 0;\n\n  h3 {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    grid-gap: 10px 13px;\n\n    .left-label {\n      float: none;\n      // margin-right: 13px !important;\n      // margin-bottom: 10px !important;\n    }\n\n    .prefers_to {\n      font-family: 'Helvetica LT W05 Roman';\n      color: #5C5D60 !important;\n      font-size: 14px !important;\n      line-height: 17px !important;\n      text-transform: none;\n      letter-spacing: -0.04px;\n      font-weight: normal;\n      display: inline;\n      margin-bottom: 0 !important;\n    }\n\n    #equation {\n      display: inline-block;\n      // padding-left: 13px;\n\n      span {        \n        margin-bottom: 0 !important\n      }\n\n      &>span {\n        padding: 0;\n        display: inline-block !important;\n        font-size: 12px !important;\n        font-weight: 400 !important;\n        line-height: 14px !important;\n        text-transform: uppercase !important;\n        font-family: 'Helvetica LT W05 Bold' !important;\n        letter-spacing: 0.07px !important;;\n      }\n    }\n  }\n}\n\n.footer-logo {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  width: 100%;\n  margin-bottom: 10px;\n\n  .copyright {\n    width: 50%;\n\n    p {\n      font-size: 11px !important;\n      letter-spacing: 0.39px !important;\n    }\n  }\n\n  .fs-logo {\n    width: 50%;\n    text-align: right;\n  }\n}\n\n.below-chart-description {\n  margin-bottom: 0;\n\n  p {\n    margin: 0;\n    font-family: 'Helvetica LT W05 Light';\n    font-size: 12px;\n    line-height: 17px;\n    display: block;\n    color: #f1f1f1;\n\n    span {\n      font-size: 14px;\n      font-family: 'Helvetica LT W05 Bold';\n    }\n  }\n\n  .fs-graph-logo {\n    max-width: 181px;\n  }\n}\n\n.fixed-loader {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n\n  &.profile-loader {\n    max-width: 820px;\n    width: 100%;\n  }\n\n  i {\n    font-size: 8em !important;\n  }\n\n}\n\n.pf-rdbtn {\n  padding-bottom: 25px;\n\n  &--pfpdf {\n    padding-bottom: 10px;\n  }\n\n  label {\n    padding: 0;\n    width: 65%;\n    padding-left: 10px;\n    font-weight: 500;\n    cursor: pointer;\n  }\n}\n\n.modal-body {\n  padding-block-end: 0px;\n\n  .disable-btn {\n    pointer-events: none;\n  }\n\n  .text-left {\n\n    &.text {\n      padding-left: 0;\n    }\n  }\n\n  .text--fw {\n    width: 100%;\n    font-weight: bold;\n    padding: 0;\n  }\n\n  .assessment-select {\n\n    select {\n      height: 30px;\n      padding: 3px;\n      width: 45%;\n      background-color: #fff;\n      margin: 0 10px 7px;\n    }\n  }\n}\n\n.modal-body__buttons {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  border-top: 1px solid #ddd;\n  width: calc(100% + 32px);\n  margin: 0 -16px;\n  padding: 5px 10px;\n  background-color: #f6f6f6;\n\n  .btn {\n    margin-top: 0;\n\n    &-prim {\n      margin-inline-start: 10px;\n\n    }\n\n    &-disable {\n      cursor: not-allowed;\n      pointer-events: none;\n    }\n  }\n}\n\n.clr {\n  color: #5C5D60;\n  font-size: 16px;\n  font-family: \"Open Sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 400;\n\n  @media #{$mobile} {\n    padding-bottom: 0;\n  }\n\n  select {\n    padding: 2px 5px 2px 3px;\n    outline-color: #5c5d60;\n    width: 171px;\n    height: 29px;\n    color: #5c5d60;\n    font-family: $font-stack;\n\n    @media #{$mobile} {\n      width: 100%;\n    }\n  }\n}\n\n.chart-container {\n\n  .chart-pfd {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    line-height: 20px;\n    align-items: center;\n\n    @media #{$mobile} {\n      flex-wrap: wrap;\n    }\n\n    .chart-left {\n      position: relative;\n\n      &__title {\n        position: absolute;\n        top: -55px;\n\n        @media #{$mobile} {\n          position: static;\n        }\n\n        strong {\n          padding-bottom: 8px;\n          color: #5C5D60;\n          font-size: 32px;\n          line-height: 38px;\n          margin: 0 0 0;\n          letter-spacing: -0.1px;\n          font-family: \"Helvetica LT W05 Bold\";\n        }\n\n        .pencil {\n          margin-left: 8px;\n        }\n\n      }\n    }\n\n    .chart-right {\n      width: 100%;\n      text-align: right;\n      padding-bottom: 6px;\n\n      @media #{$mobile} {\n        text-align: left;\n      }\n\n      .foursight-content {\n        font-size: 16px;\n        line-height: 19px;\n        text-align: right;\n        margin-bottom: 0px;\n        margin-top: 11px;\n        letter-spacing: 0;\n        padding-bottom: 0;\n\n        @media #{$mobile} {\n          text-align: left;\n        }\n      }\n    }\n  }\n}\n\n.chartist-wrap {\n\n  &__pd {\n    margin: 0;\n  }\n}\n\n.section-wrapper {\n  padding: 20px 10px 40px;\n}\n\n.guide-modal {\n  display: none;\n}\n\n/*--- 05-07-23 ---*/\n\n.fs-profile {\n\n  .page-content {\n\n    .chart-container {\n\n      .chart-left {\n\n        &__title {\n\n          h2 {\n\n            @media #{$pc} {\n              font-size: 30px;\n            }\n\n            @media (min-width: 768px) and (max-width: 991px) {\n              font-size: 28px;\n            }\n\n            @media (max-width: 640px) {\n              font-size: 26px;\n            }\n          }\n        }\n      }\n\n      ::ng-deep &__pd {\n\n        .chart-section {\n\n          @media (min-width: 641px) and (max-width: 991px) {\n            margin: 0 0 0 19px;\n          }\n\n          @media (max-width: 640px) {\n            margin: 0 0 0 19px;\n            width: 95%;\n          }\n        }\n      }\n    }\n\n    .below-chart {\n\n      h3 {\n\n        .left-label {\n\n          @media (min-width: 768px) and (max-width: 991px) {\n            font-size: 22px;\n          }\n\n          @media (max-width: 640px) {\n            font-size: 18px !important;\n            padding: 4px 8px !important;\n            width: 100%;\n            margin-right: 0 !important;\n          }\n\n        }\n      }\n\n      @media (max-width: 640px) {\n        padding: 18px;\n      }\n    }\n\n    .quick-gd {\n\n      & .quick-gd {\n\n        &__arrow {\n\n          @media #{$pc} {\n            min-height: 75px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.f-btn {\n  \n  &--nobdr  {\n    border: 0; \n  }\n}","@import './../../../assets/styles/variables';\n\n::ng-deep .owner-details {\n  .ibox-content {\n    .source-wrapper {\n      .image {\n        display: inline-block;\n      }\n    }\n  }\n}\n\n::ng-deep .dark-left-section {\n  small.fs-in {\n    display: block;\n  }\n}\n\n::ng-deep .pace-running:not(.pace-done) {\n  .widget-head-color-box h2 {\n    background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n    background-size: 600px;\n    animation: shine-avatar 1.6s infinite linear;\n    height: 26px;\n    font-size: 0;\n  }\n\n  .owner-details {\n    .ibox-content {\n      .source-wrapper {\n        .image {\n          background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n          background-size: 600px;\n          animation: shine-avatar2 1.6s infinite linear;\n          height: 100px;\n\n          img {\n            opacity: 0;\n          }\n        }\n      }\n\n      ul.list-unstyled {\n        li {\n          background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);\n          background-size: 600px;\n          animation: shine-avatar1 1.6s infinite linear;\n          margin: 0 0 1px 0;\n          height: 19px;\n          font-size: 0;\n        }\n      }\n    }\n  }\n}\n\n@keyframes shine-avatar {\n  0% {\n    background-position: -32px;\n  }\n\n  40%,\n  100% {\n    background-position: 300px;\n  }\n\n  100% {\n    background-position: 500px;\n  }\n}\n\n@keyframes shine-avatar1 {\n  0% {\n    background-position: -32px;\n  }\n\n  40%,\n  100% {\n    background-position: 300px;\n  }\n\n  100% {\n    background-position: 500px;\n  }\n}\n\n@keyframes shine-avatar2 {\n  0% {\n    background-position: -32px;\n  }\n\n  40%,\n  100% {\n    background-position: 300px;\n  }\n\n  100% {\n    background-position: 500px;\n  }\n}\n\n@keyframes shine-avatar3 {\n  0% {\n    background-position: -32px;\n  }\n\n  40%,\n  100% {\n    background-position: 300px;\n  }\n\n  100% {\n    background-position: 500px;\n  }\n}\n\n::ng-deep .introjs-tooltip {\n  box-sizing: content-box;\n  visibility: visible;\n  min-width: 200px;\n  max-width: 300px;\n  transition: opacity .1s ease-out;\n\n  width: 243px;\n  height: auto;\n  background: $color-light-type;\n  border-radius: 100px;\n  -webkit-border-radius: 100px;\n  -moz-border-radius: 100px;\n  position: relative;\n  margin: 90px auto 20px;\n  padding: 20px !important;\n  box-shadow: 0 0px !important;\n\n  .introjs-arrow.top {\n    background: url($assets+'/images/cloud-arrow-icon.png');\n    width: 10px !important;\n    height: 10px !important;\n    display: block !important;\n    padding: 32px;\n    display: block !important;\n    background-size: 100% !important;\n    top: -80px;\n    background-color: transparent;\n    border: none;\n  }\n\n  .introjs-arrow.left {\n    background: url($assets+'/images/cloud-arrow-icon.png');\n    width: 10px !important;\n    height: 10px !important;\n    display: block !important;\n    padding: 32px;\n    display: block !important;\n    background-size: 100% !important;\n    top: 90px;\n    background-color: transparent;\n    border: none;\n    transform: rotate(-70deg);\n    left: -50px;\n  }\n\n  &:after,\n  &:before {\n    content: '';\n    position: absolute;\n    background: $color-light-type;\n    z-index: -1;\n  }\n\n  &:before {\n    width: 135px;\n    height: 135px;\n    top: -67px;\n    right: 37px;\n    border-radius: 200px;\n    -webkit-border-radius: 200px;\n    -moz-border-radius: 200px;\n  }\n\n  &:after {\n    width: 75px;\n    height: 75px;\n    top: -37px;\n    left: 37px;\n    border-radius: 100px;\n    -webkit-border-radius: 100px;\n    -moz-border-radius: 100px;\n  }\n\n  .introjs-tooltiptext {\n    text-align: center;\n    padding: 0 15px;\n  }\n\n  .introjs-tooltipbuttons {\n    text-align: center;\n    white-space: nowrap;\n    margin-top: 10px;\n\n    a.introjs-button {\n      padding: 9px 14px;\n      border: none;\n      border-radius: 4px;\n      background: $develop-color;\n      color: $color-light-type;\n      text-shadow: 0 0;\n      margin: 0 0 0 5px;\n\n      &.introjs-disabled {\n        opacity: .8;\n        cursor: not-allowed;\n      }\n    }\n  }\n}\n\n.dashboard-column .source-owner .btn-primary {\n  max-width: 170px;\n  width: 100%;\n  word-wrap: break-word;\n  white-space: normal;\n}\n\n.m-b-md.dash-user-image {\n  width: 70px;\n  height: 70px;\n  border-width: 0px;\n  object-fit: cover;\n}\n\n@media #{$tablet} {\n  .ibox-title h5 {\n    float: none;\n  }\n}\n\n@media screen and (max-width: 575px) {\n  .ibox-title {\n    text-align: center;\n  }\n}\n\n.video-container {\n  position: relative;\n  padding-bottom: 56.25%;\n  // padding-top: 30px;\n  height: 0;\n  overflow: hidden;\n}\n\n.video-container iframe,\n.video-container object,\n.video-container embed {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.top-modal {\n  display: inline-block;\n}\n\n.min-box {\n  // min-height: 200px;\n  height: auto !important;\n\n  .places {\n    padding: 5px 20px 5px 20px !important;\n  }\n}\n\n.d-flex-cst {\n  display: flex;\n  display: -ms-flexbox;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.d-flex-cst .ibox {\n  height: 100%;\n}\n\n.h-100 {\n  height: 100%;\n}\n\n@media screen and (max-width: 1199px) {\n  .d-flex-cst .col-lg-6 {\n    width: 100%;\n  }\n}\n\n::ng-deep.grey {\n  background: rgba(236, 236, 236, 0.9);\n}\n\n.branding-details {\n  text-align: left;\n  max-width: 100;\n}\n\nli.branding-profile {\n  padding-bottom: 5px;\n  padding-top: 3px;\n}\n\n.email-verification {\n  text-align: center;\n}\n\n.grid-2-cols {\n  display: grid;\n  grid-template-columns: auto auto;\n}\n\n.image-youtube {\n  height: 500px;\n  object-fit: contain;\n}\n\n.asssessment_img {\n  width: 263px;\n  height: 341px;\n  margin: 0 auto;\n  padding: 10px;\n}\n\n.dashboard-header {\n  padding: 32px 20px 30px;\n\n  h2 {\n    margin-top: 0;\n    font-size: 24px;\n  }\n}\n\n.api-err {\n  h1 {\n    font-family: $muso-700;\n  }\n}\n\n.profile-error {\n\n  h5,\n  p {\n    font-family: $font-stack;\n    font-size: 14px;\n  }\n}\n\n.maintain-msg {\n  background-color: #f5b5b5;\n  padding: 20px;\n  border-radius: 4px;\n  color: #c80909;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
